webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROOT_URL; });
/* harmony export (immutable) */ __webpack_exports__["d"] = request;
/* harmony export (immutable) */ __webpack_exports__["f"] = setOAuthToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetch;
/* harmony export (immutable) */ __webpack_exports__["e"] = applyRelations;
/* unused harmony export fetchLink */
/* unused harmony export postProcess */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OAuth__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Global__ = __webpack_require__(110);








var oauth = null;

// axios.defaults.withCredentials = true
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers = {
  'X-Requested-With': 'XMLHttpRequest'
};

var ROOT_URL = "/api";

function isInvalidOAuthToken(err) {
  return err.response && err.response.data && err.response.data.error === 'invalid_token';
}

function request(options) {
  return __WEBPACK_IMPORTED_MODULE_4_axios___default.a.request(options).catch(function (err) {
    if (isInvalidOAuthToken(err)) {
      return __WEBPACK_IMPORTED_MODULE_5__OAuth__["a" /* default */].refreshToken(oauth.refresh_token).then(function (token) {
        setOAuthToken(token);
        return request(options);
      }).catch(function () {
        setOAuthToken(null);
        __WEBPACK_IMPORTED_MODULE_6__utils_Global__["a" /* EventBus */].$emit('auth-failed');
      });
    } else {
      // Nothing to see here, pass it on
      throw err;
    }
  });
}

/**
 * Because the backend returns FULL URL, instead of relative url, we need to override it.
 *
 * @param {string} url
 * @returns {string} url relative to our root url
 */
function fixProxyUrl(url) {
  if (url.indexOf('http://') < 0 && url.indexOf('https://') < 0 && url.charAt(0) !== '/') {
    return ROOT_URL + '/' + url;
  } else {
    var match = /\/api\/(.*)/.exec(url);
    if (match && match.length) {
      return ROOT_URL + '/' + match[1];
    }
    return url;
  }
}

function setOAuthToken(token) {
  oauth = token;
  __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers = token ? {
    'Authorization': token.token_type + ' ' + token.access_token
  } : null;
}

function fixLinkUrl(url) {
  return url.replace(/\{[^}]*\}/g, '');
}

function fetch(url, name, options) {
  url = fixLinkUrl(url);
  options = options || {};

  options.fetchLinks = options.fetchLinks;
  if (options.fetchLinks === undefined) {
    options.fetchLinks = !!options.include;
  }

  url = fixProxyUrl(url);

  var params = {};
  if (options.filters) {
    for (var i in options.filters) {
      params[i] = options.filters[i];
    }
  }

  if (options.sort) {
    params.sort = options.sort;
  }

  if (options.projection) {
    params.projection = options.projection;
  }

  params.size = 999999;

  if (options.size !== undefined) {
    params.size = options.size;
  }

  if (typeof options.size !== 'number') {
    delete params.size;
  }

  if (options.page) {
    params.page = options.page;
  }

  return request({
    method: 'GET',
    url: url,
    params: params
  }).then(function (result) {
    if (result.data._embedded === undefined || result.data.enabled !== undefined) {
      var item = result.data;
      if (!item._links) {
        item._links = {
          self: {
            href: url
          }
        };
      }

      postProcess(item);

      if (options.fetchLinks) {
        return fetchLinks(item, name, options).then(function () {
          return item;
        });
      } else {
        return item;
      }
    }

    var info = {
      items: result.data._embedded[__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(result.data._embedded).pop()],
      _page: result.data.page || {}
    };

    options.include = options.include || null;

    info.items.forEach(function (item) {
      postProcess(item);
    });

    if (options.fetchLinks) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(info.items.map(function (item) {
        return fetchLinks(item, name, options);
      })).then(function () {
        return info;
      });
    } else {
      return info;
    }
  });
}

function fetchLinks(item, name, options) {
  if (!item._sources) {
    item._sources = {};
  }

  var links = options.include || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(item._links).filter(function (item) {
    return item !== 'self' && item !== name && item !== name.substr(0, name.length - 1);
  });
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(links.map(function (field) {
    var subInclude = void 0;

    // Alternative format allowing us to fetch sublinks
    if (typeof field !== 'string') {
      subInclude = field.slice(1);
      field = field[0];
    }

    return fetch(item._links[field].href, field, { size: null, include: subInclude }).then(function (result) {
      if (result._page !== undefined) {
        item[field] = result.items;
      } else {
        item[field] = result;
      }
      item._sources[field] = item._links[field].href;
    }).catch(function (err) {
      if (err && err.response && err.response.status !== 404) {
        console.error(err);
        console.log('Failed to fetch', field);
      }

      item[field] = null;
      item._sources[field] = item._links[field].href;
    });
  }));
}

/**
 * Returns relations contained in model data in format of:
 *  relation_url = relation_item_url[]
 *
 * @param {Object} data model data
 * @return {{[key: string]: string}} relations
 */
function splitRelations(data, options) {
  var relations = {};
  options = options || {};

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).forEach(function (key) {
    var value = data[key];
    var source = data && data._sources && data._sources[key] || data._self + '/' + key;

    if (Array.isArray(value)) {
      value.forEach(function (item) {
        if (item._self !== undefined) {
          if (!source) {
            console.warn('[API]', 'Saving of relation', key, 'is not possible because relation source is missing.');
          } else {
            if (!relations[source]) relations[source] = [];
            relations[source].push(item._self);
          }
        }
      });
    } else if (value && value._self !== undefined) {
      if (!source) {
        console.warn('[API]', 'Saving of relation', key, 'is not possible because relation source is missing.');
      } else {
        relations[source] = [value._self];
      }
    }
  });

  return relations;
}

/**
 * Applies relations contained in model data.
 * @param {Object} data model data
 */
function applyRelations(data, options) {
  options = options || {};
  var relations = splitRelations(data, options);
  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(relations).map(function (key) {
    var value = relations[key].filter(function (item) {
      return !!item;
    });
    if (value.length > 0) {
      return request({
        method: 'PUT',
        url: key,
        data: value.join('\r\n'),
        headers: {
          'Content-Type': 'text/uri-list'
        }
      });
    } else {
      return request({
        method: 'DELETE',
        url: key
      });
    }
  }));
}

function getDataOnly(data) {
  var updated = {};
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).forEach(function (field) {
    if (field.substring(0, 1) !== '_' && (!data._sources || data._sources[field] === undefined) && !Array.isArray(data[field]) && !__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data[field]) !== 'function' && data[field] !== undefined && data[field] !== null && (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(data[field]) !== 'object' || data[field]._self === undefined)) {
      updated[field] = data[field];
    }
  });
  return updated;
}

function fetchLink(item, link, options) {
  return fetch(item._links[link].href, link, options);
}

function postProcess(item) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(item._links).forEach(function (key) {
    var link = item._links[key];
    link.href = fixProxyUrl(link.href).replace('{?projection}', '');
  });

  item._self = item._links.self.href;
  item._sources = {};
  item.id = item._self.split('/').filter(function (item) {
    return item.length > 0;
  }).pop();
  item.fetch = function (link, options) {
    return fetchLink(item, link, options);
  };

  return item;
}

/* harmony default export */ __webpack_exports__["a"] = (function (options) {
  var name = options.name;
  var enums = options.enums || {};
  var methods = options.methods || {};

  var model = {
    name: name,
    enums: enums,

    getList: function getList(options) {
      return fetch(name, name, options);
    },
    create: function create(data) {
      // Copy data, and skip _links and _self
      var updated = getDataOnly(data);

      return request({
        method: 'POST',
        url: ROOT_URL + '/' + name,
        data: updated
      }).then(function (response) {
        data._links = response.data._links;
        postProcess(data);
        return applyRelations(data, options);
      }).then(function () {
        return data;
      });
    },
    update: function update(data, fields) {
      data = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(data).filter(function (field) {
        return !fields || field.charAt(0) === '_' || fields.indexOf(field) >= 0;
      }).reduce(function (result, field) {
        result[field] = data[field];
        return result;
      }, {});

      return applyRelations(data, options).then(function () {
        // Copy data, and skip _links and _self
        var updated = getDataOnly(data);

        return request({
          method: 'PATCH',
          url: data._links.self.href,
          data: updated
        }).then(function (result) {
          return postProcess(result.data);
        });
      });
    },
    updateRelation: function updateRelation(data, field) {
      var updated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        _links: data._links,
        _self: data._self,
        _sources: data._sources
      }, field, data[field]);
      return applyRelations(updated, {});
    },
    delete: function _delete(data) {
      var updated = getDataOnly(data);
      updated.deleted = true;
      return request({
        method: 'PUT',
        url: data._links.self.href,
        data: updated
      });
    },


    fetch: fetch,
    applyRelations: applyRelations,
    postProcess: postProcess,
    fetchLink: fetchLink,
    ROOT_URL: ROOT_URL
  };

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(methods).forEach(function (key) {
    model[key] = methods[key].bind(model);
  });

  return model;
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(39);




var model = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["a" /* default */])({
  name: 'users',
  enums: {
    role: {
      SUPER_ADMIN: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('userRole.superAdmin'),
      GROUP_ADMIN: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('userRole.groupAdmin'),
      COMPANY_ADMIN: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('userRole.companyAdmin'),
      COMPANY_USER: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('userRole.companyUser')
    }
  },
  methods: {
    getSelf: function getSelf(username) {
      var _this = this;

      if (!username) {
        throw new Error('Username is empty');
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["c" /* fetch */])('users?username=[EQ]' + username, 'users', {
        include: [['company', 'companyGroup', 'configuration'], ['companyGroups', 'companies'], 'userCertificates']
      }).then(function (result) {
        if (result.items.length === 0) {
          _this.error = _this.$t('login.unknownError');
          _this.isBusy = false;
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Failed to load user details. Empty response.');
        }

        return result.items[0];
      });
    },
    setPassword: function setPassword(data) {
      var url = data._self || __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/users';
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])({
        method: 'PUT',
        url: url + '/changepwd',
        data: {
          password: data.password
        }
      }).then(function (result) {
        return result.data;
      });
    },
    resetPassword: function resetPassword(token, password) {
      var url = __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/users/resetpwd';
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])({
        method: 'PUT',
        url: url,
        data: {
          password: password,
          token: token
        }
      });
    },
    requestReset: function requestReset(username) {
      username = encodeURIComponent(username);
      var url = __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/users/requestresetpwd/' + username;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])({
        method: 'GET',
        url: url
      });
    },
    sendInfo: function sendInfo(data) {
      var url = __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/users/notifyNewUser/' + data.username;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])({
        method: 'POST',
        url: url,
        data: {
          password: data.password || null
        }
      });
    },
    logout: function logout() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])({
        method: 'GET',
        url: __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/users/logout'
      });
    },
    getPasswordComplexity: function getPasswordComplexity(token) {
      var url = __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/users/passwordComplexity';
      var options = {
        url: url
      };
      if (token) {
        options.method = 'POST';
        options.data = {
          token: token
        };
      } else {
        options.method = 'GET';
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])(options).then(function (response) {
        return response.data;
      });
    },
    getDelegation: function getDelegation(user, options) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["c" /* fetch */])(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/users/' + user.id + '/companyDelegation', 'companyDelegation', options);
    }
  }
});

/* harmony default export */ __webpack_exports__["default"] = (model);

/***/ }),
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(859)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(490),
  /* template */
  __webpack_require__(1060),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cs__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_i18n__ = __webpack_require__(430);




var i18n = new __WEBPACK_IMPORTED_MODULE_2_vue_i18n__["a" /* default */]({
  locale: 'cs',
  fallbackLocale: 'en',
  messages: {
    en: __WEBPACK_IMPORTED_MODULE_0__en__["a" /* default */],
    cs: __WEBPACK_IMPORTED_MODULE_1__cs__["a" /* default */]
  }
});

/* harmony default export */ __webpack_exports__["default"] = (i18n);

if (false) {
  module.hot.accept(['./en', './cs'], function () {
    i18n.setLocaleMessage('en', require('./en').default);
    i18n.setLocaleMessage('cs', require('./cs').default);
  });
}

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Configuration__ = __webpack_require__(105);




/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'companies',
  methods: {
    saveConfiguration: function saveConfiguration(company, configuration) {
      configuration.company = company;
      if (!configuration._self) {
        return __WEBPACK_IMPORTED_MODULE_2__models_Configuration__["a" /* default */].create(configuration);
      } else {
        return __WEBPACK_IMPORTED_MODULE_2__models_Configuration__["a" /* default */].update(configuration);
      }
    }
  },
  enums: {
    passwordComplexity: {
      '2': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('passwordComplexity.low'),
      '3': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('passwordComplexity.medium'),
      '4': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('passwordComplexity.high')
    }
  }
}));

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'targets'
}));

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'userCertificates'
}));

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(864)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(489),
  /* template */
  __webpack_require__(1065),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({ name: 'companyGroups' }));

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(39);




var Configuration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["a" /* default */])({
  name: 'configurations',
  methods: {
    getCurrent: function getCurrent(user) {
      if (user.company && user.company._links.configuration) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["c" /* fetch */])(user.company._links.configuration.href, 'configuration', {
          include: [['certificates', 'user']]
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(null);
    },
    setKey: function setKey(configuration, key) {
      var url = configuration._self;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])({
        method: 'PUT',
        url: url + '/changeenckey',
        data: {
          encryptionKey: key
        }
      }).then(function (result) {
        return result.data;
      });
    },
    setPassword: function setPassword(configuration, password) {
      var url = configuration._self;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["d" /* request */])({
        method: 'PUT',
        url: url + '/changepwd',
        data: {
          password: password
        }
      }).then(function (result) {
        return result.data;
      });
    }
  },
  enums: {
    encrypt: {
      NONE: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('configuration.basic.encryption.none'),
      // PASSWORD: Locale.t('configuration.basic.encryption.password'),
      KEY: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('configuration.basic.encryption.key')
    },
    compression: {
      PCM: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('configuration.basic.compressions.pcm'),
      FLAC: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('configuration.basic.compressions.flac'),
      MP3: __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t('configuration.basic.compressions.mp3')
    }
  }
});
/* harmony default export */ __webpack_exports__["a"] = (Configuration);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["d" /* request */])({
      method: 'GET',
      url: __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["b" /* ROOT_URL */] + '/filesystem/status'
    }).then(function (result) {
      return result.data.fileSystems;
    });
  },


  /**
   * @param {number} id recording id
   * @param {'download'|'play'} operation
   * @param {(loaded: number, total: number) => void} progressCallback
   * @returns {Promise<ArrayBuffer>}
   */
  getRecording: function getRecording(id, operation, progressCallback) {
    if (operation !== 'play' && operation !== 'download') {
      throw new Error('Operation must be play or download');
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["d" /* request */])({
      method: 'GET',
      url: __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["b" /* ROOT_URL */] + '/filesystem/recording/' + id + '/' + operation,
      responseType: 'arraybuffer',
      onDownloadProgress: function onDownloadProgress(e) {
        progressCallback && progressCallback(e.loaded, e.total);
      }
    }).then(function (response) {
      return response.data;
    });
  },
  archiveRecording: function archiveRecording(id) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["d" /* request */])({
      method: 'GET',
      url: __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["b" /* ROOT_URL */] + '/filesystem/recording/' + id + '/delete'
    });
  },
  archiveRecordings: function archiveRecordings(ids) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["d" /* request */])({
      method: 'POST',
      url: __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["b" /* ROOT_URL */] + '/filesystem/recording/delete',
      data: {
        ids: ids
      }
    });
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





var Record = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'recordings',
  enums: {
    direction: {
      OUT: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('callDirection.out'),
      IN: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('callDirection.in')
    },
    state: {
      ANSWERED: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('callState.answered'),
      NOT_ANSWERED: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('callState.notAnswered'),
      BUSY: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('callState.busy')
    },
    reason: {
      UNKNOWN: 'recordings.reason.unknown',
      TIME_MISMATCH: 'recordings.reason.timeMismatch',
      RECORDING_DISABLED: 'recordings.reason.recordingDisabled',
      NUMBER_BLACKLIST: 'recordings.reason.numberBlacklist'
    }
  },
  methods: {
    isPlayable: function isPlayable(item) {
      return !item.archived && item.fileName;
    },
    getBasename: function getBasename(item) {
      try {
        return item.fileName.split('/').pop().split('.').shift();
      } catch (e) {
        return 'recording_' + __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.callDate).format('YYYY-MM-DD_HH:mm');
      }
    },
    getFilename: function getFilename(item) {
      // @TODO: Wtf is this, why is it so complicated
      var ext = void 0;
      try {
        ext = item.fileName.split('.').pop();
      } catch (e) {
        ext = 'wav';
      }
      return Record.getBasename(item) + '.' + ext;
    },
    getMetadata: function getMetadata(item) {
      return item.fetch('recordingMetadata').then(function (result) {
        item.recordingMetadata = result.items;
        return (['<?xml version=\'1.0\' encoding=\'UTF-8\'?>', '<cdr>', '\t<callDate>' + item.callDate + '</callDate>', '\t<source>' + item.source + '</source>', '\t<destination>' + item.destination + '</destination>', '\t<direction>' + item.direction + '</direction>', '\t<state>' + item.state + '</state>', '\t<duration>' + item.duration + '</duration>', '</cdr>'].join('\n') + '\n\n' + item.recordingMetadata.map(function (item) {
          return item.metadata;
        }).join('\n\n')).replace(/\n/g, '\r\n');
      });
    }
  }
});

Record.saveTags = function (item) {
  var updated = {
    _links: item._links,
    _self: item._self,
    _sources: item._sources,
    tags: item.tags
  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["e" /* applyRelations */])(updated, {});
};

/* harmony default export */ __webpack_exports__["a"] = (Record);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorePlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__debug__ = __webpack_require__(470);


var store = {
  auth: {
    token: null,
    user: null
  },
  login: {
    redirect: null
  },
  player: {
    keyStored: false,
    passStored: false
  }
};

if (process && __webpack_require__.i({"NODE_ENV":"production","API_URL":"/api","CLIENT_ID":"siprec","CLIENT_SECRET":"s1pr3c"}) && "production" === 'development') {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__debug__["a" /* default */])(store, 'store');
}

/* harmony default export */ __webpack_exports__["b"] = (store);

var StorePlugin = {
  install: function install(Vue) {
    Vue.prototype.$store = store;
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(88)))

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var data = {};
var store = {
  get: function get(key) {
    return data[key];
  },
  set: function set(key, value) {
    data[key] = value;
    this.save();
  },
  save: function save() {
    localStorage.setItem('localStore', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));
  },
  load: function load() {
    if (localStorage.getItem('localStore')) {
      var loaded = JSON.parse(localStorage.getItem('localStore'));
      if (loaded) {
        data = loaded;
      }
    }
  }
};

store.load();

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);


var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(869)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(495),
  /* template */
  __webpack_require__(1070),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */,
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__locale__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Format__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Record__ = __webpack_require__(107);







var pdFields = ['id', 'callDate', 'source', 'destination', 'fileName', 'encrypted', 'codecType', 'duration'];

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__factory_Siprec__["a" /* default */])({
  name: 'dataChanges',
  enums: {
    operation: {
      CREATE: 'CREATE',
      READ: 'READ',
      UPDATE: 'UPDATE',
      DELETE: 'DELETE',
      PLAY: 'PLAY',
      DOWNLOAD: 'DOWNLOAD'
    },
    tableName: {
      SIPREC_USER: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.users'),
      SIPREC_TAG: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.tags'),
      SIPREC_USER_CERTIFICATE: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.userCertificates'),
      SIPREC_COMPANY: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.companies'),
      SIPREC_COMPANY_GROUP: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.companyGroups'),
      SIPREC_COMPANY_DELEGATION: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.companyDelegations'),
      SIPREC_CONFIGURATION: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.configuration'),
      SIPREC_TARGET_GROUP: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.lineGroups'),
      SIPREC_TARGET: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.lines'),
      SIPREC_NUMBER: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.admin.numbers'),
      SIPREC_ACCESS: __WEBPACK_IMPORTED_MODULE_3__locale__["default"].t('titles.reports.accesses')
    }
  },
  methods: {
    getDiff: function getDiff(item, field) {
      try {
        var result = JSON.parse(item[field]);
        if (!result) return [];
        var other = field === 'dataBefore' ? 'dataAfter' : 'dataBefore';
        var otherResult = JSON.parse(item[other]);
        if (!otherResult) otherResult = {};

        // Special case for play/download operations
        var playDownload = field === 'dataBefore' && (item.operation === 'PLAY' || item.operation === 'DOWNLOAD');

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(result).filter(function (field) {
          if (playDownload) {
            return pdFields.indexOf(field) >= 0;
          }

          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(result[field]) === 'object') {
            if (otherResult[field] === result[field] || !otherResult[field] && !result[field]) {
              return false;
            }

            if (!otherResult[field] && result[field] || otherResult[field] && !result[field]) {
              return true;
            }

            if (Array.isArray(result[field])) {
              return result[field].length !== otherResult[field].length || !!result[field].find(function (item, index) {
                otherResult[field][index] !== item;
              });
            } else {
              return false;
            }
          }

          return result[field] !== otherResult[field];
        }).map(function (field) {
          var value = result[field];

          if (field === 'certificate' || field === 'encryptionKey') {
            value = '****';
          }

          if (Array.isArray(value)) {
            value = '[' + value.join(',') + ']';
          }

          if (playDownload) {
            if (field === 'callDate') {
              value = __WEBPACK_IMPORTED_MODULE_4__utils_Format__["a" /* default */].date(value);
            }

            if (field === 'fileName') {
              value = __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].getFilename(result);
            }

            if (field === 'duration') {
              value = __WEBPACK_IMPORTED_MODULE_4__utils_Format__["a" /* default */].interval(value);
            }
          }

          return field + ': ' + value;
        });
      } catch (e) {
        console.error(e);
        return [];
      }
    }
  }
}));

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'targetGroups'
}));

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({ name: 'tags' }));

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  SUPER_ADMIN: '/',
  GROUP_ADMIN: '/',
  COMPANY_ADMIN: '/',
  COMPANY_USER: '/'
});

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(866)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(482),
  /* template */
  __webpack_require__(1067),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'accesses'
}));

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'companyDelegations'
}));

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);




var clientId = "siprec";
var clientSecret = "s1pr3c";

/* harmony default export */ __webpack_exports__["a"] = ({
  getToken: function getToken(username, password) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.request({
      url: __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/oauth/token',
      method: 'post',
      auth: {
        username: clientId,
        password: clientSecret
      },
      data: __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
        grant_type: 'password',
        username: username,
        password: password
      }),
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    }).then(function (response) {
      return response.data;
    });
  },
  refreshToken: function refreshToken(token) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.request({
      method: 'post',
      url: __WEBPACK_IMPORTED_MODULE_1__factory_Siprec__["b" /* ROOT_URL */] + '/oauth/token',
      data: __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify({
        grant_type: 'refresh_token',
        refresh_token: token
      }),
      auth: {
        username: clientId,
        password: clientSecret
      }
    }).then(function (response) {
      return response.data;
    });
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(39);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'recordingRequests',
  enums: {
    operation: {
      DELETE: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('recordingRequests.operation.delete'),
      PLAY: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('recordingRequests.operation.play'),
      DOWNLOAD: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('recordingRequests.operation.download')
    }
  }
}));

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_OAuth__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_factory_Siprec__ = __webpack_require__(15);





var Auth = {
  /**
   * Returns if user is authorized to use application.
   * Users that have to change their password to continue or
   * perform any other actions to use application are not authorized.
   */
  isAuthorized: function isAuthorized() {
    return this.isLogged() && !__WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.changePasswordAfterLogin && !Auth.requiresKey();
  },


  /**
   * Returns if users needs to set master key to be authorized.
   */
  requiresKey: function requiresKey() {
    return __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user && __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.role === 'COMPANY_ADMIN' && __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.company && __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.company.requireEncryption && (!__WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.company.configuration || __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.company.configuration.encrypt !== 'KEY' || !__WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.company.configuration.encryptionKeyExists);
  },


  /**
   * Returns if user is logged in.
   */
  isLogged: function isLogged() {
    return !!__WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user;
  },


  /**
   * Returns if user is authorized as any of specified roles.
   * @param {string|string[]} role one or more roles
   * @param {boolean} ignoreDelegations don't use delegations
   * @return {boolean} if user is authorized as any of specified roles
   */
  hasRole: function hasRole(role, ignoreDelegations) {
    var _this = this;

    // User that is required to change password has access nowhere
    if (__WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.changePasswordAfterLogin) {
      return false;
    }

    // Multiple roles specified
    if (Array.isArray(role)) {
      return !!role.find(function (role) {
        return _this.hasRole(role, ignoreDelegations);
      });
    }

    // If we have delegation active, automatically approve company admin
    if (!ignoreDelegations && role === 'COMPANY_ADMIN' && __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.companyDelegation) {
      return true;
    }

    return __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.role === role;
  },
  isAuditor: function isAuditor() {
    return this.hasRole('COMPANY_USER') && __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user.companyAuditor;
  },


  /**
   * Returns user model.
   * This loads the model when required, this prevents issues with localization not being loaded.
   * @return {UserModel} user model
   */
  user: function user() {
    return __webpack_require__(19).default;
  },
  install: function install(Vue) {
    Vue.prototype.$auth = Auth;
  },
  login: function login(username, password) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1__models_OAuth__["a" /* default */].getToken(username, password).then(function (token) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__models_factory_Siprec__["f" /* setOAuthToken */])(token);
      __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.token = token;
      return _this2.user().getSelf(username);
    });
  },
  useToken: function useToken(token, username) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__models_factory_Siprec__["f" /* setOAuthToken */])(token);
    __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.token = token;
    return this.user().getSelf(username);
  },
  getUser: function getUser() {
    return __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user;
  },
  logout: function logout() {
    var _this3 = this;

    return this.user().logout().catch(function () {
      return _this3.clear();
    }).then(function () {
      return _this3.clear();
    });
  },
  clear: function clear() {
    __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.token = null;
    __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user = null;
    __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.username = null;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__models_factory_Siprec__["f" /* setOAuthToken */])(null);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (Auth);

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
var ieVersion = function () {
  var sAgent = window.navigator.userAgent;
  var Idx = sAgent.indexOf("MSIE");

  // If IE, return version number.
  if (Idx > 0) return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)));

  // If IE 11 then look for Updated user agent string.
  else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11;else return null; //It is not IE
}();
/* eslint-enable */

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * @returns {boolean} is current browser IE
   */
  isIE: function isIE() {
    return ieVersion !== undefined;
  },


  /**
   * Returns IE version. For example, on IE9 returns 9.
   * @returns {undefined|number} version of IE
   */
  getIEVersion: function getIEVersion() {
    return ieVersion;
  },
  install: function install(Vue) {
    Vue.prototype.$browser = this;
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_FileSystem__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Record__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jszip__);





/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Prompts user to download specified url under specified filename.
   *
   * @param {string} filename filename to be displayed to user
   * @param {string|Blob} url actual url
   */
  download: function download(filename, url) {
    var isBlob = url instanceof Blob;

    if (!isBlob || this.isObjectURLSupported()) {
      var link = document.createElement('a');
      document.body.appendChild(link);
      link.href = isBlob ? window.URL.createObjectURL(url) : url;
      link.download = filename;
      link.click();
      link.remove();
    } else {
      window.navigator.msSaveBlob(url, filename);
    }
  },


  /**
   * @returns {boolean} if downloading blob using object url is supported
   */
  isObjectURLSupported: function isObjectURLSupported() {
    return !window.navigator.msSaveOrOpenBlob;
  },


  /**
   * Collects recording data and metadata and returns them.
   * @param {Object} recording recording database object (only id is used)
   * @param {(download: number, metadata: number) => void} progressCallback progress callback
   * @returns {Promise<{ recording: ArrayBuffer, metadata: string }>} promise loading data
   */
  collectRecording: function collectRecording(recording, progressCallback) {
    // Result item with recording data and metadata text
    var result = {
      recording: null,
      metdata: null

      // Recording can already have data downloaded
    };var promise = void 0;
    if (recording.blob == null) {
      promise = __WEBPACK_IMPORTED_MODULE_1__models_FileSystem__["a" /* default */].getRecording(recording.id, 'download', function (loaded, total) {
        progressCallback(loaded / total, 0);
      });
    } else {
      promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(recording.blob);
    }

    return promise.then(function (response) {
      progressCallback && progressCallback(1, 0);

      result.recording = response;

      // Fetch metadata
      return __WEBPACK_IMPORTED_MODULE_2__models_Record__["a" /* default */].getMetadata(recording);
    }, function (err) {
      console.error('[Downloader]', 'Failed to fetch recording contents');
      console.error(err);
      // Failed to fetch recording
      // Try to at least fetch metadata
      return __WEBPACK_IMPORTED_MODULE_2__models_Record__["a" /* default */].getMetadata(recording);
    }).then(function (data) {
      progressCallback && progressCallback(1, 1);

      result.metadata = data;
      return result;
    }, function (err) {
      console.error('[Downloader]', 'Failed to fetch recording metdata');
      console.error(err);
    });
  },


  /**
   * Downloads specified list of recordings.
   *
   * @param {Object[]} items list of db objects to download
   * @param {string} filename name of resulting archive
   * @param {(done: number, total: number) => void} progressCallback progress callback
   * @returns {Promise<void>}
   */
  downloadRecordings: function downloadRecordings(items, filename, progressCallback) {
    var _this = this;

    var zip = new __WEBPACK_IMPORTED_MODULE_3_jszip__();
    var downloaded = [];
    var playable = items.filter(function (item) {
      return __WEBPACK_IMPORTED_MODULE_2__models_Record__["a" /* default */].isPlayable(item);
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(playable.map(function (item) {
      var downloadIndex = downloaded.length;
      downloaded.push(0);

      // Download recording into zip
      return _this.collectRecording(item, function (download, metadata) {
        downloaded[downloadIndex] = download * 0.95 + metadata * 0.05;
        progressCallback && progressCallback(downloaded.reduce(function (s, i) {
          return s + i;
        }, 0), playable.length);
      }).then(function (result) {
        zip.file(__WEBPACK_IMPORTED_MODULE_2__models_Record__["a" /* default */].getFilename(item), result.recording || '');
        zip.file(__WEBPACK_IMPORTED_MODULE_2__models_Record__["a" /* default */].getBasename(item) + '.txt', result.metadata || '');
      }).catch(function (err) {
        console.error('[Download]', 'Failed to collect recording data');
        console.error(err);
      });
    })).then(function () {
      // Generate zip archive
      return zip.generateAsync({ type: 'uint8array' });
    }).then(function (result) {
      // Download zip archive
      var blob = new Blob([result], { type: 'application/zip' });
      _this.download(filename || 'recordings.zip', blob);
    });
  }
});

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_cs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_cs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_locale_cs__);



var sdiak = 'áäčďéěíĺľňóô öŕšťúů üýřžÁÄČĎÉĚÍĹĽŇÓÔ ÖŔŠŤÚŮ ÜÝŘŽ';
var bdiak = 'aacdeeillnoo orstuu uyrzAACDEEILLNOO ORSTUU UYRZ';

/* harmony default export */ __webpack_exports__["a"] = ({
  date: function date(input) {
    return __WEBPACK_IMPORTED_MODULE_0_moment___default()(input).format('L LT');
  },

  filename: function filename(input) {
    for (var i = 0; i < sdiak.length; i++) {
      input = input.replace(new RegExp(sdiak[i]), bdiak[i]);
    }
    return input;
  },
  fileSize: function fileSize(bytes) {
    var u = 0;
    var s = 1024;
    while (bytes >= s || -bytes >= s) {
      bytes /= s;
      u++;
    }
    return (u ? bytes.toFixed(1) + ' ' : bytes) + ' KMGTPEZY'[u] + (u ? 'i' : '') + 'B';
  },
  ratio: function ratio(value, total) {
    if (total !== undefined) {
      if (total === 0) {
        value = 0;
      } else {
        value /= total;
      }
    }

    value = value || 0;

    return Math.round(value * 1E3) / 10 + ' %';
  },
  interval: function interval(_interval) {
    return ('00' + Math.floor(_interval / 3600)).slice(-2) + ':' + ('00' + Math.floor(_interval % 3600 / 60)).slice(-2) + ':' + ('00' + _interval % 60).slice(-2);
  },
  install: function install(Vue) {
    Vue.prototype.$format = this;
  }
});

/***/ }),
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(888)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(1091),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(885)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(484),
  /* template */
  __webpack_require__(1088),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(848)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(494),
  /* template */
  __webpack_require__(1049),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(496),
  /* template */
  null,
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(898)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(505),
  /* template */
  __webpack_require__(1102),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(867)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(506),
  /* template */
  __webpack_require__(1068),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(884)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(508),
  /* template */
  __webpack_require__(1087),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(881)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(509),
  /* template */
  __webpack_require__(1084),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_v_tooltip__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_Format__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Auth__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Browser__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loadable__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_vuetify_dist_vuetify_min_css__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__node_modules_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__node_modules_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_style_css__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_tooltip_css__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_custom_css__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_custom_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_custom_css__);
/* eslint-disable */
/// <reference path="../types/index.d.ts" />
/* eslint-enable */



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__store__["a" /* StorePlugin */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5__utils_Format__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__utils_Auth__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_v_tooltip__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__utils_Browser__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loadable', __WEBPACK_IMPORTED_MODULE_8__components_Loadable___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  i18n: __webpack_require__(39).default,
  router: __webpack_require__(469).default,
  template: '<App/>',
  components: { App: __webpack_require__(995) }
});

/***/ }),
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  login: {
    title: 'Přihlášení',
    username: 'Uživatelské jméno',
    password: 'Heslo',
    login: 'Přihlásit',
    unknownError: 'Došlo k chybě, zkuste to prosím později',
    badCredentialsError: 'Špatné jméno nebo heslo',
    forgotten: 'Zapomenuté heslo'
  },
  dashboard: {
    lastRecordings: 'Poslední nahrávky',
    moreRecordings: 'Další nahrávky',
    systemStorageUsage: 'Využití systémového místa',
    logicStorageUsage: 'Využití místa',
    notifications: 'Notifikace'
  },
  pageNotFound: {
    title: '404',
    pageNotFound: 'Stránka nenalezena'
  },
  recordings: {
    recordingIsEncrypted: 'Nahrávka je šifrovaná',
    downloadSelected: 'Stáhnout vybrané',
    play: 'Přehrát',
    download: 'Stáhnout',
    downloadMetadata: 'Stáhnout metadata',
    archived: 'Nahrávka je archivována',
    delete: 'Smazat nahrávku',
    deleteSelected: 'Smazat vybrané nahrávky',
    deletePrompt: 'Pro potvrzení smazání nahrávky zadejte slovo DELETE',
    deleteSelectedPrompt: 'Pro potvrzení smazání vybraných nahrávek zadejte slovo DELETE SELECTED',
    downloading: 'Stahování nahrávek',
    requestDownload: 'Vyžádat stažení',
    requestPlay: 'Vyžádat přehrání',
    requestDelete: 'Vyžádat smazání',
    actionRequest: 'Vytvořit žádost',
    requestQuestion: 'Chcete vyžádat danou operaci?',
    reason: {
      unknown: 'Nahrávka nebyla nahrána.',
      timeMismatch: 'Mimo časové okno.',
      recordingDisabled: 'Nahrávání vypnuto.',
      numberBlacklist: 'Číslo {number} je v blacklistu.'
    },
    deleteFiltered: 'Smazat vše',

    deleteFilteredPrompt: 'Pokud opravdu chcete smazat {number} nahrávek odpovídajících aktuálnímu filtru, zadejte slovo DELETE FILTERED',
    deleting: 'Mazání'
  },
  profile: {
    loading: 'Načítání profilu',
    accesses: {
      title: 'Přístupy'
    },
    certForm: {
      titleAdd: 'Přidat klíč',
      titleUpdate: 'Upravit klíč'
    },
    certs: {
      title: 'Klíče',
      noCerts: 'Žádné klíče'
    },
    common: {
      title: 'Obecné nastavení',
      saved: 'Údaje uloženy'
    },
    password: {
      title: 'Změnit heslo',
      saved: 'Nové heslo uloženo',
      originalPassword: 'Původní heslo',
      newPassword: 'Nové heslo',
      newPasswordAgain: 'Nové heslo znovu',
      passwordsMustMatch: 'Hesla se musí shodovat',
      wrongOriginalPassword: 'Špatné původní heslo'
    }
  },
  user: {
    passwordsMustMatch: 'Hesla se musí shodovat',
    passwordIsTooWeak: 'Heslo je příliš slabé'
  },
  configuration: {
    basic: {
      title: 'Nastavení',
      maxAge: 'Maximální stáří nahrávek',
      maxAgeHint: 'Ve dnech, 0 vypnutí mazání',
      encrypt: 'Šifrování nahrávek',
      publicKey: 'Změnit veřejný klíč',
      password: 'Heslo',
      encryption: {
        none: 'Žádné',
        password: 'Heslem',
        key: 'Klíčem'
      },
      compression: 'Komprese',
      compressions: {
        pcm: 'PCM (Žádná)',
        flac: 'FLAC',
        mp3: 'MP3'
      },
      invalidKey: 'Nevalidní PGP klíč',
      insertIdent: 'Vložit identifikaci stažené nahrávky',
      saved: 'Nastavení uloženo'
    },
    certs: {
      title: 'Povolené klíče uživatelů',
      noCerts: 'Žádné klíče',
      addKey: {
        title: 'Přidat klíč',
        certificate: 'Klíč'
      }
    }
  },
  keyFoot: {
    keyWarning: 'Máte v paměti uložený privátní klíč',
    keyAndPassWarning: 'Máte v paměti uložený privátní klíč a heslo!',
    forget: 'Zapomenout'
  },
  player: {
    title: 'Přehrávač',
    titlePrivateKeySettings: 'Nastavení privátního klíče',
    titlePrivateKeyPass: 'Heslo klíče',
    privateKeyPrompt: 'Nahrávka je zašifrovaná. Pro dešifrování je potřeba privátní klíč:',
    privateKey: 'Privátní klíč',
    saveLocally: 'Lokálně uložit pro opakované použití',
    continue: 'Pokračovat',
    passPrompt: 'Pro dešifrování zadejte heslo k vašemu privátnímu klíči:',
    passphrase: 'Heslo',
    saveTemporary: 'Dočasně uložit',
    decrypt: 'Dešifrovat',
    forgetKey: 'Zapomenout klíč',
    download: 'Stáhnout',
    keyLoadingFailed: 'Klíč se nepodařilo načíst',
    keyRequiresPass: 'Klíč vyžaduje heslo',
    wrongPass: 'Špatné heslo',
    loadingFailed: 'Nepodařilo se načíst nahrávku',
    wrongKey: 'Nahrávku nelze pomocí tohoto klíče dešifrovat',
    decryptingInProgress: 'Probíhá dešifrování nahrávky',
    playError: 'Při načítání nahrávky došlo k chybě. Podporuje váš prohlížeč přehrávání nahrávek typu {0}?'
  },
  tagger: {
    title: 'Tagy',
    addTag: 'Vytvořit tag',
    add: 'Přidat'
  },
  reset: {
    success: 'Heslo bylo úspěšně změněno.',
    continue: 'Pokračovat',
    invalidToken: 'Žádost o změnu hesla nebyla nalezena'
  },
  forgotten: {
    description: 'Zadejte prosím vaše uživatelské jméno. Po odeslání vám přijde e-mail s dalšími instrukcemi.',
    success: 'E-mailová zpráva odeslána. Dále postupujte podle instrukcí ve zprávě.',
    send: 'Odeslat',
    failed: 'Odeslání se nezdařilo. Je zadané uživatelské jméno správné?'
  },
  crud: {
    add: 'Přidat',
    filters: 'Filtry',
    csv: 'CSV',
    delete: 'Smazat',
    edit: 'Upravit',
    deleteSelected: 'Smazat vybrané',
    filter: {
      clear: 'Vyčistit'
    },
    filterTooltip: '<b>Aktivní filtr:</b> {0}',
    refresh: 'Obnovit',
    newTitle: 'Vytvoření nové položky',
    editTitle: 'Úprava existující položky'
  },
  logicStorageReport: {
    displayFilters: 'Nastavení zobrazení',
    showOnly: 'Zobrazit pouze tuto položku'
  },
  companySetup: {
    description: 'Pro pokračování je potřeba nastavit hlavní klíč pro šifrování nahrávek',
    publicKey: 'Hlavní veřejný klíč'
  },
  delegations: {
    title: 'Delegace',
    delegatedAs: 'Delegace jako',
    expiredAlert: 'Vaše právě vybraná delegace vypršela.'
  },
  errors: {
    notEmpty: 'Nesmí být prázdné',
    mustBeLonger: 'Musí být delší než {0}',
    passwordComplexityIsLessThanCompanyGroup: 'Síla hesla je menší než síla nastavená ve skupině',
    passwordExpiryIsLessThanCompanyGroup: 'Doba expirace je větší než doba nastavená ve skupině ({0} dní)',
    invalidAutomaticIdent: 'Může obsahovat pouze znaky 1234567890+*#',
    positiveNumbersOnly: 'Pouze čísla >= 0'
  },
  titles: {
    login: 'Přihlášení',
    dashboard: 'Dashboard',
    recordings: 'Nahrávky',
    reports: {
      title: 'Reporty',
      accesses: 'Výpis přihlášení',
      dataChanges: 'Výpis změn',
      systemStorage: 'Využití systémového místa',
      logicStorage: 'Využití místa',
      notifications: 'Notifikace'
    },
    admin: {
      title: 'Správa',
      superadmins: 'Superadministrátoři',
      groupadmins: 'Administrátoři',
      companyadmins: 'Správci společnosti',
      users: 'Uživatelé',
      companies: 'Firmy',
      companyGroups: 'Skupiny firem',
      lines: 'Linky',
      lineGroups: 'Skupiny linek',
      numbers: 'Čísla',
      tags: 'Tagy',
      configuration: 'Nastavení nahrávek',
      userCertificates: 'Uživatelské klíče',
      companyDelegations: 'Delegace'
    },
    profile: 'Profil',
    logout: 'Odhlásit',
    passwordReset: 'Změnit heslo',
    forgottenPassword: 'Zapomenuté heslo',
    companySetup: 'Nastavení šifrování nahrávek'
  },
  headers: {
    user: 'Uživatel',
    ipAddress: 'IP Adresa',
    loggedIn: 'Přihlášení',
    loggedOut: 'Odhlášení',
    changeDate: 'Datum změny',
    tableName: 'Tabulka',
    operation: 'Operace',
    dataBefore: 'Data před',
    dataAfter: 'Data po',
    name: 'Název',
    description: 'Popis',
    ico: 'IČO',
    enabled: 'Aktivní',
    company: 'Firma',
    companies: 'Firmy',
    recordDaysOfWeek: 'Nahrávat ve dnech',
    recordTimeFrom: 'Nahrávat od',
    recordTimeTill: 'Nahrávat do',
    recordingType: 'Nahrávat',
    certificates: 'Klíče',
    phoneNumber: 'Číslo',
    targetGroup: 'Skupina',
    overrideGroup: 'Přepsat nastavení skupiny',
    username: 'Uživatelské jméno',
    personName: 'Jméno',
    surname: 'Příjmení',
    email: 'E-mail',
    companyGroup: 'Skupina firem',
    companyGroups: 'Skupiny firem',
    password: 'Heslo',
    passwordAgain: 'Heslo znovu',
    browser: 'Prohlížeč',
    target: 'Linka',
    callDate: 'Datum',
    source: 'Volající',
    destination: 'Volaný',
    duration: 'Délka hovoru',
    direction: 'Směr hovoru',
    state: 'Stav',
    tags: 'Tagy',
    targets: 'Linky',
    targetGroups: 'Skupiny linek',
    admins: 'Správci',
    date: 'Datum',
    actionType: 'Akce',
    recordAlways: 'Nahrávat vždy',
    createAdmin: 'Vytvořit správce',
    sendInfo: 'Odeslat informace e-mailem',
    quota: 'Kvóta místa',
    passwordComplexity: 'Vyžadovaná síla hesla',
    passwordExpiry: 'Doba vypršení hesla',
    allowRecordingDeletion: 'Povolit uživatelské mazání nahrávek',
    automaticIdent: 'Automatická identifikace',
    customLogo: 'Vlastní logo',
    customLogoHint: 'URL adresa loga firmy',
    customCss: 'Vlastní styl',
    customCssHint: 'URL adresa css stylu firmy',
    show: 'Zobrazit',
    totalSpace: 'Celkem místa',
    takenSpace: 'Zabráno',
    disabledSpace: 'Neaktivních',
    severity: 'Závažnost',
    type: 'Typ',
    text: 'Text',
    maxChannels: 'Maximalní počet kanalů',
    disableRecording: 'Zakázat nahrávání',
    changePasswordAfterLogin: 'Vynutit změnu hesla po přihlášení',
    requireEncryption: 'Vyžadovat šifrování klíčem',
    recordingsSize: 'Obsazené místo',
    allowedHosts: 'Povolit přístup z',
    allowedHostsHint: 'Seznam zdrojů ze kterých může uživatel přistupovat. Prázdný seznam povolí přístup odkudkoliv. Formát je: maska;maska;maska. Maska je pak buď hostname (example.com), ip adresa (192.168.100.1) nebo ip adresa s rozsahem (192.168.100.0/24)',
    color: 'Barva',
    dateFrom: 'Aktivní od',
    delegationDuration: 'Délka',
    delegationDurationHint: 'V minutách',
    note: 'Poznámka',
    recordingsConfirmations: 'Potvrzování nahrávek',
    sipId: 'SIP Identifikátor',
    dtmfDelectionAllowed: 'Povolit detekci DTMF',
    companyAuditor: 'Auditor'
  },
  week: {
    monday: 'Pondělí',
    tuesday: 'Úterý',
    wednesday: 'Středa',
    thursday: 'Čtvrtek',
    friday: 'Pátek',
    saturday: 'Sobota',
    sunday: 'Neděle'
  },
  time: {
    from: 'Od',
    to: 'Do'
  },
  passwordComplexity: {
    low: 'Slabší',
    medium: 'Střední',
    high: 'Vysoká'
  },
  recordingType: {
    always: 'Vždy nahrávat',
    never: 'Nikdy nenahrávat'
  },
  callDirection: {
    in: 'Dovnitř',
    out: 'Ven'
  },
  callState: {
    answered: 'Přijato',
    notAnswered: 'Nepřijato',
    busy: 'Zaneprázdněn'
  },
  space: {
    free: 'Volné místo',
    used: 'Využité místo',
    inactive: 'Využité neaktivími firmami'
  },
  userRole: {
    superAdmin: 'Superadmin',
    groupAdmin: 'Admin',
    companyAdmin: 'Admin společnosti',
    companyUser: 'Uživatel'
  },
  recordingRequests: {
    operation: {
      delete: 'Smazání',
      play: 'Přehrání',
      download: 'Stažení'
    }
  },
  companyNotifications: {
    severity: {
      debug: 'DEBUG',
      info: 'INFO',
      warn: 'VAROVÁNÍ',
      error: 'CHYBA'
    },
    type: {
      automaticTarget: 'Automatická linka',
      quotaUsage: 'Kvóty'
    },
    automaticTarget: 'Byla vytvořena linka s číslem {number}',
    quotaUsage: 'Obsazení disku dosáhlo {percentage} % kvóty'
  },
  targetsReport: {
    title: 'Využití linek',
    period: 'Období',
    defined: 'Definováno',
    used: 'Použito'
  },
  noItems: 'Žádné položky',
  loadingItems: 'Načítání dat',
  close: 'Zavřít',
  save: 'Uložit',
  create: 'Vytvořit',
  savingFailed: 'Uložení se nezdařilo',
  cancel: 'Zrušit',
  yes: 'Ano',
  no: 'Ne',
  inDays: 'Ve dnech',
  inMb: 'V MiB',
  changePasswordDescription: 'Pro dokončení přihlášení je potřeba nastavit nové heslo',
  search: 'Vyhledat'
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  login: {
    title: 'Sign in',
    username: 'Username',
    password: 'Password',
    login: 'Sign in',
    unknownError: 'An error occured. Please, try again later.',
    badCredentialsError: 'Invalid username or password.',
    forgotten: 'Forgotten password'
  },
  dashboard: {
    lastRecordings: 'Last recordings',
    moreRecordings: 'More recordings',
    SystemStorageUsage: 'Usage of system storage',
    logicStorageUsage: 'Storage usage',
    notifications: 'Notifications'
  },
  pageNotFound: {
    title: '404',
    pageNotFound: 'Page Not Found'
  },
  recordings: {
    recordingIsEncrypted: 'Recording is encrypted',
    downloadSelected: 'Download selected',
    play: 'Play',
    download: 'Download',
    downloadMetadata: 'Download metadata',
    archived: 'Recording is archived',
    delete: 'Delete recording',
    deleteSelected: 'Delete selected recordings',
    deletePrompt: 'To confirm recording deletion, enter word DELETE',
    deleteSelectedPrompt: 'To confirm deletion of selected recordings, enter DELETE SELECTED',
    downloading: 'Downloading recordings',
    requestDownload: 'Request download',
    requestPlay: 'Request play',
    requestDelete: 'Request deletion',
    actionRequest: 'Request action',
    requestQuestion: 'Do you want to request this operation?',
    reason: {
      unknown: 'No recording present.',
      timeMismatch: 'Outside of time window.',
      recordingDisabled: 'Recording is disasbled.',
      numberBlacklist: 'Number {number} is blacklisted.'
    },
    deleteFiltered: 'Delete all',
    deleteFilteredPrompt: 'If you really want to delete {number} recordings, that correspond to currently selected filters, enter DELETE FILTERED',
    deleting: 'Deleting'
  },
  profile: {
    loading: 'Loading profile',
    accesses: {
      title: 'Accesses'
    },
    certForm: {
      titleAdd: 'Add key',
      titleUpdate: 'Edit key'
    },
    certs: {
      title: 'Keys',
      noCerts: 'No keys'
    },
    common: {
      title: 'General settings',
      saved: 'Data saved'
    },
    password: {
      title: 'Change password',
      saved: 'New password saved',
      originalPassword: 'Current password',
      newPassword: 'New password',
      newPasswordAgain: 'Confirm new password',
      passwordsMustMatch: 'Passwords have to match',
      wrongOriginalPassword: 'Invalid current password'
    }
  },
  user: {
    passwordsMustMatch: 'Passwords have to match',
    passwordIsTooWeak: 'Heslo je příliš slabé'
  },
  configuration: {
    basic: {
      title: 'Configuration',
      maxAge: 'Maximum age of recordings',
      maxAgeHint: 'Number of days, set to 0 to never delete recordings',
      encrypt: 'Encrypt recordings',
      publicKey: 'Change public key',
      encryption: {
        none: 'None',
        password: 'Password',
        key: 'Key'
      },
      compression: 'Komprese',
      compressions: {
        pcm: 'PCM (Žádná)',
        flac: 'FLAC',
        mp3: 'MP3'
      },
      invalidKey: 'Invalid PGP key',
      insertIdent: 'Insert indentification of downloaded recording',
      saved: 'Configuration saved'
    },
    certs: {
      title: 'Enabled user keys',
      noCerts: 'No keys',
      addKey: {
        title: 'Add key',
        certificate: 'Key'
      }
    }
  },
  keyFoot: {
    keyWarning: 'You have private key saved in memory.',
    keyAndPassWarning: 'You have private key and password saved in memory!',
    forget: 'Forget'
  },
  player: {
    title: 'Player',
    titlePrivateKeySettings: 'Private key settings',
    titlePrivateKeyPass: 'Key password',
    privateKeyPrompt: 'This recording is encrypted. You need private key to decrypt it:',
    privateKey: 'Private key',
    saveLocally: 'Save locally to reuse',
    continue: 'Continue',
    passPrompt: 'Enter password for your private key to decrypt:',
    passphrase: 'Password',
    saveTemporary: 'Save temporarily',
    decrypt: 'Decrypt',
    forgetKey: 'Forget the key',
    download: 'Download',
    keyLoadingFailed: 'Key can not be loaded',
    keyRequiresPass: 'Key requires password',
    wrongPass: 'Wrong password',
    loadingFailed: 'Recording can not be loaded',
    wrongKey: 'Recording can not be decrypted using this key',
    decryptingInProgress: 'Recording is being decrypted',
    playError: 'There was error when loading recording. Does your browser support playing {0} recordings?'
  },
  tagger: {
    title: 'Tags',
    addTag: 'Add tag',
    add: 'Add'
  },
  reset: {
    success: 'Password was successfully changed.',
    continue: 'Continue',
    invalidToken: 'Password request was not found'
  },
  forgotten: {
    description: 'Please enter your username. You will receive e-mail with instructions.',
    success: 'E-mail sent, continue according to instructions in e-mail.',
    send: 'Send'
  },
  crud: {
    add: 'Add',
    filters: 'Filters',
    csv: 'CSV',
    delete: 'Delete',
    edit: 'Edit',
    deleteSelected: 'Delete selected',
    filter: {
      clear: 'Clear'
    },
    filterTooltip: '<b>Active filter:</b> {0}',
    refresh: 'Refresh',
    newTitle: 'Creating new item',
    editTitle: 'Editing existing item'
  },
  logicStorageReport: {
    displayFilters: 'Display filters',
    showOnly: 'Show only this item'
  },
  companySetup: {
    description: 'To continue, you need to setup a master public key for encryption of recording',
    publicKey: 'Master public key'
  },
  delegations: {
    title: 'Delegations',
    delegatedAs: 'Delegated as',
    expiredAlert: 'Your currently selected delegation expired.'
  },
  errors: {
    notEmpty: 'Can not be empty',
    mustBeLonger: 'Must be longer than {0}',
    passwordComplexityIsLessThanCompanyGroup: 'Password strength is smaller than password strength required by group',
    passwordExpiryIsLessThanCompanyGroup: 'Password expiry is bigger than password expiry set in group ({0} days)',
    invalidAutomaticIdent: 'Can only contain characters 1234567890+*#',
    positiveNumbersOnly: 'Only numbers >= 0'
  },
  titles: {
    login: 'Sign In',
    dashboard: 'Dashboard',
    recordings: 'Recordings',
    reports: {
      title: 'Reports',
      accesses: 'Login log',
      dataChanges: 'Changes log',
      systemStorage: 'System storage usage',
      logicStorage: 'Storage usage',
      notifications: 'Notifications'
    },
    admin: {
      title: 'Administration',
      superadmins: 'Superadministrators',
      groupadmins: 'Administrators',
      companyadmins: 'Company administrators',
      users: 'Users',
      companies: 'Companies',
      companyGroups: 'Company groups',
      lines: 'Lines',
      lineGroups: 'Line groups',
      numbers: 'Numbers',
      tags: 'Tags',
      configuration: 'Recording configuration',
      userCertificates: 'User certificates',
      companyDelegations: 'Delegations'
    },
    profile: 'Profile',
    logout: 'Sign out',
    passwordReset: 'Reset password',
    forgottenPassword: 'Forgotten password',
    companySetup: 'Recordings encryption settings'
  },
  headers: {
    user: 'User',
    ipAddress: 'IP address',
    loggedIn: 'Signed in',
    loggedOut: 'Signed out',
    changeDate: 'Date of change',
    tableName: 'Table',
    operation: 'Operation',
    dataBefore: 'Original data',
    dataAfter: 'Changed data',
    name: 'Name',
    description: 'Description',
    ico: 'Organization ID',
    enabled: 'Active',
    company: 'Company',
    companies: 'Companies',
    recordDaysOfWeek: 'Record in days',
    recordTimeFrom: 'Record from',
    recordTimeTill: 'Record to',
    recordingType: 'Record',
    certificates: 'Keys',
    phoneNumber: 'Number',
    targetGroup: 'Group',
    overrideGroup: 'Override group settings',
    username: 'Username',
    personName: 'Name',
    surname: 'Surname',
    email: 'E-mail',
    companyGroup: 'Company group',
    companyGroups: 'Company groups',
    password: 'Password',
    passwordAgain: 'Confirm password',
    browser: 'Browser',
    target: 'Line',
    targetGroups: 'Line groups',
    callDate: 'Date',
    source: 'Caller',
    destination: 'Callee',
    duration: 'Call duration',
    direction: 'Call direction',
    state: 'State',
    tags: 'Tags',
    targets: 'Lines',
    admins: 'Administrators',
    date: 'Date',
    actionType: 'Action',
    recordAlways: 'Always record',
    createAdmin: 'Create company admin',
    sendInfo: 'Send info by e-mail',
    quota: 'Space quota',
    passwordComplexity: 'Required password strength',
    passwordExpiry: 'Password expiration time',
    allowRecordingDeletion: 'Allow users to delete recordings',
    automaticIdent: 'Automatic identification',
    customLogo: 'Custom logo',
    customLogoHint: 'URL address of company logo',
    customCss: 'Vlastní styl',
    customCssHint: 'URL address of company css style',
    show: 'Show',
    totalSpace: 'Total space',
    takenSpace: 'Used',
    disabledSpace: 'Disabled',
    severity: 'Severity',
    type: 'Type',
    text: 'Text',
    maxChannels: 'Maximum number of channels',
    disableRecording: 'Disable recording',
    changePasswordAfterLogin: 'Force password change after login',
    requireEncryption: 'Require key encryption',
    recordingsSize: 'Used space',
    allowedHosts: 'Allow access from',
    allowedHostsHint: 'List of sources from which user can login. Empty list means any source is allowed. Format: mask;mask;mask. Mask is either hostname (example.com), ip address (192.168.100.1) or ip address with mask (192.168.100.0/24)',
    color: 'Color',
    dateFrom: 'Active from',
    delegationDuration: 'Duration',
    delegationDurationHint: 'In minutes',
    note: 'Note',
    recordingsConfirmations: 'Recordings confirmations',
    sipId: 'SIP Identificator',
    dtmfDelectionAllowed: 'Allow DTMF detection',
    companyAuditor: 'Auditor'
  },
  week: {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday'
  },
  time: {
    from: 'From',
    to: 'To'
  },
  passwordComplexity: {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
  },
  recordingType: {
    always: 'Always record',
    never: 'Never record'
  },
  callDirection: {
    in: 'Incoming',
    out: 'Outgoing'
  },
  callState: {
    answered: 'Answered',
    notAnswered: 'Unanswered',
    busy: 'Busy'
  },
  space: {
    free: 'Free space',
    used: 'Used space',
    inactive: 'Used by inactive companies'
  },
  userRole: {
    superAdmin: 'Superadmin',
    groupAdmin: 'Admin',
    companyAdmin: 'Company admin',
    companyUser: 'User'
  },
  recordingRequests: {
    operation: {
      delete: 'Delete',
      play: 'Play',
      download: 'Download'
    }
  },
  companyNotifications: {
    severity: {
      debug: 'DEBUG',
      info: 'INFO',
      warn: 'WARNING',
      error: 'ERROR'
    },
    type: {
      automaticTarget: 'Automatic target',
      quotaUsage: 'Quota usage'
    },
    automaticTarget: 'Target with number {number} was created',
    quotaUsage: 'Disk usage has reached {percentage} % of quota'
  },
  targetsReport: {
    period: 'Period',
    defined: 'Defined',
    used: 'Used',
    title: 'Lines usage'
  },
  noItems: 'No items',
  loadingItems: 'Loading items',
  close: 'Close',
  save: 'Save',
  create: 'Create',
  savingFailed: 'Saving failed',
  cancel: 'Cancel',
  yes: 'Yes',
  no: 'No',
  inDays: 'In days',
  inMb: 'In MiB',
  changePasswordDescription: 'You need to set new password to finish logging in',
  search: 'Search'
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(39);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'companyNotifications',
  enums: {
    severity: {
      'DEBUG': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('companyNotifications.severity.debug'),
      'INFO': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('companyNotifications.severity.info'),
      'WARN': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('companyNotifications.severity.warn'),
      'ERROR': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('companyNotifications.severity.error')
    },
    type: {
      'AUTOMATIC_TARGET': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('companyNotifications.type.automaticTarget'),
      'QUOTA_USAGE': __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('companyNotifications.type.quotaUsage')
    }
  }
}));

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(39);



/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["a" /* default */])({
  name: 'numbers',
  enums: {
    recordingType: {
      RECORD_ALWAYS: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('recordingType.always'),
      RECORD_NEVER: __WEBPACK_IMPORTED_MODULE_1__locale__["default"].t('recordingType.never')
    }
  }
}));

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__ = __webpack_require__(15);


/* harmony default export */ __webpack_exports__["a"] = ({
  getList: function getList() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["d" /* request */])({
      url: __WEBPACK_IMPORTED_MODULE_0__factory_Siprec__["b" /* ROOT_URL */] + '/reports/recording',
      method: 'POST',
      data: options
    }).then(function (response) {
      return response.data;
    });
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Admin_CompanyGroups__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Admin_CompanyGroups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Admin_CompanyGroups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Admin_Configuration__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Admin_Configuration___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Admin_Configuration__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Admin_Users__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Admin_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Admin_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Admin_Tags__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Admin_Tags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Admin_Tags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Admin_Companies__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Admin_Companies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Admin_Companies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Admin_Numbers__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Admin_Numbers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Admin_Numbers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Admin_Lines__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Admin_Lines___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Admin_Lines__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Admin_LineGroups__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_Admin_LineGroups___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_Admin_LineGroups__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Admin_CompanyDelegations__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Admin_CompanyDelegations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Admin_CompanyDelegations__);










/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/admin/users',
  name: 'Users',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Admin_Users___default.a,
  meta: {
    title: 'titles.admin.users',
    requiresAuth: true,
    roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN']
  }
}, {
  path: '/admin/tags',
  name: 'Tags',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_Admin_Tags___default.a,
  meta: {
    title: 'titles.admin.tags',
    requiresAuth: true,
    roles: ['COMPANY_ADMIN', 'COMPANY_USER']
  }
}, {
  path: '/admin/companies',
  name: 'Companies',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_Admin_Companies___default.a,
  meta: {
    title: 'titles.admin.companies',
    requiresAuth: true,
    roles: ['GROUP_ADMIN']
  }
}, {
  path: '/admin/numbers',
  name: 'Numbers',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_Admin_Numbers___default.a,
  meta: {
    title: 'titles.admin.numbers',
    requiresAuth: true,
    roles: ['COMPANY_ADMIN']
  }
}, {
  path: '/admin/lines',
  name: 'Lines',
  component: __WEBPACK_IMPORTED_MODULE_6__pages_Admin_Lines___default.a,
  meta: {
    title: 'titles.admin.lines',
    requiresAuth: true,
    roles: ['GROUP_ADMIN', 'COMPANY_ADMIN']
  }
}, {
  path: '/admin/lineGroups',
  name: 'LineGroups',
  component: __WEBPACK_IMPORTED_MODULE_7__pages_Admin_LineGroups___default.a,
  meta: {
    title: 'titles.admin.lineGroups',
    requiresAuth: true,
    roles: ['COMPANY_ADMIN']
  }
}, {
  path: '/admin/company-groups',
  name: 'CompanyGroups',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Admin_CompanyGroups___default.a,
  meta: {
    title: 'titles.admin.companyGroups',
    requiresAuth: true,
    roles: ['SUPER_ADMIN']
  }
}, {
  path: '/admin/configuration',
  name: 'Configuration',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Admin_Configuration___default.a,
  meta: {
    title: 'titles.admin.configuration',
    requiresAuth: true,
    roles: ['COMPANY_ADMIN']
  }
}, {
  path: '/admin/company-delegations',
  name: 'CompanyDelegations',
  component: __WEBPACK_IMPORTED_MODULE_8__pages_Admin_CompanyDelegations___default.a,
  meta: {
    title: 'titles.admin.companyDelegations',
    requiresAuth: true,
    roles: ['COMPANY_ADMIN'],
    ignoreDelegations: true
  }
}]);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Reports_Accesses__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Reports_Accesses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Reports_Accesses__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Reports_DataChanges__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Reports_DataChanges___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Reports_DataChanges__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Reports_SystemStorage__ = __webpack_require__(1044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Reports_SystemStorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Reports_SystemStorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Reports_LogicStorage__ = __webpack_require__(1042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Reports_LogicStorage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Reports_LogicStorage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Reports_Notifications__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Reports_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Reports_Notifications__);






/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/reports/accesses',
  name: 'Accesses',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Reports_Accesses___default.a,
  meta: {
    title: 'titles.reports.accesses',
    requiresAuth: true,
    roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN']
  }
}, {
  path: '/reports/data-changes',
  name: 'DataChanges',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Reports_DataChanges___default.a,
  meta: {
    title: 'titles.reports.dataChanges',
    requiresAuth: true,
    roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN']
  }
}, {
  path: '/reports/system-storage',
  name: 'SystemStorage',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Reports_SystemStorage___default.a,
  meta: {
    title: 'titles.reports.systemStorage',
    requiresAuth: true,
    roles: ['SUPER_ADMIN']
  }
}, {
  path: '/reports/logic-storage',
  name: 'LogicStorage',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_Reports_LogicStorage___default.a,
  meta: {
    title: 'titles.reports.logicStorage',
    requiresAuth: true,
    roles: ['GROUP_ADMIN', 'COMPANY_ADMIN']
  }
}, {
  path: '/reports/notifications',
  name: 'Notifications',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_Reports_Notifications___default.a,
  meta: {
    title: 'titles.reports.notifications',
    requiresAuth: true,
    roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN']
  }
}]);

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Dashboard__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__pages_Dashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Recordings__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Recordings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Recordings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Profile__ = __webpack_require__(1038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_PasswordReset__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_PasswordReset___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_PasswordReset__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_ForgottenPassword__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_ForgottenPassword___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_ForgottenPassword__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_PasswordChange__ = __webpack_require__(1036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_PasswordChange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_PasswordChange__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_CompanySetup__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_CompanySetup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_CompanySetup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Admin_routes__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Reports_routes__ = __webpack_require__(466);












/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_8__Admin_routes__["a" /* default */].concat(__WEBPACK_IMPORTED_MODULE_9__Reports_routes__["a" /* default */], [{
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login___default.a,
  meta: {
    title: 'titles.login',
    unauthorizedOnly: true
  }
}, {
  path: '/forgotten-password',
  name: 'ForgottenPassword',
  component: __WEBPACK_IMPORTED_MODULE_5__pages_ForgottenPassword___default.a,
  meta: {
    requiresAuth: false,
    unauthorizedOnly: true,
    title: 'titles.forgottenPassword'
  },
  props: true
}, {
  path: '/password-reset/:token',
  name: 'PasswordReset',
  component: __WEBPACK_IMPORTED_MODULE_4__pages_PasswordReset___default.a,
  meta: {
    requiresAuth: false,
    unauthorizedOnly: true,
    title: 'titles.passwordReset'
  },
  props: true
}, {
  path: '/password-change',
  name: 'PasswordChange',
  component: __WEBPACK_IMPORTED_MODULE_6__pages_PasswordChange___default.a,
  meta: {
    requiresAuth: false,
    title: 'titles.passwordReset'
  }
}, {
  path: '/logout',
  name: 'Logout',
  component: __WEBPACK_IMPORTED_MODULE_0__pages_Login___default.a,
  props: { logout: true }
}, {
  path: '/',
  name: 'Dashboard',
  component: __WEBPACK_IMPORTED_MODULE_1__pages_Dashboard___default.a,
  meta: {
    title: 'titles.dashboard',
    requiresAuth: true,
    roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN', 'COMPANY_USER']
  }
}, {
  path: '/profile',
  name: 'Profile',
  component: __WEBPACK_IMPORTED_MODULE_3__pages_Profile___default.a,
  meta: {
    title: 'titles.profile',
    requiresAuth: true
  }
}, {
  path: '/recordings',
  name: 'Recordings',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_Recordings___default.a,
  meta: {
    title: 'titles.recordings',
    requiresAuth: true,
    roles: ['COMPANY_ADMIN', 'COMPANY_USER'],
    ignoreDelegations: true
  }
}, {
  path: '/company-setup',
  name: 'CompanySetup',
  component: __WEBPACK_IMPORTED_MODULE_7__pages_CompanySetup___default.a,
  meta: {
    title: 'titles.companySetup',
    requiresAuth: false
  }
}]));

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = beforeEach;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__default__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Auth__ = __webpack_require__(207);





/**
 * Checks if the specified user can accesses specified route
 * @param {*} route
 * @param {*} user
 */
function isAuthorized(route, user) {
  // Don't allow unlogged user to access logged only pages
  if (route.meta && route.meta.requiresAuth && !user) {
    console.log('User is not logged in, but tried to access', route.name);
    return false;
  }

  if (route.meta && route.meta.roles && !route.meta.roles.find(function (role) {
    return __WEBPACK_IMPORTED_MODULE_3__utils_Auth__["a" /* default */].hasRole(role, route.meta.ignoreDelegations);
  })) {
    console.log('User does not have rights to access', route.name);
    return false;
  }

  return true;
}

/**
 * Intended to be used in router 'beforeEach' hook.
 * Checks if currently logged in user can access target route and redirects him if not
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
function beforeEach(to, from, next) {
  var user = __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth && __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].auth.user;

  // Don't allow access user to pages that are only for unlogged users
  if (user && to.meta.unauthorizedOnly) {
    console.log('Logged user is trying to access unlogged only page', to.name);
    return next('/404');
  }

  // Some exceptions
  if (user) {
    // Force user to change password
    if (user.changePasswordAfterLogin && to.name !== 'PasswordChange' && to.name !== 'Logout') {
      console.log('Password change is forced');
      return next('/password-change');
    }

    // Force user to set company public key
    if (!user.changePasswordAfterLogin && __WEBPACK_IMPORTED_MODULE_3__utils_Auth__["a" /* default */].requiresKey() && to.name !== 'CompanySetup' && to.name !== 'Logout') {
      console.log('Company setup is forced');
      return next('/company-setup');
    }
  }

  if (!isAuthorized(to, user)) {
    /*
      User is logged in, but can't acces specified resource.
      Redirect him to his default route.
    */
    if (user) {
      if (to.name === 'Dashboard' && __WEBPACK_IMPORTED_MODULE_1__default__["a" /* default */][user.role]) {
        console.log('User is trying to access dashboard, but doesnt have rights to do so. Redirecting to default route', __WEBPACK_IMPORTED_MODULE_1__default__["a" /* default */][user.role]);
        return next(__WEBPACK_IMPORTED_MODULE_1__default__["a" /* default */][user.role]);
      }
      return next('/404');
    } else {
      // User is not logged in, redirect him to login
      if (to.name !== 'Login') {
        __WEBPACK_IMPORTED_MODULE_0__store__["b" /* default */].login.redirect = to.fullPath;
        console.log('Must login');
        return next('/login');
      }
    }
  }

  document.title = (to.meta.title ? __WEBPACK_IMPORTED_MODULE_2__locale__["default"].t(to.meta.title) : to.name) + ' - SIPREC';

  return next();
}

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_PageNotFound__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_PageNotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_PageNotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_routes__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth__ = __webpack_require__(468);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_3__pages_routes__["a" /* default */].push({
  path: '*',
  component: __WEBPACK_IMPORTED_MODULE_2__pages_PageNotFound___default.a,
  meta: {
    requiresAuth: true,
    title: 'pageNotFound.pageNotFound'
  }
});

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_3__pages_routes__["a" /* default */]
});

router.beforeEach(__WEBPACK_IMPORTED_MODULE_4__auth__["a" /* beforeEach */]);

/* harmony default export */ __webpack_exports__["default"] = (router);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

function load(key, store) {
  if (localStorage.getItem(key)) {
    var loaded = JSON.parse(localStorage.getItem(key));
    if (loaded) {
      for (var i in loaded) {
        store[i] = loaded[i];
      }
    }
  }
}

function save(key, store) {
  delete store.auth.user;
  localStorage.setItem(key, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(store));
}

/* harmony default export */ __webpack_exports__["a"] = (function (data, key) {
  load(key, data);
  window.onunload = function () {
    return save(key, data);
  };
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Csv = function () {
  function Csv() {
    var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ';';
    var encoding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UTF-8';

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Csv);

    this.separator = separator;
    this.encoding = encoding;
    this.rows = [];
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Csv, [{
    key: 'addRow',
    value: function addRow(row) {
      var escaped = row.map(function (col) {
        return col ? col.toString().replace(/"/, '""').replace(/\n/, '\\n') : '';
      });

      this.rows.push(escaped);
    }
  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      // @TODO: Convert to target encoding

      return '\uFEFF' + this.rows.map(function (row) {
        return row.map(function (col) {
          return '"' + col + '"';
        }).join(_this.separator);
      }).join('\r\n');
    }
  }, {
    key: 'download',
    value: function download(filename) {
      var a = document.createElement('a');
      a.style = 'display: none';
      document.body.appendChild(a);

      var data = this.toString();
      var blob = new Blob([data], { type: 'text/csv' });
      var url = window.URL.createObjectURL(blob);

      a.href = url;
      a.download = filename;
      a.click();
      window.URL.revokeObjectURL(url);

      a.remove();
    }
  }]);

  return Csv;
}();

/* harmony default export */ __webpack_exports__["a"] = (Csv);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DecoderException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InvalidKeyException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return InvalidPassphraseException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DecodingFailedException; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FileNotFoundException; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_openpgp__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_openpgp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_openpgp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lamejs__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lamejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lamejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_FileSystem__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Browser__ = __webpack_require__(208);












__WEBPACK_IMPORTED_MODULE_6_openpgp___default.a.initWorker({ path: 'static/openpgp.worker.js' });

function Int8ToBuffer(array) {
  var buffer = new ArrayBuffer(array.length);
  var ubuf = new Uint8Array(buffer);
  for (var i = 0; i < ubuf.length; i += 1) {
    ubuf[i] = array[i];
  }
  return buffer;
}

var DecoderException = function () {
  function DecoderException(e) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DecoderException);

    // super(e && e.toString())

    this.exception = e;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(DecoderException, [{
    key: 'toString',
    value: function toString() {
      return this.exception ? this.exception.toString() : 'Unknown error';
    }
  }]);

  return DecoderException;
}();

var InvalidKeyException = function (_DecoderException) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InvalidKeyException, _DecoderException);

  function InvalidKeyException() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, InvalidKeyException);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InvalidKeyException.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InvalidKeyException)).apply(this, arguments));
  }

  return InvalidKeyException;
}(DecoderException);
var InvalidPassphraseException = function (_DecoderException2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(InvalidPassphraseException, _DecoderException2);

  function InvalidPassphraseException() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, InvalidPassphraseException);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InvalidPassphraseException.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(InvalidPassphraseException)).apply(this, arguments));
  }

  return InvalidPassphraseException;
}(DecoderException);
var DecodingFailedException = function (_DecoderException3) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DecodingFailedException, _DecoderException3);

  function DecodingFailedException() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DecodingFailedException);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DecodingFailedException.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(DecodingFailedException)).apply(this, arguments));
  }

  return DecodingFailedException;
}(DecoderException);
var FileNotFoundException = function (_DecoderException4) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(FileNotFoundException, _DecoderException4);

  function FileNotFoundException() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, FileNotFoundException);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FileNotFoundException.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(FileNotFoundException)).apply(this, arguments));
  }

  return FileNotFoundException;
}(DecoderException);

/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Encodes wav file to mp3 format
   * @param {ArrayBuffer} buffer wav data
   */
  wavToMp3: function wavToMp3(buffer) {
    var wav = __WEBPACK_IMPORTED_MODULE_7_lamejs___default.a.WavHeader.readHeader(new DataView(buffer));
    var samples = new Int16Array(buffer, wav.dataOffset, wav.dataLen / 2);

    var mp3buffer = [];
    var mp3enc = new __WEBPACK_IMPORTED_MODULE_7_lamejs___default.a.Mp3Encoder(wav.channels, wav.sampleRate, samples);

    var remaining = samples.length;
    var maxSamples = 1152;
    for (var i = 0; remaining >= maxSamples; i += maxSamples) {
      var mono = samples.subarray(i, i + maxSamples);
      var mp3buf = mp3enc.encodeBuffer(mono);
      if (mp3buf.length > 0) {
        mp3buffer.push(mp3buf);
      }
      remaining -= maxSamples;
    }

    var d = mp3enc.flush();
    if (d.length) {
      mp3buffer.push(d);
    }

    return mp3buffer;
  },


  /**
   * Downloads and possibly decrypt and encode recording.
   *
   * @param {Object} recording recording database object
   * @param {string} privateKey
   * @param {string} passphrase
   * @param {'play'|'download'} action
   * @param {(downloadProgress: number, decodeProgress: number) => void} progressCallback
   * @return {Promise<Blob>}
   */
  decode: function decode(recording, privateKey, passphrase, action, progressCallback) {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var privateKeyObj = void 0;
      var encodeToMp3 = action === 'play' && __WEBPACK_IMPORTED_MODULE_9__utils_Browser__["a" /* default */].isIE() && recording.codecType === 'WAV';

      if (recording.encrypted) {
        // Try to decode private key
        try {
          privateKeyObj = __WEBPACK_IMPORTED_MODULE_6_openpgp__["key"].readArmored(privateKey).keys[0];
        } catch (e) {
          return reject(new InvalidKeyException(e));
        }

        // Check if private key requires passphrase
        if (privateKeyObj.primaryKey.encrypted && !passphrase) {
          return reject(new InvalidPassphraseException('Passphrase not provided, but private key is encrypted'));
        }

        // Decrypt private key if passphrase is supplied
        try {
          if (passphrase) {
            privateKeyObj.decrypt(passphrase);
          }
        } catch (e) {
          return reject(new InvalidPassphraseException(e));
        }
      }

      // Load recording from external source
      var promise = __WEBPACK_IMPORTED_MODULE_8__models_FileSystem__["a" /* default */].getRecording(recording.id, action, function (loaded, total) {
        progressCallback && progressCallback(loaded / total, 0);
      }).then(function (result) {
        progressCallback && progressCallback(1, 0);
        return result;
      }).catch(function (err) {
        throw new FileNotFoundException(err);
      });

      // Decrypt recording if needed
      if (recording.encrypted) {
        promise = promise.then(function (data) {
          // Prepare decryption object
          return {
            message: __WEBPACK_IMPORTED_MODULE_6_openpgp__["message"].read(new Uint8Array(data)),
            privateKey: privateKeyObj,
            format: 'binary'
          };
        }).catch(function (error) {
          throw new DecodingFailedException(error);
        }).then(function (options) {
          // Decrypt the file
          return __WEBPACK_IMPORTED_MODULE_6_openpgp___default.a.decrypt(options);
        }).then(function (result) {
          return Int8ToBuffer(result.data);
        }).catch(function (error) {
          // Pass decoder exceptions on
          if (error instanceof DecoderException) {
            throw error;
          }

          // This means we have encrypted key without passhrase or with wrong passphrase
          if (error.toString() === 'Private key is not decrypted.') {
            throw new InvalidPassphraseException(error);
          }

          // Something occured, most probably key is wrong
          throw new InvalidKeyException(error);
        });
      }

      // Encode to mp3 if needed
      promise = promise.then(function (data) {
        var buffer = [data];

        // Only try to change format if we're playing
        if (encodeToMp3) {
          // Try to decode to MP3 on IE
          try {
            buffer = _this5.wavToMp3(data);
          } catch (e) {
            throw new DecodingFailedException(e);
          }
        }

        // Return in form of blob
        return new Blob(buffer, { type: 'audio/mp3' });
      });

      resolve(promise);
    });
  }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_KeyFoot__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_KeyFoot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_KeyFoot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Delegations__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Delegations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Delegations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_local__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Global__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      drawer: true,
      mini: false,
      right: null,
      idleTimeout: null,
      idleTicks: 0
    };
  },
  created: function created() {
    var _this = this;

    window.addEventListener('beforeunload', function () {
      return _this.unload();
    });
    window.addEventListener('load', function () {
      return _this.resetIdle();
    });

    var idleEvents = ['load', 'mousemove', 'mousedown', 'touchstart', 'click', 'scroll', 'keypress'];
    idleEvents.forEach(function (event) {
      document.addEventListener(event, function () {
        return _this.resetIdle();
      });
    });

    __WEBPACK_IMPORTED_MODULE_4__utils_Global__["a" /* EventBus */].$on('auth-failed', function () {
      _this.$auth.clear();
      _this.$router.push('/login');
    });

    this.resetIdle();
  },

  methods: {
    unload: function unload() {
      if (this.$store.auth.user) {
        __webpack_require__(19).default.logout();
      }
    },
    resetIdle: function resetIdle() {
      clearTimeout(this.idleTimeout);
      this.idleTicks = 0;
      this.startIdle();
    },
    startIdle: function startIdle() {
      var _this2 = this;

      this.idleTimeout = setTimeout(function () {
        return _this2.timeout();
      }, 5 * 60 * 1000);
    },
    timeout: function timeout() {
      // Clear saved pass if saved
      var stored = __WEBPACK_IMPORTED_MODULE_3__store_local__["a" /* default */].get('private');
      if (stored && stored.pass) {
        stored.pass = null;
        this.$store.player.passSaved = false;
        __WEBPACK_IMPORTED_MODULE_3__store_local__["a" /* default */].set('private', stored);
      } else {
        this.$store.player.passSaved = false;
      }

      // Save minutes of being idle
      this.idleTicks++;

      // Logout when 4*5=20 minutes passed
      if (this.idleTicks === 4 && this.$store.auth.user) {
        this.$store.login.redirect = this.$route.fullPath;
        this.$router.push('/logout');
      }

      // Continue tracking idle time
      this.startIdle();
    },
    title: function title() {
      var matched = this.$router.currentRoute.matched.find(function (record) {
        return record.meta.title;
      });
      return matched && this.$t(matched.meta.title);
    },
    authorized: function authorized() {
      return this.$auth.isAuthorized();
    },
    delegationChanged: function delegationChanged() {
      this.$refs.navigation.refresh();
    }
  },
  components: {
    Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a,
    KeyFoot: __WEBPACK_IMPORTED_MODULE_1__components_KeyFoot___default.a,
    Delegations: __WEBPACK_IMPORTED_MODULE_2__components_Delegations___default.a
  }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormContainer__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FormContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FormContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Configuration__ = __webpack_require__(105);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  data: function data() {
    var _this = this;

    return {
      isBusy: false,
      compressionValues: this.enumToOptions(__WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */].enums.compression),
      model: __WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */],
      saved: false,
      keyRules: [function (value) {
        if (!value) return true;
        return (/-----BEGIN PGP PUBLIC KEY BLOCK-----([^]*?)-----END PGP PUBLIC KEY BLOCK-----/.test(value) ? true : _this.$t('configuration.basic.invalidKey')
        );
      }]
    };
  },

  computed: {
    isByPassword: function isByPassword() {
      return this.value.encrypt === 'PASSWORD';
    },
    isByKey: function isByKey() {
      return this.value.encrypt === 'KEY';
    },
    encryptValues: function encryptValues() {
      // Only allow key encryption when encryption is required
      if (this.$store.auth.user.company.requireEncryption && this.$store.auth.user.company.requireEncryption) {
        return this.enumToOptions({
          KEY: __WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */].enums.encrypt.KEY
        });
      }

      return this.enumToOptions(__WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */].enums.encrypt);
    }
  },
  methods: {
    enumToOptions: function enumToOptions(item) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(item).map(function (field) {
        return {
          text: item[field],
          value: field
        };
      });
    },
    save: function save() {
      var _this2 = this;

      this.isBusy = true;

      this.doSave().then(function (saved) {
        if (_this2.isByKey && _this2.value.encryptionKey) {
          return __WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */].setKey(saved, _this2.value.encryptionKey);
        }
        if (_this2.isByPassword && _this2.value.password) {
          return __WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */].setPassword(saved, _this2.value.password);
        }
      }).then(function () {
        _this2.saved = true;
        _this2.isBusy = false;

        setTimeout(function () {
          _this2.saved = false;
        }, 5000);
      }).catch(function (error) {
        console.error(error);

        _this2.isBusy = false;

        if (error.response.data && error.response.data.errors) {
          if (error.response.data.errors.find(function (err) {
            return err.property === 'encryptionKey';
          })) {
            alert(_this2.$t('configuration.basic.invalidKey'));
            return;
          }
        }

        console.error(error.response);

        alert(_this2.$t('savingFailed'));
      });
    },
    doSave: function doSave() {
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.value);
      data.company = this.$store.auth.user.company;

      /* if (data.encryptionKey && data.encryptionKey.length > 0) {
        data.encryptionKey = btoa(data.encryptionKey)
      } */

      if (!this.value._self) {
        return __WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */].create(data);
      } else {
        return __WEBPACK_IMPORTED_MODULE_3__models_Configuration__["a" /* default */].update(data);
      }
    },
    drop: function drop(ev) {
      var data = ev.dataTransfer;
      if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].kind === 'file') {
            this.readFile(data.items[i].getAsFile());
            ev.preventDefault();
            break;
          }
        }
      } else {
        this.readFile(data.files[0]);
        ev.preventDefault();
      }
    },
    fileChanged: function fileChanged() {
      if (this.$refs.file.files && this.$refs.file.files.length === 1) {
        this.readFile(this.$refs.file.files[0]);
      }
    },
    readFile: function readFile(file) {
      var _this3 = this;

      var reader = new FileReader();
      reader.onload = function () {
        _this3.value.encryptionKey = reader.result;
      };
      reader.readAsText(file);
    }
  },
  components: {
    FormContainer: __WEBPACK_IMPORTED_MODULE_2__components_FormContainer___default.a
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_UserCertificate__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Configuration__ = __webpack_require__(105);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  data: function data() {
    return {
      items: [],
      selected: null,
      addShown: false,
      isBusy: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__models_UserCertificate__["a" /* default */].getList({ include: ['user'] }).then(function (result) {
      _this.items = result.items.map(function (item) {
        item.name = item.user.name + ' ' + item.user.surname + ' - ' + item.name;
        return item;
      });
    });

    if (this.value && this.value.certificates) {
      this.value.certificates.forEach(function (item) {
        item.name = item.user.name + ' ' + item.user.surname + ' - ' + item.name;
      });
    }
  },

  methods: {
    remove: function remove(item) {
      var _this2 = this;

      var index = this.value.certificates.findIndex(function (cert) {
        return cert._self === item._self;
      });
      if (index >= 0) {
        this.value.certificates.splice(index, 1);
        __WEBPACK_IMPORTED_MODULE_1__models_Configuration__["a" /* default */].applyRelations(this.value).then(function () {
          _this2.isBusy = false;
        }).catch(function (error) {
          console.error(error);
          alert(_this2.$t('savingFailed'));
        });
      }
    },
    add: function add() {
      this.addShown = true;
    },
    save: function save() {
      var _this3 = this;

      var item = this.items.find(function (item) {
        return item._self === _this3.selected;
      });
      if (item) {
        this.isBusy = true;
        this.value.certificates.push(item);
        __WEBPACK_IMPORTED_MODULE_1__models_Configuration__["a" /* default */].applyRelations(this.value).then(function () {
          _this3.isBusy = false;
          _this3.addShown = false;
          _this3.selected = null;
        }).catch(function (error) {
          console.error(error);
          alert(_this3.$t('savingFailed'));
        });
      }
    }
  }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CrudField__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CrudField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__CrudField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CrudForm__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CrudForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CrudForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CrudFilter__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CrudFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__CrudFilter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CrudFilterDialog__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CrudFilterDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CrudFilterDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_DataChange__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_Csv__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    fields: Object,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    creatable: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    deletable: {
      type: Boolean,
      default: true
    },
    exportable: {
      type: Boolean,
      default: true
    },
    refreshable: {
      type: Boolean,
      default: true
    },
    perPage: {
      type: Number,
      default: 25
    },
    bulk: {
      type: Boolean,
      default: true
    },
    filtering: {
      type: Boolean,
      default: true
    },
    paginating: {
      type: Boolean,
      default: true
    },
    formComponent: {
      type: Object,
      default: null
    },
    formOrder: {
      type: Array,
      default: null
    },
    defaultOrder: {
      type: String,
      default: null
    },
    defaultOrderAsc: {
      type: Boolean,
      default: true
    },
    serverside: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    requestAllItems: {
      type: Function,
      default: null
    },
    allItemsActions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    formError: String
  },
  created: function created() {
    this.clearFilters();
  },
  data: function data() {
    return {
      form: false,
      page: 1,
      filters: {},
      checked: {},
      sortBy: this.defaultOrder,
      sortAsc: this.defaultOrderAsc
    };
  },

  computed: {
    fieldKeys: function fieldKeys() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields);
    },
    nActions: function nActions() {
      return this.actions.map(function (action) {
        var item = {};
        for (var i in action) {
          item[i] = action[i];
        }
        if (item.single === undefined) {
          item.single = true;
        }
        if (item.visibility === undefined) {
          item.visibility = function () {
            return true;
          };
        }
        return item;
      });
    },
    itemActions: function itemActions() {
      return this.nActions.filter(function (item) {
        return item.single;
      });
    },
    bulkActions: function bulkActions() {
      return this.nActions.filter(function (item) {
        return item.multi;
      });
    },
    nFields: function nFields() {
      var _this = this;

      return this.fieldKeys.reduce(function (fields, field) {
        var options = _this.fields[field];
        var normalized = options;

        /*
        for (let i in options) {
          normalized[i] = options[i]
        }
        */

        if (normalized.sortable === undefined) {
          normalized.sortable = true;
        }
        if (normalized.filterable === undefined) {
          normalized.filterable = true;
        }
        if (normalized.id === undefined) {
          normalized.id = '_self';
        }
        if (normalized.display === undefined) {
          normalized.display = 'name';
        }
        if (normalized.list === undefined) {
          normalized.list = true;
        }
        if (normalized.editable === undefined) {
          normalized.editable = true;
        }
        if (normalized.formOrder === undefined) {
          normalized.formOrder = 0;
        }
        if (normalized.errors === undefined) {
          normalized.errors = [];
        }
        if (normalized.rules === undefined) {
          normalized.rules = [];
        }
        if (normalized.type === 'reference' || normalized.type === 'references') {
          if (normalized.display === undefined) {
            normalized.display = 'name';
          }
        }

        fields[field] = normalized;
        return fields;
      }, {});
    },
    paginated: function paginated() {
      var _this2 = this;

      var filtered = this.items;

      if (!this.serverside) {
        filtered = filtered.filter(function (item) {
          var fieldFilter = _this2.fieldKeys.find(function (field) {
            var options = _this2.nFields[field];
            var idField = options.id || '_self';
            if (options.filterable) {
              if (_this2.filters[field]) {
                if (options.type === 'references') {
                  if (_this2.filters[field].length > 0 && !_this2.filters[field].find(function (fil) {
                    return item[field].find(function (sub) {
                      return sub[idField] === fil[idField];
                    });
                  })) {
                    return true;
                  }
                } else if (options.type === 'reference') {
                  if (_this2.filters[field].length > 0 && !_this2.filters[field].find(function (fil) {
                    return fil[idField] === item[field][idField];
                  })) {
                    return true;
                  }
                } else if (options.type === 'enum') {
                  if (_this2.filters[field].length > 0 && !_this2.filters[field].find(function (fil) {
                    return fil._self === item[field];
                  })) {
                    return true;
                  }
                } else if (options.type === 'bool') {
                  return item[field] !== _this2.filters[field];
                } else {
                  if (!item[field] || item[field].toString().toLowerCase().indexOf(_this2.filters[field].toString().toLowerCase()) < 0) {
                    return true;
                  }
                }
              }
            }
            return false;
          });

          if (fieldFilter) {
            return false;
          }

          return true;
        });
      }

      if (!this.serverside && this.sortBy) {
        filtered.sort(function (a, b) {
          return (_this2.sortAsc ? 1 : -1) * _this2.compare(a, b);
        });
      }

      if (!this.serverside) {
        filtered = filtered.slice((this.page - 1) * this.perPage, this.page * this.perPage);
      }

      return filtered;
    },
    selectedItems: function selectedItems() {
      var _this3 = this;

      return this.paginated.reduce(function (selected, item) {
        if (_this3.checked[item._self]) {
          selected.push(item);
        }
        return selected;
      }, []);
    },
    totalItems: function totalItems() {
      return this.total === null ? this.items.length : this.total;
    },
    isBulkEnabled: function isBulkEnabled() {
      return this.bulk && (this.deletable || this.bulkActions.length > 0);
    }
  },
  watch: {
    page: function page() {
      if (this.bulk && this.$refs.checkAll) {
        this.$refs.checkAll.checked = false;
      }
      this.$emit('page-changed', this.page);
    },
    sortBy: function sortBy() {
      this.$emit('sort-changed', this.sortBy, this.sortAsc);
    },
    sortAsc: function sortAsc() {
      this.$emit('sort-changed', this.sortBy, this.sortAsc);
    }
  },
  methods: {
    changePage: function changePage(page) {
      this.page = page;
    },
    clearFilters: function clearFilters() {
      var _this4 = this;

      this.filters = this.fieldKeys.reduce(function (filters, field) {
        if (_this4.nFields[field].type === 'references' || _this4.nFields[field].type === 'reference' || _this4.nFields[field].type === 'enum') {
          filters[field] = [];
        } else {
          filters[field] = null;
        }
        return filters;
      }, {});

      this.$emit('filters-changed', this.filters);
    },
    compare: function compare(a, b) {
      var options = this.nFields[this.sortBy];
      var displayField = options.display || 'id';
      var av = a[this.sortBy];
      var bv = b[this.sortBy];

      if (this.isNothing(av) && this.isNothing(bv)) return 0;
      if (this.isNothing(av)) return -1;
      if (this.isNothing(bv)) return 1;

      if (options.type === 'references') {
        if (this.isEmpty(av) && this.isEmpty(bv)) return 0;
        if (this.isEmpty(av)) return -1;
        if (this.isEmpty(bv)) return 1;
        av = av[0];
        bv = bv[0];
      }

      if (options.type === 'reference' || options.type === 'references') {
        if (this.isNothing(av[displayField]) && this.isNothing(bv[displayField])) return 0;
        if (this.isNothing(av[displayField])) return -1;
        if (this.isNothing(bv[displayField])) return 1;
        return av[displayField].localeCompare(bv[displayField]);
      } else if (options.type === 'number') {
        return av - bv;
      } else {
        return av.toString().localeCompare(bv.toString());
      }
    },
    sort: function sort(field) {
      if (!this.nFields[field].sortable) return;

      if (this.sortBy === field) {
        this.sortAsc = !this.sortAsc;
      } else {
        this.sortBy = field;
        this.sortAsc = true;
      }
    },
    isNothing: function isNothing(ref) {
      return ref === null || ref === undefined;
    },
    isEmpty: function isEmpty(refs) {
      return this.isNothing(refs) || refs.length === 0;
    },
    create: function create(item) {
      this.$emit('create', item);
    },
    save: function save(item, field) {
      this.$emit('save', item, [field], this.items);
    },
    remove: function remove(item) {
      this.$emit('remove', [item]);
    },
    edit: function edit(item) {
      var _this5 = this;

      // References type currently requires array, so make sure we have array
      this.fieldKeys.forEach(function (field) {
        if (_this5.nFields[field].type === 'references' && !item[field]) {
          item[field] = [];
        }
      });

      this.form = item;
    },
    formSave: function formSave(item) {
      this.$emit('save', item, this.fieldKeys, this.items);
    },
    formCancel: function formCancel(previous) {
      var _this6 = this;

      this.items.forEach(function (item, index) {
        if (item._self === previous._self) {
          _this6.items[index] = previous;
        }
      });

      this.form = null;
      this.$emit('cancel', previous);
    },
    saveFailed: function saveFailed(item, fields) {
      if (this.$refs.form) {
        this.$refs.form.saveFailed(item, fields);
      }
    },
    saved: function saved(item, fields) {
      if (fields.length === 1) {
        this.$refs.crudField.forEach(function (field) {
          field.saved(item, fields[0]);
        });
      }
      this.form = null;
    },
    edited: function edited(comp, item, field) {
      this.$refs.crudField.forEach(function (item) {
        if (item !== comp) item.closeForm();
      });
    },
    checkAll: function checkAll(e) {
      this.checked = this.paginated.reduce(function (checked, item) {
        checked[item._self] = e.srcElement.checked;
        return checked;
      }, {});
    },
    deleteSelected: function deleteSelected() {
      if (this.selectedItems.length > 0) {
        this.$emit('remove', this.selectedItems);
      }
    },
    actionOnSelected: function actionOnSelected(action) {
      if (this.selectedItems.length > 0) {
        action.action(this.selectedItems);
      }
    },
    allItemsActionSelected: function allItemsActionSelected(action) {
      var promise = this.serverside && this.requestAllItems ? this.requestAllItems(this.filters) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.items);

      promise.then(function (items) {
        action.action(items);
      });
    },
    exportCsv: function exportCsv() {
      var _this7 = this;

      var promise = this.serverside && this.requestAllItems ? this.requestAllItems(this.filters) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.items);

      promise.then(function (items) {
        var csv = new __WEBPACK_IMPORTED_MODULE_7__utils_Csv__["a" /* default */](';', 'cp1250');

        csv.addRow(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this7.nFields).filter(function (field) {
          return _this7.nFields[field].list;
        }).map(function (field) {
          return _this7.nFields[field].label;
        }));

        items.forEach(function (item) {
          csv.addRow(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this7.nFields).filter(function (field) {
            return _this7.nFields[field].list;
          }).map(function (field) {
            var options = _this7.nFields[field];
            var value = item[field];

            if (value === undefined || value === null) {
              return '';
            }

            switch (options.type) {
              case 'date':
                return _this7.$format.date(value);
              case 'reference':
                return value[options.display];
              case 'references':
                return value.map(function (item) {
                  return item[options.display];
                }).join(', ');
              case 'enum':
                return options.values[value] || value;
              case 'bool':
                return value ? _this7.$t('yes') : _this7.$t('no');
              case 'data':
                return __WEBPACK_IMPORTED_MODULE_6__models_DataChange__["a" /* default */].getDiff(item, field).join(', ');
              default:
                return value;
            }
          }));
        });

        var exportName = _this7.$format.filename(_this7.$t(_this7.$route.meta.title));
        var exportDate = __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('L LT');

        csv.download(exportName + ' ' + exportDate + '.csv');
      });
    },
    showFilters: function showFilters() {
      this.$refs.filterDialog.show();
    },
    saveFilters: function saveFilters() {
      this.$emit('filters-changed', this.filters);
    },
    add: function add() {
      var _this8 = this;

      this.edit(this.fieldKeys.reduce(function (item, field) {
        var options = _this8.nFields[field];
        if (options.default) {
          item[field] = options.default;
        } else if (options.type === 'references') {
          item[field] = [];
        }
        return item;
      }, {}));
    },
    isAnyFilterActive: function isAnyFilterActive() {
      var _this9 = this;

      return !!this.fieldKeys.find(function (field) {
        return _this9.isActiveFilter(field);
      });
    },
    isActiveFilter: function isActiveFilter(field) {
      return this.filters[field] && (['references', 'reference', 'enum'].indexOf(this.nFields[field].type) < 0 || this.filters[field].length > 0);
    },
    filterTooltip: function filterTooltip(field) {
      return this.$t('crud.filterTooltip', [this.filterTooltipvalue(field)]);
    },
    filterTooltipvalue: function filterTooltipvalue(field) {
      var _this10 = this;

      if (['references', 'reference', 'enum'].indexOf(this.nFields[field].type) < 0) {
        return this.filters[field];
      }

      return this.filters[field].map(function (item) {
        return item[_this10.nFields[field].display];
      }).join(', ');
    },
    refresh: function refresh() {
      this.$emit('refresh');
    }
  },
  components: {
    CrudField: __WEBPACK_IMPORTED_MODULE_2__CrudField___default.a,
    CrudForm: __WEBPACK_IMPORTED_MODULE_3__CrudForm___default.a,
    CrudFilter: __WEBPACK_IMPORTED_MODULE_4__CrudFilter___default.a,
    CrudFilterDialog: __WEBPACK_IMPORTED_MODULE_5__CrudFilterDialog___default.a
  }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudInput__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CrudInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_DataChange__ = __webpack_require__(141);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    field: String,
    options: Object,
    value: Object,
    editable: Boolean
  },
  data: function data() {
    return {
      editing: false,
      preEdit: null,
      displaySaved: false
    };
  },

  computed: {
    references: function references() {
      var _this = this;

      if (this.options.type !== 'references') return [];
      if (!this.value[this.field]) return [];
      if (!Array.isArray(this.value[this.field])) {
        console.warn('Field', this.field, 'is references, yet it doesn\'t contain array.', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.value[this.field]), this.value[this.field]);
        return [];
      }
      return this.value[this.field].map(function (item) {
        return item[_this.options.displayField || 'name'];
      });
    },
    dataChange: function dataChange() {
      if (this.options.type !== 'data') return [];
      return __WEBPACK_IMPORTED_MODULE_2__models_DataChange__["a" /* default */].getDiff(this.value, this.field);
    },
    textDisplay: function textDisplay() {
      var value = this.value[this.field];
      if (this.options.type === 'number' && typeof value === 'number') {
        value = value.toString();
      }

      if (!value) return '';

      if (this.options.displayLength) {
        return value.length > this.options.displayLength ? value.substr(0, this.options.displayLength - 3) + '...' : value;
      }

      return value;
    }
  },
  methods: {
    boolChange: function boolChange() {
      this.$emit('save', this.value, this.field);
    },
    saveField: function saveField(e) {
      this.$refs.field.save();
    },
    save: function save(e) {
      this.editing = false;

      if (this.preEdit !== this.value[this.field]) {
        this.$emit('save', this.value, this.field);
      }

      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    cancel: function cancel(e) {
      this.value[this.field] = this.preEdit;
      this.editing = false;

      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    edit: function edit() {
      // @TODO: Saving works, but highlights wrong entity and displays loading for entire screen
      if (!this.editable || !this.options.editable || this.options.type === 'bool') return;

      this.preEdit = this.value[this.field];
      this.editing = true;
      this.$emit('edited', this, this.value, this.field);
    },
    closeForm: function closeForm() {
      if (this.editing) {
        this.save();
      }
    },
    saved: function saved(item, field) {
      var _this2 = this;

      if (item._self !== this.value._self || field !== this.field) return;

      this.displaySaved = true;
      setTimeout(function () {
        _this2.displaySaved = false;
      }, 1000);
    },
    formatDate: function formatDate(date) {
      return this.$format.date(date);
    },
    formatInterval: function formatInterval(interval) {
      return this.$format.interval(interval);
    },
    formatReferences: function formatReferences(data) {
      var display = this.formatReferencesTooltip(data);
      if (display.length > 50) {
        display = display.substr(0, 47) + '...';
      }
      return display;
    },
    formatReferencesTooltip: function formatReferencesTooltip(data) {
      var display = data.join(', ');
      if (display.length > 50) {
        display = display.substr(0, 47) + '...';
      }
      return display;
    }
  },
  components: {
    CrudInput: __WEBPACK_IMPORTED_MODULE_1__CrudInput___default.a
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudInput__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CrudInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CrudInput__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    options: Object,
    field: String,
    value: Object
  },
  components: {
    CrudInput: __WEBPACK_IMPORTED_MODULE_1__CrudInput___default.a
  },
  methods: {
    convertEnum: function convertEnum(values) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(values).map(function (field) {
        return {
          _self: field,
          name: values[field]
        };
      });
    }
  }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CrudFilter__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CrudFilter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CrudFilter__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['fields', 'value'],
  data: function data() {
    return {
      shown: false
    };
  },

  methods: {
    show: function show() {
      this.shown = true;
    },
    save: function save() {
      this.$emit('saved');
      this.shown = false;
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.shown = false;
    }
  },
  components: {
    CrudFilter: __WEBPACK_IMPORTED_MODULE_0__CrudFilter___default.a
  }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CrudFormField__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CrudFormField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CrudFormField__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    fields: Object,
    formOrder: Array,
    value: Object,
    error: String
  },
  created: function created() {
    // Deep copy, please kill me
    this.previous = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.value));
  },

  methods: {
    save: function save() {
      var _this = this;

      /*
      if (Object.keys(this.fields).find(field => !!this.fields[field].rules.find(rule => rule.bind(this.value)(this.value[field]) !== true))) {
        return
      }
      */
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).find(function (field) {
        if (_this.$refs['input_' + field] && _this.$refs['input_' + field].length) {
          return !_this.$refs['input_' + field][0].isValid();
        } else {
          return false;
        }
      })) {
        return;
      }

      this.isBusy = true;
      this.$emit('save', this.value);
    },
    cancel: function cancel() {
      this.$emit('input', this.previous);
      this.$emit('cancel', this.previous);
    },
    saveFailed: function saveFailed() {
      var _this2 = this;

      this.isBusy = false;
      this.refresh = false;
      setTimeout(function () {
        _this2.refresh = true;
      });
    }
  },
  data: function data() {
    return {
      fill: ['weekdays'],
      isBusy: false,
      refresh: true,
      previous: null
    };
  },

  watch: {
    value: function value() {
      this.isBusy = false;
    }
  },
  computed: {
    isNew: function isNew() {
      return !this.value._self;
    },
    rows: function rows() {
      var _this3 = this;

      var keys = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.fields).filter(function (field) {
        var options = _this3.fields[field];
        if (!options.editable) return false;
        if (options.createOnly && _this3.value._self) return false;
        if (options.requires) {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(options.requires) === 'object') {
            for (var _field in options.requires) {
              var target = options.requires[_field];
              if (target === false) {
                if (_this3.value[_field]) return false;
              } else if (target === true) {
                if (!_this3.value[_field]) return false;
              } else {
                if (_this3.value[_field] !== target) return false;
              }
            }
          } else {
            if (options.requiresValue === undefined && !_this3.value[options.requires]) return false;
            if (options.requiresValue !== undefined && _this3.value[options.requires] !== options.requiresValue) return false;
          }
        }

        if (options.createOnly && _this3.value._self) {
          return false;
        }

        return true;
      });

      keys.sort(function (a, b) {
        if (!_this3.formOrder) {
          return _this3.fields[a].formOrder - _this3.fields[b].formOrder;
        } else {
          return _this3.formOrder.indexOf(a) - _this3.formOrder.indexOf(b);
        }
      });

      var rows = [];
      var row = [];
      rows.push(row);

      keys.forEach(function (item) {
        if (_this3.fill.indexOf(_this3.fields[item].type) >= 0 || _this3.fields[item].fill) {
          rows.push(item);
          row = [];
          rows.push(row);
        } else {
          row.push(item);
          if (row.length === 2) {
            row = [];
            rows.push(row);
          }
        }
      });

      return rows.filter(function (row) {
        return row.length > 0;
      });
    }
  },
  components: {
    CrudFormField: __WEBPACK_IMPORTED_MODULE_3__CrudFormField___default.a
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CrudInput__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CrudInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CrudInput__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    field: String,
    options: Object,
    value: Object
  },
  components: {
    CrudInput: __WEBPACK_IMPORTED_MODULE_0__CrudInput___default.a
  },
  methods: {
    isValid: function isValid() {
      return this.$refs.input.isValid();
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_search_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObjectSelect__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ObjectSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ObjectSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Weekdays__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Weekdays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Weekdays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateTime__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DateTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateRange__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DateRange___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DateRange__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    field: String,
    options: Object,
    value: Object,
    size: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    },
    allowEmpty: {
      type: Boolean,
      default: false
    },
    overrideType: {
      type: String,
      default: null
    },
    overrideValues: {
      type: Array,
      default: null
    },
    noRules: Boolean,
    filter: Boolean
  },
  data: function data() {
    var datedtime = null;
    if (this.options.type === 'datedtime') {
      if (this.value[this.field]) {
        datedtime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.value[this.field]).format('HH:mm');
      }
    }

    if (this.options.type === 'enum' && !this.filter && this.value[this.field] !== undefined && this.value[this.field] !== null && typeof this.value[this.field] !== 'string') {
      this.value[this.field] = this.value[this.field].toString();
    }

    var date = null;
    var time = null;

    return {
      refOptions: [],
      isBusy: false,
      datedtime: datedtime,
      date: date,
      time: time
    };
  },

  watch: {
    datedtime: function datedtime() {
      this.value[this.field] = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.datedtime, 'hh:mm').toISOString();
    }
  },
  created: function created() {
    var _this = this;

    if (this.type === 'reference' || this.type === 'references') {
      if (this.overrideValues !== null) {
        this.refOptions = [].concat(this.overrideValues);
      } else if (this.options.model) {
        this.isBusy = true;
        this.options.model.getList({
          filters: this.options.filters || {},
          sort: this.options.display || 'name'
        }).then(function (result) {
          _this.refOptions = [].concat(result.items);
          _this.isBusy = false;

          if (_this.focus) {
            _this.doFocus();
          }

          if (_this.type === 'reference' && _this.allowEmpty) {
            _this.addEmpty();
          }
        });
      } else if (typeof this.options.values === 'function') {
        this.isBusy = true;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(this.options.values(this.value)).then(function (items) {
          _this.refOptions = [].concat(items);
          _this.isBusy = false;

          if (_this.focus) {
            _this.doFocus();
          }

          if (_this.type === 'reference' && _this.allowEmpty) {
            _this.addEmpty();
          }
        });
      } else {
        this.refOptions = [].concat(this.options.values);
        if (this.type === 'reference' && this.allowEmpty) {
          this.addEmpty();
        }
      }
    }
  },
  mounted: function mounted() {
    if (this.focus) {
      this.doFocus();
    }
  },

  computed: {
    rules: function rules() {
      var _this2 = this;

      if (this.noRules) return [];
      return (this.options.rules || []).map(function (rule) {
        return rule.bind(_this2.value);
      });
    },
    small: function small() {
      return this.size === 'sm';
    },
    type: function type() {
      if (this.overrideType !== null) {
        return this.overrideType;
      }
      return this.options && this.options.type;
    },
    enumValues: function enumValues() {
      var _this3 = this;

      if (this.options.type !== 'enum') return null;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options.values).map(function (key) {
        return {
          key: key,
          text: _this3.options.values[key]
        };
      });
    },
    required: function required() {
      if (this.filter) return false;
      if (this.options.required !== undefined) {
        if (this.options.required === 'create') {
          return !this.value._self;
        }
        return this.options.required;
      }
    },
    multiEmpty: function multiEmpty() {
      if (this.type !== 'references') return false;
      return !this.value[this.field] || this.value[this.field].length === 0;
    }
  },
  methods: {
    save: function save(e) {
      this.$emit('save', e, this.value, this.field);

      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
    },
    doFocus: function doFocus() {
      if (this.$refs.input) {
        var tested = this.$refs.input.$el || this.$refs.input;
        if (typeof tested.focus === 'function') {
          tested.focus();
          setTimeout(function () {
            tested.focus();
          }, 100);
        }
      }
    },
    blur: function blur(e) {
      if (this.focus) {
        this.save();
      }
    },
    onSelect: function onSelect(items) {
      this.value[this.field] = items;
    },
    addEmpty: function addEmpty() {
      this.refOptions.unshift(null);
    },
    isValid: function isValid() {
      var _this4 = this;

      if (this.options.type === 'custom') {
        return this.$refs.input.isValid();
      }

      if (this.options.type === 'references' && this.required) {
        if (this.multiEmpty) {
          return false;
        }
      }

      if (this.options.rules.find(function (rule) {
        return rule.bind(_this4.value)(_this4.value[_this4.field]) !== true;
      })) {
        return false;
      }

      return true;
    }
  },
  components: {
    MultiListSelect: __WEBPACK_IMPORTED_MODULE_2_vue_search_select__["MultiListSelect"],
    ObjectSelect: __WEBPACK_IMPORTED_MODULE_3__ObjectSelect___default.a,
    Weekdays: __WEBPACK_IMPORTED_MODULE_4__Weekdays___default.a,
    DateRange: __WEBPACK_IMPORTED_MODULE_7__DateRange___default.a,
    DateTime: __WEBPACK_IMPORTED_MODULE_6__DateTime___default.a
  }
});

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DateTime__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DateTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DateTime__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import moment from 'moment'

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String,
    label: String,
    required: Boolean
  },
  data: function data() {
    var from = null;
    var to = null;

    if (this.value) {
      if (this.value.indexOf('|') >= 0) {
        var values = this.value.split('|');
        from = values[0];
        to = values[1];
      }
    }

    return {
      picker: false,
      from: from,
      to: to
    };
  },

  watch: {
    from: function from() {
      this.updateValue();
    },
    to: function to() {
      this.updateValue();
    },
    value: function value() {
      if (!this.value || this.value.indexOf('|') < 0) {
        this.from = null;
        this.to = null;
      }

      var values = this.value.split('|');
      this.from = values[0];
      this.to = values[1];
    }
  },
  computed: {
    displayValue: function displayValue() {
      if (this.from || this.to) {
        return (this.from ? this.$format.date(this.from) : '*') + ' - ' + (this.to ? this.$format.date(this.to) : '*');
      }
    }
  },
  methods: {
    updateValue: function updateValue() {
      var value = (this.from || '') + '|' + (this.to || '');
      this.$emit('input', value);
    },
    closePicker: function closePicker() {
      this.picker = false;
    },
    openPicker: function openPicker() {
      this.picker = true;
    }
  },
  components: {
    DateTime: __WEBPACK_IMPORTED_MODULE_0__DateTime___default.a
  }
});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: [Date, String],
    required: Boolean,
    label: String
  },
  data: function data() {
    var value = this.value;
    var date = null;
    var time = null;

    if (value) {
      date = value.split('T')[0];
      time = value.split('T')[1];
    }

    return {
      date: date,
      time: time
    };
  },

  watch: {
    date: function date() {
      this.updateValue();
    },
    time: function time() {
      this.updateValue();
    }
  },
  methods: {
    updateValue: function updateValue() {
      var updated = this.value;
      if (this.date) {
        updated = (this.date || '') + 'T' + (this.time || '00:00');
      } else {
        updated = '';
      }
      this.$emit('input', updated);
    }
  }
});

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_User__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_CompanyDelegation__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      delegations: [],
      delegation: null,
      isBusy: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__models_User__["default"].getDelegation(this.$store.auth.user, { include: ['company'] }).then(function (result) {
      _this.delegation = result;
    }).catch(function (err) {
      if (err && err.response && err.response.status !== 404) {
        console.error('Failed to fetch company delegations for delegations menu');
        console.error(err);
      }
    });

    __WEBPACK_IMPORTED_MODULE_2__models_CompanyDelegation__["a" /* default */].getList({ include: ['company'] }).then(function (result) {
      var now = __WEBPACK_IMPORTED_MODULE_3_moment___default()();

      _this.delegations = result.items.filter(function (delegation) {
        var from = __WEBPACK_IMPORTED_MODULE_3_moment___default()(delegation.dateFrom);
        var to = from.clone().add(delegation.duration, 'minutes');

        // Currently enabled, show normally, hide after expiry
        if (now.isBetween(from, to)) {
          setTimeout(function () {
            _this.delegationExpired(delegation);
          }, now.diff(to, 'seconds') * 1000);

          return true;
        }

        // Will become enabled in some time, set timeout to display it
        if (now.isAfter(from)) {
          setTimeout(function () {
            _this.delegationEnabled(delegation);
          }, from.diff(now, 'seconds') * 1000);
        }

        // Expired, hide forever
        return false;
      });
    });
  },

  methods: {
    select: function select(delegation) {
      var _this2 = this;

      this.isBusy = true;

      var updated = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$store.auth.user);
      updated.companyDelegation = delegation || {
        _self: null
      };

      return __WEBPACK_IMPORTED_MODULE_1__models_User__["default"].applyRelations(updated).then(function () {
        _this2.delegation = delegation;

        _this2.$store.auth.user.company = delegation ? delegation.company : null;
        _this2.$store.auth.user.companyDelegation = delegation;

        _this2.isBusy = false;
        _this2.$emit('change', delegation);
      }, function () {
        _this2.isBusy = false;
      });
    },
    delegationEnabled: function delegationEnabled(delegation) {
      this.delegations.push(delegation);
    },
    delegationExpired: function delegationExpired(delegation) {
      var _this3 = this;

      this.delegations.filter(function (item) {
        return item.id !== delegation.id;
      });
      if (this.delegation && this.delegation.id === delegation.id) {
        this.select(null).then(function () {
          alert(_this3.$t('delegations.expiredAlert'));
        });
      }
    }
  }
});

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    save: {
      type: Boolean,
      default: true
    },
    cancel: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    saveClick: function saveClick() {
      this.$emit('save');
    },
    cancelClick: function cancelClick() {
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_local__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      store: this.$store
    };
  },

  methods: {
    clear: function clear() {
      this.store.player.keyStored = false;
      this.store.player.passStored = false;

      __WEBPACK_IMPORTED_MODULE_0__store_local__["a" /* default */].set('private', {});
    },
    hasKey: function hasKey() {
      return this.store.player.keyStored;
    },
    hasPass: function hasPass() {
      return this.store.player.passStored;
    }
  }
});

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    loading: Boolean,
    description: String,
    size: String,
    showProgress: Boolean,
    progress: Number,
    onlyHide: Boolean
  },
  computed: {
    isSmall: function isSmall() {
      return this.size === 'small';
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    title: String
  }
});

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Crud_Crud__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Crud_Crud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Crud_Crud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_Global__ = __webpack_require__(110);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// @TODO: Maybe use mixins for crud?

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    model: Object,
    extended: Boolean,
    fields: Object,
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    editable: {
      default: true
    },
    deletable: {
      default: true
    },
    refreshable: {
      type: Boolean,
      default: true
    },
    paginating: {
      type: Boolean,
      default: true
    },
    filtering: {
      type: Boolean,
      default: true
    },
    bulk: {
      type: Boolean,
      default: true
    },
    perPage: {
      type: Number,
      default: 25
    },
    nameField: {
      type: String,
      default: 'name'
    },
    include: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fetchFilters: {
      type: Object,
      default: function _default() {}
    },
    exportable: {
      type: Boolean,
      default: true
    },
    creatable: {
      default: true
    },
    formComponent: {
      type: Object,
      default: null
    },
    formOrder: {
      type: Array,
      default: null
    },
    preSave: {
      type: Function,
      default: null
    },
    atferSave: {
      type: Function,
      default: null
    },
    defaultOrder: {
      type: String,
      default: null
    },
    defaultOrderAsc: {
      type: Boolean,
      default: true
    },
    allItemsActions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  created: function created() {
    this.refresh();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_6__utils_Global__["a" /* EventBus */].$off('refresh', this.refreshHandler);
  },
  data: function data() {
    var _this = this;

    var refreshHandler = function refreshHandler() {
      return _this.refresh();
    };

    __WEBPACK_IMPORTED_MODULE_6__utils_Global__["a" /* EventBus */].$on('refresh', refreshHandler);

    return {
      items: [],
      isBusy: true,
      page: 1,
      total: 0,
      order: this.defaultOrder || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.fields)[0],
      orderAsc: this.defaultOrderAsc,
      filters: null,
      previousFilters: null,
      formError: null,
      refreshHandler: refreshHandler,
      errorTranslations: [{
        rule: 'nesmí být null',
        message: function message() {
          return _this.$t('errors.notEmpty');
        }
      }, {
        rule: /velikost musí být mezi ([0-9]+) a [0-9]{5,}/,
        message: function message(match) {
          return _this.$t('errors.mustBeLonger', [match[1]]);
        }
      }]
    };
  },

  watch: {
    fetchFilters: 'refresh'
  },
  methods: {
    processRoleArg: function processRoleArg(arg) {
      var _this2 = this;

      if (arg === true || arg === false) return arg;
      if (Array.isArray(arg)) {
        return !!arg.find(function (role) {
          return _this2.$auth.hasRole(role);
        });
      }
      return true;
    },
    refresh: function refresh() {
      var _this3 = this;

      this.isBusy = true;
      this.model.getList(this.prepareParams()).then(function (result) {
        _this3.items = result.items;

        // Apply preprocessing if needed
        _this3.items.forEach(function (item) {
          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this3.fields).forEach(function (field) {
            var options = _this3.fields[field];
            if (options.preProcess) {
              item[field] = options.preProcess.apply(_this3, [item[field], item, field]);
            }
          });
        });

        _this3.total = result._page.totalElements;
        _this3.isBusy = false;
      });
    },
    changePage: function changePage(page) {
      this.page = page;
      this.refresh();
    },
    changeSort: function changeSort(sort, asc) {
      this.order = sort;
      this.orderAsc = asc;
      this.refresh();
    },
    saveItem: function saveItem(item, fields) {
      var _this4 = this;

      this.formError = null;

      // Only save editable items
      var updatedItem = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(item).reduce(function (result, key) {
        if (key.charAt(0) === '_' || fields.indexOf(key) >= 0) {
          result[key] = item[key];
        }
        return result;
      }, {});

      this.doSave(updatedItem, fields).catch(function (error) {
        // Reset form
        if (_this4.$refs.crud) {
          _this4.$refs.crud.saveFailed(item, fields);
        }

        var showError = false;

        // If server response contains info about invalid fields
        if (error.response && error.response.data && error.response.data.errors && error.response.status === 400) {
          // Populate errors with server response
          error.response.data.errors.forEach(function (item) {
            if (item.property && _this4.authorizedFields[item.property] && _this4.processRoleArg(_this4.authorizedFields[item.property].editable)) {
              // Try to load more user friendly message
              var message = _this4.errorTranslations.reduce(function (message, item) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(item.rule) === 'object') {
                  var match = message.match(item.rule);
                  if (match) {
                    return message.replace(item.rule, typeof item.message === 'function' ? item.message(match) : item.message);
                  }
                } else {
                  if (message === item.rule) {
                    return item.message;
                  }
                }
                return message;
              }, item.message);

              _this4.fields[item.property].errors.push(message.charAt(0).toUpperCase() + message.slice(1));
            } else if (item.property) {
              showError = true;
            }
          });
        }

        // Default error handler
        console.log(error);

        if (showError) {
          _this4.formError = _this4.$t('savingFailed') + '. ' + error;
        }
      });
    },
    doSave: function doSave(item, fields) {
      var _this5 = this;

      if (this.preSave) {
        this.preSave(item, fields);
      }

      // Create item copy
      item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);

      // Reset errors
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.fields).forEach(function (field) {
        if (_this5.fields[field].errors) {
          _this5.fields[field].errors.splice(0, _this5.fields[field].errors.length);
        }
      });

      // Apply post processing if needed
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.fields).forEach(function (field) {
        var options = _this5.fields[field];
        if (options.postProcess) {
          item[field] = options.postProcess.apply(_this5, [item[field], item, field]);
        }
      });

      if (item._links) {
        var updated = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(item).reduce(function (result, field) {
          // Only allow editable or internal fields
          /*
          if (field.charAt(0) === '_' ||
            (this.authorizedFields[field] !== undefined &&
              (this.authorizedFields[field].editable ||
              this.authorizedFields[field].editable === undefined)
            )
          ) {
            result[field] = item[field]
          }
          */

          if (field.charAt(0) === '_' || _this5.fields[field] && _this5.fields[field].type !== 'reference' && _this5.fields[field].type !== 'references' || _this5.authorizedFields[field] !== undefined && (_this5.authorizedFields[field].editable || _this5.authorizedFields[field].editable === undefined)) {
            result[field] = item[field];
          }

          return result;
        }, {});

        return this.model.update(updated).then(function (result) {
          if (_this5.$refs.crud) {
            _this5.$refs.crud.saved(item, fields);
          }
          if (_this5.atferSave) {
            return _this5.atferSave(result, item, fields);
          }
        });
      } else {
        return this.model.create(item).then(function (result) {
          if (_this5.$refs.crud) {
            _this5.$refs.crud.saved(item, fields);
          }
          _this5.refresh();
          if (_this5.atferSave) {
            return _this5.atferSave(result, item, fields);
          }
        });
      }
    },
    removeItems: function removeItems(items) {
      var _this6 = this;

      if (confirm('Opravdu chcete smazat ' + items.map(function (item) {
        return item[_this6.nameField];
      }).join(', ') + '?')) {
        items.forEach(function (item) {
          var removed = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);

          __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(_this6.fields).forEach(function (field) {
            var options = _this6.fields[field];
            if (options.postProcess) {
              removed[field] = options.postProcess.apply(_this6, [removed[field], removed, field]);
            }
          });

          _this6.model.delete(removed);

          var index = _this6.items.findIndex(function (sub) {
            return sub._self === removed._self;
          });
          if (index >= 0) {
            _this6.items.splice(index, 1);
          } else {
            console.warn('Failed to remove item', removed, _this6.items);
          }
        });
      }
    },
    changeFilters: function changeFilters(filters) {
      this.filters = filters;

      if (this.$refs.crud && this.previousFilters !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filters)) {
        this.previousFilters = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filters);
        if (this.page !== 1) {
          this.$refs.crud.changePage(1);
        } else {
          this.refresh();
        }
      }
    },
    mapToIds: function mapToIds(items) {
      return items.map(function (item) {
        return item._self.split('/').filter(function (item) {
          return item.length > 0;
        }).pop();
      });
    },
    parseRangeDate: function parseRangeDate(input, def) {
      if (input.length === 0) {
        return def || 0;
      } else {
        return Math.round(__WEBPACK_IMPORTED_MODULE_5_moment___default()(input).toDate().getTime());
      }
    },
    prepareParams: function prepareParams() {
      var params = {
        include: this.include,
        filters: this.fetchFilters || {},
        page: this.page - 1,
        size: this.perPage

        // Make sure we have a copy of fetchFilters
      };params.filters = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, params.filters);

      if (this.order) {
        params.sort = this.order + ',' + (this.orderAsc ? 'asc' : 'desc');
      }

      if (this.extended) {
        params.projection = 'extended';
      }

      // If there are any filters defined
      if (this.filters) {
        for (var field in this.filters) {
          // Load value and field options
          var options = this.authorizedFields[field];
          var value = this.filters[field];

          // If it's authorized field and has filter value
          if (options && value !== null && value !== undefined && value.length !== 0) {
            // Classic text parameter
            if (options.type === undefined || options.type === 'text') {
              params.filters[field] = '[LIKE]' + this.filters[field];
            }

            // Date range
            if (options.type === 'date') {
              var values = value.split('|');
              var from = this.parseRangeDate(values[0]);
              var to = this.parseRangeDate(values[1], new Date().getTime());

              params.filters[field] = '[BETWEEN]' + from + '-' + to;
            }

            // Enum values are mapped as _self
            if (options.type === 'enum') {
              params.filters[field] = '[IN]' + value.map(function (item) {
                return item._self;
              }).join(',');
            }

            // We need to extract id for references
            if (options.type === 'reference' || options.type === 'references') {
              params.filters[field + '.id'] = '[IN]' + this.mapToIds(value).join(',');
            }

            if (options.type === 'bool' && value !== undefined) {
              params.filters[field] = value ? 'true' : 'false';
            }
          }
        }
      }

      return params;
    },
    requestAllItems: function requestAllItems(filters) {
      var _this7 = this;

      var params = this.prepareParams();
      params.size = 99999999;
      params.page = 0;

      this.isBusy = true;
      return this.model.getList(params).then(function (result) {
        _this7.isBusy = false;
        return result.items;
      });
    },
    cancelItem: function cancelItem() {
      this.formError = null;
    }
  },
  computed: {
    authorizedFields: function authorizedFields() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(this.fields).reduce(function (fields, field) {
        var options = _this8.fields[field];

        if (options.editable && Array.isArray(options.editable)) {
          options.editable = _this8.$auth.hasRole(options.editable);
        }

        if (!options.roles && !options.role) {
          fields[field] = options;
        }

        if (options.role && _this8.$auth.hasRole(options.role)) {
          fields[field] = options;
        }

        if (options.roles && _this8.$auth.hasRole(options.roles)) {
          fields[field] = options;
        }

        return fields;
      }, {});
    }
  },
  components: {
    Crud: __WEBPACK_IMPORTED_MODULE_4__Crud_Crud___default.a
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavigationItem__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NavigationItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__NavigationItem__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var $t = function $t(title) {
      return _this.$t(title);
    };

    return {
      updateIndex: 0,
      items: [{ divider: true }, { title: $t('titles.dashboard'), icon: 'dashboard', href: '/', roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN', 'COMPANY_USER'] }, { title: $t('titles.recordings'), icon: 'view_list', href: '/recordings', roles: ['COMPANY_ADMIN', 'COMPANY_USER'], ignoreDelegations: true }, {
        title: $t('titles.admin.title'),
        icon: 'work',
        active: false,
        roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'],
        items: [{ title: $t('titles.admin.users'), icon: 'account_box', href: '/admin/users', roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'] }, { title: $t('titles.admin.companies'), icon: 'receipt', href: '/admin/companies', roles: ['GROUP_ADMIN'] }, { title: $t('titles.admin.companyGroups'), icon: 'group', href: '/admin/company-groups', roles: ['SUPER_ADMIN'] }, { title: $t('titles.admin.companyDelegations'), icon: 'account_box', href: '/admin/company-delegations', roles: ['COMPANY_ADMIN'], ignoreDelegations: true }, { title: $t('titles.admin.lines'), icon: 'phone', href: '/admin/lines', roles: ['GROUP_ADMIN', 'COMPANY_ADMIN'] }, { title: $t('titles.admin.lineGroups'), icon: 'phone', href: '/admin/lineGroups', roles: ['COMPANY_ADMIN'] }, { title: $t('titles.admin.numbers'), icon: 'filter_none', href: '/admin/numbers', roles: ['COMPANY_ADMIN'] }, { title: $t('titles.admin.tags'), icon: 'label', href: '/admin/tags', roles: ['COMPANY_ADMIN'] }, { title: $t('titles.admin.configuration'), icon: 'settings_input_component', href: '/admin/configuration', roles: ['COMPANY_ADMIN'] }]
      }, {
        title: $t('titles.reports.title'),
        roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'],
        items: [{ title: $t('titles.reports.accesses'), icon: 'view_list', href: '/reports/accesses' }, { title: $t('titles.reports.dataChanges'), icon: 'view_list', href: '/reports/data-changes' }, { title: $t('titles.reports.systemStorage'), icon: 'pie_chart', href: '/reports/system-storage', roles: ['SUPER_ADMIN'] }, { title: $t('titles.reports.logicStorage'), icon: 'pie_chart', href: '/reports/logic-storage', roles: ['GROUP_ADMIN', 'COMPANY_ADMIN'] }, { title: $t('titles.reports.notifications'), icon: 'info', href: '/reports/notifications', roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'] }]
      }, { divider: true, className: 'mt-5' }, { title: $t('titles.profile'), icon: 'account_circle', href: '/profile' }, { title: $t('titles.logout'), icon: 'exit_to_app', href: '/logout' }]
    };
  },

  methods: {
    refresh: function refresh() {
      this.updateIndex++;
    }
  },
  components: {
    NavigationItem: __WEBPACK_IMPORTED_MODULE_0__NavigationItem___default.a
  }
});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_Global__ = __webpack_require__(110);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    item: Object,
    group: Boolean
  },
  methods: {
    route: function route() {
      if (this.$route.fullPath === this.item.href) {
        __WEBPACK_IMPORTED_MODULE_0__utils_Global__["a" /* EventBus */].$emit('refresh');
      } else {
        this.$router.push(this.item.href);
      }
    }
  },
  computed: {
    authorized: function authorized() {
      if (this.item.role) {
        return this.$auth.hasRole(this.item.role, this.item.ignoreDelegations);
      }
      if (this.item.roles) {
        return this.$auth.hasRole(this.item.roles, this.item.ignoreDelegations);
      }
      return true;
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: Object,
    options: Array,
    size: {
      type: String,
      default: 'md'
    },
    idField: {
      type: String,
      default: '_self'
    },
    nameField: {
      type: String,
      default: 'name'
    },
    label: String,
    required: Boolean
  },
  data: function data() {
    var _this = this;

    return {
      localIndex: this.value && this.options.findIndex(function (item) {
        return item[_this.idField] === _this.value[_this.idField];
      })
    };
  },

  watch: {
    localIndex: function localIndex() {
      var value = this.options[this.localIndex];
      this.$emit('input', value);
    },
    options: function options() {
      var _this2 = this;

      this.localIndex = this.value && this.options.findIndex(function (item) {
        return item[_this2.idField] === _this2.value[_this2.idField];
      });
    }
  },
  computed: {
    normalizedOptions: function normalizedOptions() {
      var _this3 = this;

      return this.options.map(function (item, index) {
        return {
          index: index,
          text: item[_this3.nameField]
        };
      });
    }
  },
  methods: {
    focus: function focus() {
      this.$refs.select.focus();
    },
    blur: function blur() {
      this.$emit('blur');
    }
  }
});

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PasswordInput__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PasswordInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PasswordInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    error: String,
    complexity: Number
  },
  data: function data() {
    return {
      passwords: {
        updated: null,
        updated2: null
      }
    };
  },

  methods: {
    save: function save() {
      if (!this.$refs.password.isValid() || !this.$refs.passwordAgain.isValid()) {
        return;
      }

      this.$emit('save', this.passwords.updated);
    }
  },
  components: {
    PasswordInput: __WEBPACK_IMPORTED_MODULE_0__components_PasswordInput___default.a
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zxcvbn__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zxcvbn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zxcvbn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String,
    label: String,
    required: Boolean,
    options: Object,
    field: String,
    model: Object,
    filter: Boolean,
    minLevel: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    var self = this;

    return {
      input: this.value,
      errors: [],
      info: null,
      rules: [function (value) {
        if (self.options.otherPassword) {
          if (value && value !== self.model[self.options.otherPassword]) {
            return self.$t('user.passwordsMustMatch');
          }
        }
        return true;
      }, function (value) {
        if (value) {
          var info = __WEBPACK_IMPORTED_MODULE_0_zxcvbn__(value);

          // Load minimum complexity for logged user
          var minimum = self.minLevel !== null ? self.minLevel : self.$store.auth.user && self.$store.auth.user.passwordComplexity || 2;

          // Updated minimum level using values in company form
          if (self.model.passwordComplexity) {
            minimum = self.model.passwordComplexity;
          }

          // Save the info to display
          self.updateMeter(info);

          if (info.score < minimum) {
            return self.$t('user.passwordIsTooWeak');
          }
        } else {
          self.updateMeter({ score: -1 });
        }
        return true;
      }]
    };
  },

  watch: {
    input: function input() {
      this.$emit('input', this.input);
    },
    value: function value() {
      this.input = this.value;
    }
  },
  methods: {
    blur: function blur() {
      this.$emit('blur');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    updateMeter: function updateMeter(info) {
      this.info = info;
    },
    isValid: function isValid() {
      var _this = this;

      return !this.rules.find(function (rule) {
        return rule(_this.input) !== true;
      });
    }
  }
});

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_chartjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__);



/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["Pie"].extend({
  props: ['chartData', 'options'],
  mixins: [__WEBPACK_IMPORTED_MODULE_0_vue_chartjs__["mixins"].reactiveProp],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options || {});
  }
}));

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Record__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_local__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Decoder__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_Downloader__ = __webpack_require__(209);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var codecTypeExt = {
  PCM: 'wav',
  FLAC: 'flac',
  MP3: 'mp3',
  G711: 'wav'
};

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    // Database object containing all informations about recording that is supposed to be played
    record: Object
  },
  data: function data() {
    return {
      // Indicates if this dialog is shown
      shown: false,

      // Current time in recording player
      currentTime: 0,
      // Indicates time, which was naturally updated when playing (not user seeked)
      updating: null,
      // Indicates if player can play current recording
      canPlay: false,
      // Indicates if recording is paused
      paused: true,
      // Recording playback volume (0-100)
      volume: 100,

      // URL to recording decrypted contents
      recording: null,
      // Blob with recording decrypted contents
      recordingBlob: null,

      // Contents of private key form input
      privateKeyForm: null,
      // Saved private key contents
      privateKey: null,
      // Saved private key passphrase
      privateKeyPass: null,

      // Used to indicate if user wants to save private key
      saveKey: true,
      // Used to indicate if user wants to save passphrase
      saveKeyPass: false,

      // List of issues with private key
      privateKeyErrors: [],
      // List of issues with passphrase
      privateKeyPassErrors: [],

      // Indicates if we're currently decoding recording
      decoding: false,

      // Indicates if this dialog was opened to only download recording, not play it, in witch case it will close upon decoding file
      downloadOnly: false,

      // Cointains error message, if there's fatal unresolvable error when decoding/downloading recording
      fatalError: null
    };
  },

  watch: {
    /**
     * Changes when user tries to play new recording
     */
    record: function record() {
      // Only do something when we actually have recording to play
      if (this.record) {
        // When the recording is encrypted, we need key and passphrase before doing anything
        if (this.record.encrypted) {
          // Try to load stored key and passphrase
          var stored = __WEBPACK_IMPORTED_MODULE_2__store_local__["a" /* default */].get('private');

          // If there're stored key/passphrase, try to decrypt
          if (stored && stored.key) {
            // This is used to warn user about having saved key/passhrase
            this.$store.player.keyStored = true;
            if (stored.pass) {
              this.$store.player.passStored = true;
            }

            // Load private key and passphrase from store
            this.privateKey = this.privateKeyForm = stored.key;
            this.privateKeyPass = stored.pass;

            // Try to decrypt recording
            this.decode();
          } else {
            // Make sure form input is empty
            this.privateKeyForm = null;
          }
        } else {
          // Unencrypted recording only needs to be downloaded and converted
          this.decode();
        }
      } else {
        // Clear data, when no record is to be played
        this.privateKey = null;
        this.privateKeyPass = null;
        this.recording = null;
      }
    },


    /**
     * Changes when URL to decoded recording changes
     */
    recording: function recording() {
      if (this.$refs.player) {
        this.$refs.player.load();
      }
    },


    /**
     * Changes when user changes volume
     */
    volume: function volume() {
      if (this.$refs.player) {
        this.$refs.player.volume = this.volume / 100;
      }
    },


    /**
     * Changes when visibility of this dialog changes
     */
    shown: function shown() {
      if (!this.shown) {
        this.$emit('closed');
      } else {
        this.$emit('opened');
      }
    }
  },
  computed: {
    /**
     * Computes correct mime type for recording.
     */
    audioType: function audioType() {
      if (!this.record) return 'audio/x-wav';

      switch (this.record.codecType) {
        case 'MP3':
          return 'audio/mpeg';
        case 'FLAC':
          return 'audio/flac';
        case 'PCM':
        case 'G711':
        default:
          return 'audio/x-wav';
      }
    }
  },
  methods: {
    /**
     * Starts recording playback
     */
    play: function play() {
      this.$refs.player.play();
    },


    /**
     * Pauses recording playback.
     */
    pause: function pause() {
      this.$refs.player.pause();
    },


    /**
     * Pauses recording playback and seeks to start.
     */
    stop: function stop() {
      this.$refs.player.pause();
      this.$refs.player.currentTime = 0;
    },


    /**
     * Tries to download current recording. Called when users click on download button.
     */
    download: function download() {
      var _this = this;

      // Make copy of db record, because we will be modifying it
      var item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.record);

      // Change extension to decrypted value
      item.fileName = __WEBPACK_IMPORTED_MODULE_1__models_Record__["a" /* default */].getBasename(item) + '.' + (codecTypeExt[item.codecType] || 'wav');
      // Save blob data, downloader will know what to do
      item.blob = this.recordingBlob;

      // This creates archive with recording metadata and forces user to download it
      __WEBPACK_IMPORTED_MODULE_4__utils_Downloader__["a" /* default */].downloadRecordings([item], __WEBPACK_IMPORTED_MODULE_1__models_Record__["a" /* default */].getBasename(item) + '.zip').catch(function (error) {
        console.error('[Player]', 'Downloading failed');
        console.error(error);

        _this.fatalError = _this.$t('player.loadingFailed');
      });

      this.hide();
    },


    /**
     * Shows player dialog.
     * @param {boolean} downloadOnly if the dialog should only download recording, not play it
     */
    show: function show(downloadOnly) {
      this.paused = true;
      this.volume = 100;
      this.currentTime = 0;
      this.canPlay = false;
      this.downloadOnly = downloadOnly || false;
      this.shown = true;
      this.fatalError = null;
    },


    /**
     * Hides this dialog
     */
    hide: function hide() {
      this.shown = false;
      this.privateKey = null;
      this.privateKeyPass = null;
      this.recording = null;
      this.fatalError = null;
    },


    /**
     * Seeks in recording.
     * @param {number} value
     */
    changeTime: function changeTime(value) {
      if (value !== Math.floor(this.updating) && this.$refs.player.duration) {
        this.$refs.player.currentTime = value / 100 * this.$refs.player.duration;
      }
    },


    /**
     * Called when time moves in player.
     */
    timeUpdated: function timeUpdated() {
      if (this.$refs.player) {
        this.currentTime = this.updating = this.$refs.player.currentTime / this.$refs.player.duration * 100;
      }
    },


    /**
     * Called when user saves private key.
     */
    applyKey: function applyKey() {
      this.privateKey = this.privateKeyForm;

      // Save key if prompted
      if (this.saveKey) {
        this.$store.player.keyStored = true;

        // Save key to local storage
        __WEBPACK_IMPORTED_MODULE_2__store_local__["a" /* default */].set('private', {
          key: this.privateKey,
          pass: null,
          username: this.$store.auth.username
        });
      }
    },
    applyPass: function applyPass() {
      // Save passphrase if prompted
      if (this.saveKeyPass) {
        this.$store.player.passStored = true;

        var saved = __WEBPACK_IMPORTED_MODULE_2__store_local__["a" /* default */].get('private');
        saved.pass = this.privateKeyPass;
        __WEBPACK_IMPORTED_MODULE_2__store_local__["a" /* default */].set('private', saved);
      }

      // Last user step, now try to decode the recording
      this.decode();
    },


    /**
     * Called when recording is encrypted and all required fields are entered.
     */
    decode: function decode() {
      var _this2 = this;

      this.decoding = true;

      __WEBPACK_IMPORTED_MODULE_3__utils_Decoder__["a" /* default */].decode(this.record, this.privateKey, this.privateKeyPass, this.downloadOnly ? 'download' : 'play').then(function (result) {
        // Save for downloading purposes
        _this2.recordingBlob = result;

        if (_this2.downloadOnly) {
          _this2.download();
        } else {
          // This is used in audio tag
          _this2.recording = window.URL.createObjectURL(_this2.recordingBlob);
        }
      }).catch(function (error) {
        console.log('[Player]', 'Error caught when decoding recording:', error);

        _this2.decoding = false;

        // Key is invalid, prompt user to enter valid key
        if (error instanceof __WEBPACK_IMPORTED_MODULE_3__utils_Decoder__["b" /* InvalidKeyException */]) {
          _this2.privateKeyErrors = [_this2.$t('player.wrongKey')];
          _this2.privateKey = null;

          return;
        }

        // Passphrase is invalid, prompt user to enter correct passphrase
        if (error instanceof __WEBPACK_IMPORTED_MODULE_3__utils_Decoder__["c" /* InvalidPassphraseException */]) {
          _this2.privateKeyPassErrors = [_this2.$t('player.keyRequiresPass')];
          _this2.privateKeyPass = null;

          return;
        }

        // Failed to load recording data
        if (error instanceof __WEBPACK_IMPORTED_MODULE_3__utils_Decoder__["d" /* FileNotFoundException */]) {
          _this2.fatalError = _this2.$t('player.loadingFailed');

          return;
        }

        // Unknown error occured
        if (error instanceof __WEBPACK_IMPORTED_MODULE_3__utils_Decoder__["e" /* DecodingFailedException */]) {
          alert(_this2.$t('player.playError', [_this2.record.codecType || 'WAV']));

          return;
        }
      });
    },


    /**
     * Clears all user data.
     */
    clearKey: function clearKey() {
      this.privateKey = null;
      this.privateKeyForm = null;
      this.privateKeyPass = null;
      this.saveKey = false;
      this.recording = null;

      this.$store.player.keyStored = false;
      this.$store.player.passStored = false;

      __WEBPACK_IMPORTED_MODULE_2__store_local__["a" /* default */].set('private', {});
    },


    /**
     * Handles files dropping on this dialog. Used for entering private keys.
     * @param {any} ev
     */
    drop: function drop(ev) {
      var data = ev.dataTransfer;
      if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].kind === 'file') {
            this.readFile(data.items[i].getAsFile());
            ev.preventDefault();
            break;
          }
        }
      } else {
        this.readFile(data.files[0]);
        ev.preventDefault();
      }
    },


    /**
     * Handles file input. Used for entering private keys.
     */
    fileChanged: function fileChanged() {
      if (this.$refs.file.files && this.$refs.file.files.length === 1) {
        this.readFile(this.$refs.file.files[0]);
      }
    },


    /**
     * Reads contents of specified file and saves it as private key.
     * @param {any} file
     */
    readFile: function readFile(file) {
      var _this3 = this;

      var reader = new FileReader();
      reader.onload = function () {
        _this3.privateKeyForm = reader.result;
      };
      reader.readAsText(file);
    },


    /**
     * Error occured when trying to play file.
     * @param {any} e
     */
    playError: function playError(e) {
      alert(this.$t('player.playError', [this.record.codecType || 'WAV']));
      this.hide();
    }
  }
});

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Access__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ModelCrud__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_0__models_Access__["a" /* default */],
      fetchFilters: {
        'username': '[EQ]' + this.$store.auth.username
      },
      fields: {
        ipAddress: {
          label: this.$t('headers.ipAddress')
        },
        browser: {
          label: this.$t('headers.browser')
        },
        actionDate: {
          label: this.$t('headers.date'),
          type: 'date'
        },
        actionType: {
          label: this.$t('headers.actionType')
        }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_1__components_ModelCrud___default.a
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_UserCertificate__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      shown: false,
      isBusy: false,
      name: null,
      certificate: null,
      enabled: true,
      original: null,
      keyRules: [function (value) {
        if (!value) return true;
        return (/-----BEGIN PGP PUBLIC KEY BLOCK-----([^]*?)-----END PGP PUBLIC KEY BLOCK-----/.test(value) ? true : _this.$t('configuration.basic.invalidKey')
        );
      }]
    };
  },

  methods: {
    show: function show(original) {
      this.original = original || null;
      this.$refs.file.value = null;
      this.name = this.original ? this.original.name : null;
      this.certificate = null;
      this.enabled = this.original ? this.original.enabled : true;
      this.shown = true;
    },
    save: function save() {
      var _this2 = this;

      this.isBusy = true;
      this.doSave().then(function (item) {
        _this2.$emit('saved', item);
        _this2.isBusy = false;
        _this2.shown = false;
      }).catch(function (error) {
        console.error(error);

        _this2.isBusy = false;

        if (error.response.data && error.response.data.errors) {
          if (error.response.data.errors.find(function (err) {
            return err.property === 'certificate';
          })) {
            alert(_this2.$t('configuration.basic.invalidKey'));
            return;
          }
        }

        console.error(error.response);

        alert(_this2.$t('savingFailed'));
      });
    },
    doSave: function doSave() {
      if (this.original) {
        this.original.name = this.name;
        this.original.enabled = this.enabled;
        return __WEBPACK_IMPORTED_MODULE_0__models_UserCertificate__["a" /* default */].update(this.original, ['name', 'enabled']);
      } else {
        return __WEBPACK_IMPORTED_MODULE_0__models_UserCertificate__["a" /* default */].create({
          name: this.name,
          certificate: this.certificate,
          enabled: this.enabled
        });
      }
    },
    drop: function drop(ev) {
      var data = ev.dataTransfer;
      if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].kind === 'file') {
            this.readFile(data.items[i].getAsFile());
            ev.preventDefault();
            break;
          }
        }
      } else {
        this.readFile(data.files[0]);
        ev.preventDefault();
      }
    },
    fileChanged: function fileChanged() {
      if (this.$refs.file.files && this.$refs.file.files.length === 1) {
        this.readFile(this.$refs.file.files[0]);
      }
    },
    readFile: function readFile(file) {
      var _this3 = this;

      var reader = new FileReader();
      reader.onload = function () {
        if (!_this3.name) {
          _this3.name = file.name;
        }
        _this3.certificate = reader.result;
      };
      reader.readAsText(file);
    }
  }
});

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CertificateForm__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CertificateForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CertificateForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_UserCertificate__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  data: function data() {
    return {
      certFormItem: null
    };
  },

  methods: {
    add: function add() {
      this.certFormItem = null;
      this.$refs.certForm.show(null);
    },
    saved: function saved(cert) {
      if (this.certFormItem === null) {
        this.value.userCertificates.push(cert);
      }
      this.certFormItem = null;
    },
    edit: function edit(item) {
      this.certFormItem = item;
      this.$refs.certForm.show(item);
    },
    remove: function remove(item) {
      __WEBPACK_IMPORTED_MODULE_1__models_UserCertificate__["a" /* default */].delete(item);

      var index = this.value.userCertificates.findIndex(function (cert) {
        return cert._self === item._self;
      });
      if (index >= 0) {
        this.value.userCertificates.splice(index, 1);
      }
    }
  },
  components: {
    CertificateForm: __WEBPACK_IMPORTED_MODULE_0__CertificateForm___default.a
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_User__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  data: function data() {
    return {
      saved: false
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0__models_User__["default"].update(this.value, ['username', 'role', 'name', 'surname', 'email']).then(function (result) {
        _this.$store.auth.user.name = _this.value.name;
        _this.$store.auth.user.surname = _this.value.surname;
        _this.$store.auth.user.email = _this.value.email;

        _this.saved = true;
        setTimeout(function () {
          _this.saved = false;
        }, 3000);
      }).catch(function (error) {
        console.error(error);
        alert(_this.$t('savingFailed'));
      });
    }
  }
});

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_User__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PasswordInput__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PasswordInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PasswordInput__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  data: function data() {
    var self = this;
    return {
      saved: false,
      original: null,
      passwords: {
        updated: null,
        udpated2: null
      },
      rules: {
        original: function original(value) {
          return value && value.length > 0 && value !== self.$store.auth.password ? self.$t('profile.password.wrongOriginalPassword') : true;
        }
      }
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      if (this.original !== this.$store.auth.password) {
        alert(this.$t('profile.password.wrongOriginalPassword'));
        return;
      }
      if (this.passwords.updated !== this.passwords.updated2) return;
      if (!this.$refs.first.isValid() || !this.$refs.second.isValid()) return;

      __WEBPACK_IMPORTED_MODULE_0__models_User__["default"].setPassword({
        password: this.passwords.updated
      }).then(function () {
        _this.$store.auth.password = _this.passwords.updated;

        _this.original = null;
        _this.passwords.updated = null;
        _this.passwords.updated2 = null;

        _this.saved = true;
        setTimeout(function () {
          _this.saved = false;
        }, 3000);
      }).catch(function (error) {
        console.error(error);
        alert(_this.$t('savingFailed'));
      });
    }
  },
  components: {
    PasswordInput: __WEBPACK_IMPORTED_MODULE_1__components_PasswordInput___default.a
  }
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    value: String,
    label: String,
    name: Boolean,
    required: Boolean
  },
  data: function data() {
    var _this = this;

    return {
      rules: [function (value) {
        if (!value) return true;
        return (/-----BEGIN PGP PUBLIC KEY BLOCK-----([^]*?)-----END PGP PUBLIC KEY BLOCK-----/.test(value) ? true : _this.$t('configuration.basic.invalidKey')
        );
      }]
    };
  },

  methods: {
    drop: function drop(ev) {
      var data = ev.dataTransfer;
      if (data.items) {
        for (var i = 0; i < data.items.length; i++) {
          if (data.items[i].kind === 'file') {
            this.readFile(data.items[i].getAsFile());
            ev.preventDefault();
            break;
          }
        }
      } else {
        this.readFile(data.files[0]);
        ev.preventDefault();
      }
    },
    fileChanged: function fileChanged() {
      if (this.$refs.file.files && this.$refs.file.files.length === 1) {
        this.readFile(this.$refs.file.files[0]);
      }
    },
    readFile: function readFile(file) {
      var _this2 = this;

      var reader = new FileReader();
      reader.onload = function () {
        _this2.$emit('input', reader.result);
      };
      reader.readAsText(file);
    }
  }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_RecordingRequest__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_RecordingRequest__["a" /* default */],
      fields: {
        created: {
          label: this.$t('headers.changeDate'),
          type: 'date'
        },
        user: {
          type: 'reference',
          model: __WEBPACK_IMPORTED_MODULE_2__models_User__["default"],
          label: this.$t('headers.user')
        },
        _src: {
          filterable: false,
          label: this.$t('headers.source')
        },
        _dst: {
          filterable: false,
          label: this.$t('headers.destination')
        },
        operation: {
          type: 'enum',
          values: __WEBPACK_IMPORTED_MODULE_1__models_RecordingRequest__["a" /* default */].enums.operation,
          label: this.$t('headers.operation')
        },
        _actions: {
          label: '',
          filterable: false
        }
      }
    };
  },

  methods: {
    approve: function approve(item) {
      item.approved = true;
      __WEBPACK_IMPORTED_MODULE_1__models_RecordingRequest__["a" /* default */].update(item, ['approved']);
    },
    deny: function deny(item) {
      __WEBPACK_IMPORTED_MODULE_1__models_RecordingRequest__["a" /* default */].delete(item);
    }
  },
  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Player__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Player__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tagger__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Tagger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Tagger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_Record__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Tag__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_Line__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_FileSystem__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_Downloader__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__models_RecordingRequest__ = __webpack_require__(206);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    paginating: Boolean,
    filtering: Boolean,
    exportable: Boolean,
    bulk: Boolean,
    actions: Boolean,
    perPage: {
      type: Number,
      default: 19
    }
  },
  data: function data() {
    var _this = this;

    return {
      model: __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */],
      include: [],
      fields: {
        target: { label: this.$t('headers.target'), type: 'reference', model: __WEBPACK_IMPORTED_MODULE_7__models_Line__["a" /* default */] },
        callDate: { label: this.$t('headers.callDate'), type: 'date' },
        source: { label: this.$t('headers.source') },
        destination: { label: this.$t('headers.destination') },
        duration: { label: this.$t('headers.duration'), type: 'interval' },
        direction: { label: this.$t('headers.direction'), type: 'enum', values: __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].enums.direction },
        state: { label: this.$t('headers.state'), type: 'enum', values: __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].enums.state },
        tags: { label: this.$t('headers.tags'), type: 'references', model: __WEBPACK_IMPORTED_MODULE_6__models_Tag__["a" /* default */], display: 'tagName' },
        actions: { label: '', editable: false, filterable: false, exportable: false }
      },
      bulkActions: [{
        single: false,
        multi: true,
        multiLabel: this.$t('recordings.downloadSelected'),
        icon: 'get_app',
        action: function action(items) {
          _this.downloadItems(items);
        }
      }, {
        single: false,
        multi: true,
        multiLabel: this.$t('recordings.deleteSelected'),
        icon: 'delete',
        color: 'error',
        action: function action(items) {
          _this.deleteItems(items);
        }
      }],
      allItemsActions: [{
        multiLabel: this.$t('recordings.deleteFiltered'),
        icon: 'delete',
        color: 'error',
        action: function action(items) {
          _this.deleteItems(items, false);
        }
      }],
      playerRecord: null,
      taggerRecord: null,
      loading: null,
      showRequest: false,
      requestOperation: null,
      requestItem: null,
      isDownloading: false,
      downloadProgress: null,
      isDeleting: false,
      deleteProgress: null
    };
  },

  computed: {
    recordingsConfirmations: function recordingsConfirmations() {
      return !this.$auth.hasRole('COMPANY_ADMIN') && this.$store.auth.user.company.recordingsConfirmations;
    }
  },
  methods: {
    play: function play(item) {
      this.playerRecord = item;
      this.$refs.player.show();
    },
    deleteItems: function deleteItems(items) {
      var _this2 = this;

      var onlySelected = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var userPrompt, index, batchSize;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                userPrompt = prompt(onlySelected ? _this2.$t('recordings.deleteSelectedPrompt') : _this2.$t('recordings.deleteFilteredPrompt', { number: items.length }), '').toLowerCase();

                if (!(userPrompt !== (onlySelected ? 'delete selected' : 'delete filtered'))) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                _this2.loading = _this2.$t('recordings.deleting');
                _this2.isDeleting = true;
                _this2.deleteProgress = 0;

                index = 0;

              case 7:
                if (!(index < items.length)) {
                  _context.next = 25;
                  break;
                }

                _this2.deleteProgress = Math.round(index / items.length * 100);
                batchSize = Math.min(items.length - index, 50);

                if (!(batchSize > 0)) {
                  _context.next = 22;
                  break;
                }

                _context.prev = 11;
                _context.next = 14;
                return __WEBPACK_IMPORTED_MODULE_8__models_FileSystem__["a" /* default */].archiveRecordings(items.slice(index, index + batchSize).map(function (item) {
                  return item.id;
                }));

              case 14:
                _context.next = 19;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](11);

                console.error('Failed to delete recordings', _context.t0);

              case 19:

                index += batchSize;
                _context.next = 23;
                break;

              case 22:
                return _context.abrupt('break', 25);

              case 23:
                _context.next = 7;
                break;

              case 25:

                _this2.loading = null;
                _this2.isDeleting = false;
                _this2.deleteProgress = null;

                _this2.$refs.crud.refresh();

              case 29:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[11, 16]]);
      }))();
    },
    download: function download(item) {
      // Encrypted items should be decrypted first
      if (item.encrypted) {
        this.playerRecord = item;
        this.$refs.player.show(true);
      } else {
        // Plain recordings use same logic as batch download, just with different output name
        this.downloadItems([item], __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].getBasename(item) + '.zip');
      }
    },


    /**
     * Downloads recordings.
     * NOTE: Encrypted recordings are NOT decrypted when downloaded in batch.
     *
     * @param {Object[]} items recordings to download
     * @param {string} filename filename of resulting archive
     */
    downloadItems: function downloadItems(items, filename) {
      var _this3 = this;

      this.loading = this.$t('recordings.downloading');

      this.isDownloading = true;
      this.downloadProgress = 0;

      __WEBPACK_IMPORTED_MODULE_9__utils_Downloader__["a" /* default */].downloadRecordings(items, filename, function (downloaded, total) {
        _this3.downloadProgress = Math.floor(downloaded / total * 100);
      }).then(function (result) {
        _this3.isDownloading = false;
        _this3.loading = null;
      }).catch(function () {
        _this3.isDownloading = false;
        _this3.loading = null;
      });
    },
    downloadMetadata: function downloadMetadata(item) {
      __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].getMetadata(item).then(function (data) {
        var blob = new Blob([data], { type: 'text/plain' });

        __WEBPACK_IMPORTED_MODULE_9__utils_Downloader__["a" /* default */].download(__WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].getBasename(item) + '.txt', blob);
      });
    },
    tag: function tag(item) {
      this.taggerRecord = item;
      this.$refs.tagger.show();
    },
    saveTags: function saveTags(tags, item) {
      item.tags = tags;
      __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].saveTags(item);
    },
    colorize: function colorize(tag) {
      return '#' + this.intToARGB(this.hashCode(tag._self));
    },
    hashCode: function hashCode(str) {
      var hash = 0;
      for (var i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
      }
      return hash;
    },
    intToARGB: function intToARGB(i) {
      function normalize(c) {
        return Math.round(128 + c / 255 * 127);
      }

      return normalize(i >> 16 & 0xFF).toString(16) + normalize(i >> 8 & 0xFF).toString(16) + normalize(i & 0xFF).toString(16);
    },
    playerClosed: function playerClosed() {
      this.playerRecord = null;
    },
    isPlayable: function isPlayable(item) {
      return __WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].isPlayable(item);
    },
    archive: function archive(item) {
      if ((prompt(this.$t('recordings.deletePrompt')) || '').toLowerCase() !== 'delete') return;

      return __WEBPACK_IMPORTED_MODULE_8__models_FileSystem__["a" /* default */].archiveRecording(item.id).then(function () {
        item.archived = true;
      });
    },
    request: function request(item, operation) {
      this.showRequest = true;
      this.requestOperation = operation;
      this.requestItem = item;
    },
    doRequest: function doRequest() {
      __WEBPACK_IMPORTED_MODULE_10__models_RecordingRequest__["a" /* default */].create({
        recording: this.requestItem,
        operation: this.requestOperation,
        user: this.$store.auth.user,
        created: new Date()
      });
      this.showRequest = false;
    },
    formatReason: function formatReason(item) {
      var _this4 = this;

      if (!item.reason) return this.$t(__WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].enums.reason.UNKNOWN);

      var data = void 0;
      try {
        data = JSON.parse(data);
      } catch (e) {
        return this.$t(__WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].enums.reason.UNKNOWN);
      }

      return data.reasons.map(function (item) {
        return _this4.$t(__WEBPACK_IMPORTED_MODULE_5__models_Record__["a" /* default */].enums.reason[item.reason], item);
      }).join('<br />');
    }
  },
  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_2__components_ModelCrud___default.a,
    Player: __WEBPACK_IMPORTED_MODULE_3__components_Player___default.a,
    Tagger: __WEBPACK_IMPORTED_MODULE_4__components_Tagger___default.a
  }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PieChart__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Company__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_CompanyGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LogicStorageReport_TargetsReport__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LogicStorageReport_TargetsReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LogicStorageReport_TargetsReport__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    size: {
      type: Number,
      default: 300
    },
    small: Boolean
  },
  data: function data() {
    var self = this;

    return {
      groups: null,
      filter: null,
      filtered: null,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function label(tooltipItems, data) {
              var sum = data.datasets[0].data.reduce(function (a, b) {
                return a + b;
              }, 0);
              return Math.round(data.datasets[0].data[tooltipItems.index] / sum * 10000) / 100 + ' %';
            },
            title: function title(tooltipItems, data) {
              return data.labels[tooltipItems[0].index] + ': ' + self.$format.fileSize(data.datasets[0].data[tooltipItems[0].index]);
            }
          },
          titleFontColor: '#fff',
          bodyFontColor: '#fff',
          footerFontColor: '#fff'
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    if (this.$auth.hasRole('GROUP_ADMIN')) {
      __WEBPACK_IMPORTED_MODULE_3__models_CompanyGroup__["a" /* default */].getList({
        size: 99999,
        include: ['companies']
      }).then(function (result) {
        // We need to do some postprocessing
        result.items.forEach(function (item) {
          // This needs to be done to allow watching for changes
          item.checked = true;
          item.showChildren = false;

          // This makes displaying stuff easier
          item.total = item.companies.reduce(function (sum, item) {
            return sum + item.quota;
          }, 0);
          item.used = item.companies.reduce(function (sum, item) {
            return sum + (item.enabled ? item.recordingsSize : 0);
          }, 0);
          item.inactive = item.companies.reduce(function (sum, item) {
            return sum + (item.enabled ? 0 : item.recordingsSize);
          }, 0);

          // This needs to be done to allow watching for changes
          item.companies.forEach(function (company) {
            company.checked = true;
          });
        });

        // Now save groups (triggers computed props)
        _this.groups = result.items;
      });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__models_Company__["a" /* default */].getList({
        size: 999999
      }).then(function (result) {
        _this.groups = [{
          checked: true,
          companies: result.items.map(function (item) {
            item.checked = true;
            return item;
          })
        }];
      });
    }
  },

  watch: {
    filter: function filter() {
      this.filtered = this.getFiltered();
    },
    groups: function groups() {
      this.filtered = this.getFiltered();
    }
  },
  computed: {
    data: function data() {
      // No data? Nothing to display
      if (!this.filtered || this.filtered.length <= 0) {
        return {
          datasets: [],
          labels: []
        };
      }

      // Only use checked items
      var checked = this.filtered.map(function (group) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, group);
      }).filter(function (group) {
        group.filtered = group.filtered.filter(function (company) {
          return company.checked;
        });
        return group.checked;
      });

      // Compute summary fields
      var used = checked.reduce(function (sum, group) {
        return sum + group.filtered.reduce(function (sum, item) {
          return sum + (item.enabled ? item.recordingsSize : 0);
        }, 0);
      }, 0);
      var total = checked.reduce(function (sum, group) {
        return sum + group.filtered.reduce(function (sum, item) {
          return sum + item.quota;
        }, 0);
      }, 0);
      var inactive = checked.reduce(function (sum, group) {
        return sum + group.filtered.reduce(function (sum, item) {
          return sum + (!item.enabled ? item.recordingsSize : 0);
        }, 0);
      }, 0);

      // Different roles see different things
      if (this.$auth.hasRole('COMPANY_ADMIN')) {
        return {
          datasets: [{
            backgroundColor: ['#E46651', '#41B883'],
            data: [used + inactive, Math.max(0, total - (used + inactive))]
          }],
          labels: [this.$t('space.used'), this.$t('space.free')]
        };
      }

      return {
        datasets: [{
          backgroundColor: ['#E46651', '#EEEEEE', '#41B883'],
          data: [used, inactive, Math.max(0, total - (used + inactive))]
        }],
        labels: [this.$t('space.used'), this.$t('space.inactive'), this.$t('space.free')]
      };
    }
  },
  methods: {
    /**
     * Computes filtered array, must be done by hand because reference issues
     * would destroy the checkboxes.
     * @return {object[]}
     */
    getFiltered: function getFiltered() {
      var _this2 = this;

      return this.groups.filter(function (group) {
        group.filtered = group.companies.filter(function (company) {
          return !_this2.filter || _this2.filterMatch(company.name, _this2.filter);
        });
        if (_this2.filter) {
          group.showChildren = true;
        }
        return group.filtered.length > 0;
      });
    },


    /**
     * Returns if input string matches filter
     * @param {string} input
     * @param {string} filter
     * @return {boolean}
     */
    filterMatch: function filterMatch(input, filter) {
      return input.toLowerCase().indexOf(filter.toLowerCase()) >= 0;
    },


    /**
     * Updates selected items to only show specified items
     * @param {object} showGroup group to be shown
     * @param {object?} showCompany company to be shown, if null whole group will be shown
     */
    showOnly: function showOnly(showGroup, showCompany) {
      if (!showCompany) {
        this.groups.forEach(function (group) {
          group.checked = group.id === showGroup.id;
          group.companies.forEach(function (company) {
            company.checked = group.id === showGroup.id;
          });
        });
      } else {
        this.groups.forEach(function (group) {
          group.checked = group.id === showGroup.id;
          group.companies.forEach(function (company) {
            company.checked = company.id === showCompany.id;
          });
        });
      }
    }
  },
  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_1__components_PieChart___default.a,
    TargetsReport: __WEBPACK_IMPORTED_MODULE_4__LogicStorageReport_TargetsReport___default.a
  }
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_TargetsReport__ = __webpack_require__(464);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      companies: null
    };
  },
  created: function created() {
    var _this = this;

    var isCompanyAdmin = this.$auth.hasRole('COMPANY_ADMIN');
    var opts = void 0;

    // @TODO: This is hotfix, should be removed after backend gets fixed
    if (isCompanyAdmin) {
      opts = { companyIds: [this.$auth.getUser().company.id] };
    } else {
      opts = { companyIds: [] };

      this.$auth.getUser().companyGroups.forEach(function (group) {
        group.companies.forEach(function (company) {
          opts.companyIds.push(company.id);
        });
      });
    }

    __WEBPACK_IMPORTED_MODULE_1__models_TargetsReport__["a" /* default */].getList(opts).then(function (result) {
      var companyMap = result.reduce(function (companies, item) {
        item.companyRecordingReports.forEach(function (report) {
          if (!companies[report.company.id]) {
            companies[report.company.id] = {
              company: report.company,
              items: [],
              showChildren: isCompanyAdmin
            };
          }

          companies[report.company.id].items.push({
            year: item.year,
            month: item.month,
            targetUsage: report.usages
          });
        });

        return companies;
      }, {});

      _this.companies = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(companyMap).map(function (key) {
        return companyMap[key];
      }).sort(function (a, b) {
        return a.company.name.localeCompare(b.company.name);
      });
    });
  }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_CompanyNotification__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Company__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    small: Boolean
  },
  data: function data() {
    return {
      textValues: {
        AUTOMATIC_TARGET: 'companyNotifications.automaticTarget',
        QUOTA_USAGE: 'companyNotifications.quotaUsage'
      },
      model: __WEBPACK_IMPORTED_MODULE_1__models_CompanyNotification__["a" /* default */],
      fields: {
        date: {
          label: this.$t('headers.date'),
          type: 'date'
        },
        company: {
          label: this.$t('headers.company'),
          roles: ['SUPER_ADMIN', 'COMPANY_ADMIN'],
          type: 'reference',
          model: __WEBPACK_IMPORTED_MODULE_2__models_Company__["a" /* default */]
        },
        severity: {
          label: this.$t('headers.severity'),
          type: 'enum',
          values: __WEBPACK_IMPORTED_MODULE_1__models_CompanyNotification__["a" /* default */].enums.severity
        },
        type: {
          label: this.$t('headers.type'),
          type: 'enum',
          values: __WEBPACK_IMPORTED_MODULE_1__models_CompanyNotification__["a" /* default */].enums.type
        },
        text: {
          label: this.$t('headers.text')
        }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PieChart__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_PieChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_PieChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_FileSystem__ = __webpack_require__(106);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var self = this;
    return {
      systems: [],
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function label(tooltipItems, data) {
              var sum = data.datasets[0].data.reduce(function (a, b) {
                return a + b;
              }, 0);
              return Math.round(data.datasets[0].data[tooltipItems.index] / sum * 10000) / 100 + ' %';
            },
            title: function title(tooltipItems, data) {
              return data.labels[tooltipItems[0].index] + ': ' + self.$format.fileSize(data.datasets[0].data[tooltipItems[0].index]);
            }
          },
          titleFontColor: '#fff',
          bodyFontColor: '#fff',
          footerFontColor: '#fff'
        }
      }
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__models_FileSystem__["a" /* default */].getList().then(function (systems) {
      _this.systems = systems.map(function (item) {
        return {
          title: item.name,
          datasets: [{
            backgroundColor: ['#E46651', '#41B883'],
            data: [item.totalSpace - item.usableSpace, item.usableSpace]
          }],
          labels: [_this.$t('space.used'), _this.$t('space.free')]
        };
      });
    });
  },

  components: {
    PieChart: __WEBPACK_IMPORTED_MODULE_0__components_PieChart___default.a
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Tag__ = __webpack_require__(143);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    record: Object
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__models_Tag__["a" /* default */].getList().then(function (result) {
      _this.items = result.items;
    });
  },
  data: function data() {
    return {
      shown: false,
      items: [],
      indexes: [],
      name: '',
      isBusy: false
    };
  },

  watch: {
    record: function record() {
      var _this2 = this;

      this.indexes = this.record.tags.map(function (selected) {
        return _this2.items.findIndex(function (item) {
          return item._self === selected._self;
        });
      });
    }
  },
  methods: {
    show: function show() {
      this.name = '';
      this.shown = true;
    },
    save: function save() {
      var _this3 = this;

      this.$emit('save', this.indexes.map(function (index) {
        return _this3.items[index];
      }), this.record);
      this.shown = false;
    },
    add: function add() {
      var _this4 = this;

      if (this.name.length > 0) {
        this.isBusy = true;

        __WEBPACK_IMPORTED_MODULE_0__models_Tag__["a" /* default */].create({
          tagName: this.name
        }).then(function (result) {
          _this4.items.push(result);
          _this4.indexes.push(_this4.items.length - 1);
          _this4.name = '';
          _this4.isBusy = false;
        }).catch(function (error) {
          console.error(error);
          alert(_this4.$t('savingFailed'));
          _this4.isBusy = false;
        });
      }
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['value'],
  watch: {
    value: function value() {
      this.updating = true;
      this.selected = [];
      if (typeof this.value === 'string') {
        for (var i = 0; i < this.value.length; i++) {
          if (this.value.charAt(i) === 'Y') {
            this.selected.push(i);
          }
        }
      }
      this.updating = false;
    },
    selected: function selected() {
      var _this = this;

      if (this.updating) return;

      var value = this.days.reduce(function (value, day, index) {
        if (_this.selected.indexOf(index) >= 0) return value + 'Y';
        return value + 'N';
      }, '');
      this.$emit('input', value);
    }
  },
  data: function data() {
    var selected = [];
    if (typeof this.value === 'string') {
      for (var i = 0; i < this.value.length; i++) {
        if (this.value.charAt(i) === 'Y') {
          selected.push(i);
        }
      }
    }

    return {
      updating: false,
      selected: selected,
      days: [this.$t('week.monday'), this.$t('week.tuesday'), this.$t('week.wednesday'), this.$t('week.thursday'), this.$t('week.friday'), this.$t('week.saturday'), this.$t('week.sunday')]
    };
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Company__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_CompanyGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_User__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PasswordInput__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PasswordInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_PasswordInput__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    var self = this;
    var user = this.$store.auth.user;

    var fields = {
      name: {
        label: this.$t('headers.name'),
        required: true
      },
      description: {
        label: this.$t('headers.description')
      },
      note: {
        label: this.$t('headers.note'),
        fill: true,
        multiLine: true,
        displayLength: 20
      },
      ico: {
        label: this.$t('headers.ico'),
        fill: true,
        required: true
      },
      sipId: {
        label: this.$t('headers.sipId'),
        fill: true,
        list: false
      },
      customLogo: {
        label: this.$t('headers.customLogo'),
        hint: this.$t('headers.customLogoHint'),
        fill: true,
        list: false,
        filterable: false
      },
      customCss: {
        label: this.$t('headers.customCss'),
        hint: this.$t('headers.customCssHint'),
        fill: true,
        list: false,
        filterable: false
      },
      quota: {
        label: this.$t('headers.quota'),
        list: false,
        fill: true,
        hint: this.$t('inMb'),
        required: true,
        preProcess: function preProcess(value) {
          return Math.round(value / (1024 * 1024) * 100) / 100;
        },
        postProcess: function postProcess(value) {
          return value * (1024 * 1024);
        },
        rules: [function (value) {
          return value && value < 0 ? _this.$t('errors.positiveNumbersOnly') : true;
        }]
      },
      maxChannels: {
        label: this.$t('headers.maxChannels'),
        list: false,
        fill: true,
        required: true,
        rules: [function (value) {
          return value && value < 0 ? _this.$t('errors.positiveNumbersOnly') : true;
        }]
      },
      companyGroup: {
        label: this.$t('headers.companyGroup'),
        type: 'reference',
        model: __WEBPACK_IMPORTED_MODULE_4__models_CompanyGroup__["a" /* default */],
        required: true,
        fill: true
      },
      passwordComplexity: {
        label: this.$t('headers.passwordComplexity'),
        type: 'enum',
        values: __WEBPACK_IMPORTED_MODULE_3__models_Company__["a" /* default */].enums.passwordComplexity,
        list: false,
        fill: true,
        required: true,
        default: user.company && user.company.companyGroup && user.company.companyGroup.passwordComplexity || '3',
        rules: [function (value) {
          if (this.companyGroup) {
            if (value < this.companyGroup.passwordComplexity) {
              return self.$t('errors.passwordComplexityIsLessThanCompanyGroup');
            }
          }
          return true;
        }]
      },
      passwordExpiry: {
        label: this.$t('headers.passwordExpiry'),
        type: 'number',
        list: false,
        fill: true,
        hint: this.$t('inDays'),
        default: user.company && user.company.companyGroup && user.company.companyGroup.passwordExpiry || 356,
        required: true,
        rules: [function (value) {
          if (this.companyGroup && this.companyGroup.passwordExpiry) {
            if (value > this.companyGroup.passwordExpiry) {
              return self.$t('errors.passwordExpiryIsLessThanCompanyGroup', [this.companyGroup.passwordExpiry]);
            }
          }
          return true;
        }]
      },
      recordingsSize: {
        label: this.$t('headers.recordingsSize'),
        editable: false,
        filterable: false
      },
      requireEncryption: {
        label: this.$t('headers.requireEncryption'),
        type: 'bool',
        fill: true,
        list: false
      },
      recordingsConfirmations: {
        label: this.$t('headers.recordingsConfirmations'),
        type: 'bool',
        fill: true,
        list: false
      },
      allowRecordingDeletion: {
        label: this.$t('headers.allowRecordingDeletion'),
        type: 'bool',
        fill: true,
        list: false
      },
      enabled: {
        label: this.$t('headers.enabled'),
        type: 'bool',
        default: true,
        fill: true
      },
      adminCreate: {
        label: this.$t('headers.createAdmin'),
        type: 'bool',
        createOnly: true,
        list: false,
        filterable: false,
        fill: true,
        default: true
      },
      adminSendInfo: {
        label: this.$t('headers.sendInfo'),
        type: 'bool',
        createOnly: true,
        list: false,
        filterable: false,
        fill: true,
        requires: 'adminCreate',
        default: true
      },
      adminUsername: {
        label: this.$t('headers.username'),
        createOnly: true,
        list: false,
        filterable: false,
        fill: true,
        requires: 'adminCreate',
        required: true,
        rules: [function (value) {
          return value && value.length < 3 ? _this.$t('errors.mustBeLonger', [3]) : true;
        }]
      },
      adminName: {
        label: this.$t('headers.personName'),
        createOnly: true,
        list: false,
        filterable: false,
        requires: 'adminCreate',
        rules: [function (value) {
          return value && value.length < 3 ? _this.$t('errors.mustBeLonger', [3]) : true;
        }]
      },
      adminSurname: {
        label: this.$t('headers.surname'),
        createOnly: true,
        list: false,
        filterable: false,
        requires: 'adminCreate',
        rules: [function (value) {
          return value && value.length < 3 ? _this.$t('errors.mustBeLonger', [3]) : true;
        }]
      },
      adminEmail: {
        label: this.$t('headers.email'),
        createOnly: true,
        list: false,
        filterable: false,
        requires: 'adminCreate',
        fill: true,
        required: true
      },
      adminPassword: {
        label: this.$t('headers.password'),
        type: 'custom',
        createOnly: true,
        list: false,
        filterable: false,
        requires: 'adminCreate',
        required: true,
        input: __WEBPACK_IMPORTED_MODULE_6__components_PasswordInput___default.a
      },
      adminPassword2: {
        label: this.$t('headers.passwordAgain'),
        type: 'custom',
        createOnly: true,
        list: false,
        filterable: false,
        requires: 'adminCreate',
        required: true,
        input: __WEBPACK_IMPORTED_MODULE_6__components_PasswordInput___default.a,
        otherPassword: 'adminPassword'
      }
    };

    return {
      formOrder: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(fields),
      model: __WEBPACK_IMPORTED_MODULE_3__models_Company__["a" /* default */],
      fields: fields
    };
  },

  methods: {
    atferSave: function atferSave(result, item, fields) {
      if (item.adminCreate) {
        var admin = {
          username: item.adminUsername,
          name: item.adminName,
          surname: item.adminSurname,
          email: item.adminEmail,
          role: 'COMPANY_ADMIN',
          company: result
        };
        var user = void 0;

        return __WEBPACK_IMPORTED_MODULE_5__models_User__["default"].create(admin).then(function (created) {
          user = created;
          user.password = item.adminPassword;
          return __WEBPACK_IMPORTED_MODULE_5__models_User__["default"].setPassword(user);
        }).then(function () {
          if (item.adminSendInfo) {
            return __WEBPACK_IMPORTED_MODULE_5__models_User__["default"].sendInfo(user);
          }
        });
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
    }
  },
  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_2__components_ModelCrud___default.a
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_CompanyDelegation__ = __webpack_require__(204);
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_CompanyDelegation__["a" /* default */],
      fields: {
        dateFrom: {
          label: this.$t('headers.dateFrom'),
          type: 'date',
          fill: true,
          preProcess: function preProcess(value) {
            return value && value.substr(0, value.lastIndexOf(':'));
          },
          postProcess: function postProcess(value) {
            return value && value + ':00.000Z';
          }
        },
        duration: {
          label: this.$t('headers.delegationDuration'),
          hint: this.$t('headers.delegationDurationHint'),
          fill: true
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          fill: true
        }
      }
    };
  },

  methods: {
    preSave: function preSave(item, fields) {
      item.company = this.$store.auth.user.company;
    }
  },
  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_CompanyGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Company__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_User__ = __webpack_require__(19);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_CompanyGroup__["a" /* default */],
      fields: {
        name: {
          label: this.$t('headers.name'),
          fill: true
        },
        description: {
          label: this.$t('headers.description'),
          fill: true
        },
        passwordComplexity: {
          label: this.$t('headers.passwordComplexity'),
          type: 'enum',
          values: __WEBPACK_IMPORTED_MODULE_2__models_Company__["a" /* default */].enums.passwordComplexity,
          list: false,
          fill: true,
          required: true,
          default: '3'
        },
        passwordExpiry: {
          label: this.$t('headers.passwordExpiry'),
          type: 'number',
          list: false,
          fill: true,
          hint: this.$t('inDays'),
          required: true
        },
        companies: {
          label: this.$t('headers.companies'),
          type: 'references',
          model: __WEBPACK_IMPORTED_MODULE_2__models_Company__["a" /* default */],
          fill: true,
          editable: false
        },
        users: {
          label: this.$t('headers.admins'),
          type: 'references',
          model: __WEBPACK_IMPORTED_MODULE_3__models_User__["default"],
          list: false,
          fill: true,
          display: 'username',
          filters: {
            role: '[EQ]GROUP_ADMIN'
          }
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          fill: true
        }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Configuration__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Configuration_Basic__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Configuration_Basic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Configuration_Basic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Configuration_Certificates__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Configuration_Certificates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Configuration_Certificates__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isBusy: false,
      item: {
        _self: null,
        maxAge: null,
        encrypt: 'NONE',
        compression: 'PCM',
        encryptionKey: null,
        insertIdent: false,
        certificates: []
      }
    };
  },
  created: function created() {
    var _this = this;

    this.isBusy = true;

    __WEBPACK_IMPORTED_MODULE_0__models_Configuration__["a" /* default */].getCurrent(this.$store.auth.user).then(function (item) {
      if (item) {
        _this.item._self = item._self;
        _this.item._links = item._links;
        _this.item.maxAge = item.maxAge;
        _this.item.encrypt = item.encrypt;
        _this.item.codecType = item.codecType;
        _this.item.insertIdent = item.insertIdent;
        _this.item.certificates = item.certificates;
      }
      _this.isBusy = false;
    }).catch(function () {
      _this.isBusy = false;
    });
  },

  computed: {
    isKey: function isKey() {
      return this.item.encrypt === 'KEY';
    }
  },
  components: {
    ConfigurationBasic: __WEBPACK_IMPORTED_MODULE_1__components_Configuration_Basic___default.a,
    ConfigurationCertificates: __WEBPACK_IMPORTED_MODULE_2__components_Configuration_Certificates___default.a
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_LineGroup__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_UserCertificate__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Line__ = __webpack_require__(89);
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_LineGroup__["a" /* default */],
      fields: {
        name: {
          label: this.$t('headers.name')
        },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        targets: {
          label: this.$t('headers.targets'),
          type: 'references',
          model: __WEBPACK_IMPORTED_MODULE_3__models_Line__["a" /* default */],
          fill: true,
          formOrder: 2
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          formOrder: 1
        },
        certificates: {
          type: 'references',
          formOrder: 3,
          label: this.$t('headers.certificates'),
          list: false,
          fill: true,
          values: function values() {
            return __WEBPACK_IMPORTED_MODULE_2__models_UserCertificate__["a" /* default */].getList({
              include: ['user']
            }).then(function (result) {
              return result.items.map(function (item) {
                item.name = item.user ? item.user.name + ' ' + item.user.surname + ' - ' + item.name : '? - ' + item.name;
                return item;
              });
            });
          }
        },
        recordAlways: {
          label: this.$t('headers.recordAlways'),
          type: 'bool',
          list: false,
          fill: true,
          formOrder: 4,
          default: true
        },
        timeFrom: {
          label: this.$t('headers.recordTimeFrom'),
          type: 'datedtime',
          list: false,
          requires: {
            recordAlways: false
          },
          formOrder: 4
        },
        timeTill: {
          label: this.$t('headers.recordTimeTill'),
          type: 'datedtime',
          list: false,
          requires: {
            recordAlways: false
          },
          formOrder: 4
        },
        daysOfWeek: {
          label: this.$t('headers.recordDaysOfWeek'),
          type: 'weekdays',
          list: false,
          fill: true,
          requires: {
            recordAlways: false
          },
          formOrder: 4
        }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Line__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Company__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_LineGroup__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_UserCertificate__ = __webpack_require__(90);
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_Line__["a" /* default */],
      fields: {
        name: {
          label: this.$t('headers.name'),
          editable: ['GROUP_ADMIN'],
          fill: true
        },
        note: {
          label: this.$t('headers.note'),
          roles: ['COMPANY_ADMIN'],
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        phoneNumber: {
          label: this.$t('headers.phoneNumber'),
          editable: ['GROUP_ADMIN'],
          required: true,
          fill: true
        },
        company: {
          label: this.$t('headers.company'),
          type: 'reference',
          model: __WEBPACK_IMPORTED_MODULE_2__models_Company__["a" /* default */],
          roles: ['GROUP_ADMIN'],
          editable: ['GROUP_ADMIN'],
          required: true,
          fill: true
        },
        targetGroup: {
          label: 'Skupina',
          type: 'reference',
          model: __WEBPACK_IMPORTED_MODULE_3__models_LineGroup__["a" /* default */],
          editable: ['COMPANY_ADMIN'],
          roles: ['COMPANY_ADMIN'],
          fill: true
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          editable: ['GROUP_ADMIN'],
          default: true
        },
        dtmfDelectionAllowed: {
          label: this.$t('headers.dtmfDelectionAllowed'),
          roles: ['COMPANY_ADMIN'],
          fill: true,
          type: 'bool',
          list: false
        },
        disableRecording: {
          label: this.$t('headers.disableRecording'),
          type: 'bool',
          editable: ['COMPANY_ADMIN'],
          list: false,
          fill: true,
          default: false
        },
        certificates: {
          type: 'references',
          editable: ['COMPANY_ADMIN'],
          label: this.$t('headers.certificates'),
          list: false,
          fill: true,
          values: function values() {
            return __WEBPACK_IMPORTED_MODULE_4__models_UserCertificate__["a" /* default */].getList({
              include: ['user']
            }).then(function (result) {
              return result.items.map(function (item) {
                item.name = item.user ? item.user.name + ' ' + item.user.surname + ' - ' + item.name : '? - ' + item.name;
                return item;
              });
            });
          },
          requires: {
            disableRecording: false
          }
        },
        overrideGroup: {
          label: this.$t('headers.overrideGroup'),
          type: 'bool',
          editable: ['COMPANY_ADMIN'],
          list: false,
          fill: true,
          requires: {
            disableRecording: false
          }
        },
        recordAlways: {
          label: this.$t('headers.recordAlways'),
          editable: ['COMPANY_ADMIN'],
          type: 'bool',
          list: false,
          requires: {
            overrideGroup: true,
            disableRecording: false
          },
          fill: true,
          default: true
        },
        timeFrom: {
          label: this.$t('headers.recordTimeFrom'),
          editable: ['COMPANY_ADMIN'],
          type: 'datedtime',
          list: false,
          requires: {
            overrideGroup: true,
            recordAlways: false,
            disableRecording: false
          }
        },
        timeTill: {
          label: this.$t('headers.recordTimeTill'),
          editable: ['COMPANY_ADMIN'],
          type: 'datedtime',
          list: false,
          requires: {
            overrideGroup: true,
            recordAlways: false,
            disableRecording: false
          }
        },
        daysOfWeek: {
          label: this.$t('headers.recordDaysOfWeek'),
          type: 'weekdays',
          editable: ['COMPANY_ADMIN'],
          list: false,
          fill: true,
          requires: {
            overrideGroup: true,
            recordAlways: false,
            disableRecording: false
          }
        }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Number__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Line__ = __webpack_require__(89);
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_Number__["a" /* default */],
      fields: {
        phone: { label: this.$t('headers.phoneNumber'), fill: true },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        target: {
          label: this.$t('headers.target'),
          type: 'reference',
          model: __WEBPACK_IMPORTED_MODULE_2__models_Line__["a" /* default */],
          fill: true
        },
        recordingType: { label: this.$t('headers.recordingType'), type: 'enum', values: __WEBPACK_IMPORTED_MODULE_1__models_Number__["a" /* default */].enums.recordingType, fill: true },
        enabled: { label: this.$t('headers.enabled'), type: 'bool', default: true, fill: true }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Tag__ = __webpack_require__(143);
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var _this = this;

    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_Tag__["a" /* default */],
      fields: {
        tagName: { label: this.$t('headers.name') },
        color: { label: this.$t('headers.color'), type: 'color' },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        automaticIdent: {
          label: this.$t('headers.automaticIdent'),
          roles: ['COMPANY_ADMIN'],
          rules: [function (value) {
            return !value || /^[1234567890+*#]*$/.test(value) ? true : _this.$t('errors.invalidAutomaticIdent');
          }]
        },
        enabled: { label: this.$t('headers.enabled'), type: 'bool', default: true }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_Company__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_CompanyGroup__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordInput__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_PasswordInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_PasswordInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_Line__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_LineGroup__ = __webpack_require__(142);

//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    var roles = [];

    if (this.$auth.hasRole('SUPER_ADMIN')) {
      roles = roles.concat(['SUPER_ADMIN', 'GROUP_ADMIN']);
    }

    if (this.$auth.hasRole('GROUP_ADMIN')) {
      roles = roles.concat(['COMPANY_ADMIN']);
    }

    if (this.$auth.hasRole('COMPANY_ADMIN')) {
      roles = roles.concat(['COMPANY_ADMIN', 'COMPANY_USER']);
    }

    return {
      model: __WEBPACK_IMPORTED_MODULE_2__models_User__["default"],
      include: ['company', 'companyGroups', 'assignedTargets', 'assignedTargetGroups'],
      fetchFilters: {
        'id': '[NEQ]' + this.$store.auth.user.id,
        'role': '[IN]' + roles.join(',')
      },
      formOrder: ['username', 'note', 'name', 'surname', 'role', 'email', 'password', 'password2', 'company', 'companyGroups', 'assignedTargets', 'assignedTargetGroups', 'allowedHosts', 'enabled', 'companyAuditor', 'sendInfo', 'changePasswordAfterLogin']
    };
  },

  computed: {
    fields: function fields() {
      var self = this;
      var availableRoles = [];

      if (this.$auth.hasRole('SUPER_ADMIN')) {
        availableRoles = availableRoles.concat(['SUPER_ADMIN', 'GROUP_ADMIN']);
      }

      if (this.$auth.hasRole('GROUP_ADMIN')) {
        availableRoles = availableRoles.concat(['COMPANY_ADMIN']);
      }

      if (this.$auth.hasRole('COMPANY_ADMIN')) {
        availableRoles = availableRoles.concat(['COMPANY_ADMIN', 'COMPANY_USER']);
      }

      var roleEnum = availableRoles.reduce(function (roles, role) {
        roles[role] = __WEBPACK_IMPORTED_MODULE_2__models_User__["default"].enums.role[role];
        return roles;
      }, {});

      var fields = {
        username: {
          label: this.$t('headers.username'),
          required: true,
          rules: [function (value) {
            var _this = this;

            return self.$refs.crud.items.find(function (item) {
              return item.username === value && item._self !== _this._self;
            }) ? 'Musí být unikátní' : true;
          }],
          fill: true
        },
        note: {
          label: this.$t('headers.note'),
          fill: true,
          multiLine: true,
          displayLength: 20
        },
        name: { label: this.$t('headers.personName'), formOrder: 1, required: true },
        surname: { label: this.$t('headers.surname'), formOrder: 2, required: true },
        email: { label: this.$t('headers.email'), formOrder: 4, required: true, fill: true },
        role: {
          label: 'Role',
          type: 'enum',
          values: roleEnum,
          default: this.$auth.hasRole('GROUP_ADMIN') ? 'COMPANY_ADMIN' : null,
          roles: ['SUPER_ADMIN', 'GROUP_ADMIN', 'COMPANY_ADMIN'],
          fill: true,
          required: true
        },
        companyGroups: {
          label: this.$t('headers.companyGroups'),
          type: 'references',
          model: __WEBPACK_IMPORTED_MODULE_4__models_CompanyGroup__["a" /* default */],
          roles: ['SUPER_ADMIN'],
          requires: {
            role: 'GROUP_ADMIN'
          },
          required: true,
          fill: true
        },
        company: {
          label: this.$t('headers.company'),
          type: 'reference',
          model: __WEBPACK_IMPORTED_MODULE_3__models_Company__["a" /* default */],
          roles: ['GROUP_ADMIN'],
          requires: 'role',
          requiresValue: 'COMPANY_ADMIN',
          required: true,
          fill: true
        },
        password: {
          label: this.$t('headers.password'),
          type: 'custom',
          input: __WEBPACK_IMPORTED_MODULE_5__components_PasswordInput___default.a,
          list: false,
          filterable: false,
          required: 'create'
        },
        password2: {
          label: this.$t('headers.passwordAgain'),
          type: 'custom',
          input: __WEBPACK_IMPORTED_MODULE_5__components_PasswordInput___default.a,
          otherPassword: 'password',
          list: false,
          filterable: false,
          required: 'create'
        },
        assignedTargets: {
          label: this.$t('headers.targets'),
          roles: ['COMPANY_ADMIN'],
          type: 'references',
          model: __WEBPACK_IMPORTED_MODULE_6__models_Line__["a" /* default */],
          fill: true,
          list: false,
          requires: {
            role: 'COMPANY_USER'
          }
        },
        assignedTargetGroups: {
          label: this.$t('headers.targetGroups'),
          roles: ['COMPANY_ADMIN'],
          type: 'references',
          model: __WEBPACK_IMPORTED_MODULE_7__models_LineGroup__["a" /* default */],
          fill: true,
          list: false,
          requires: {
            role: 'COMPANY_USER'
          }
        },
        companyAuditor: {
          label: this.$t('headers.companyAuditor'),
          type: 'bool',
          list: false,
          filterable: true,
          fill: true,
          roles: ['COMPANY_ADMIN'],
          requires: {
            role: 'COMPANY_USER'
          }
        },
        sendInfo: {
          label: this.$t('headers.sendInfo'),
          type: 'bool',
          list: false,
          filterable: false,
          fill: true,
          default: true,
          createOnly: true
        },
        changePasswordAfterLogin: {
          label: this.$t('headers.changePasswordAfterLogin'),
          type: 'bool',
          list: false,
          filterable: false,
          fill: true
        },
        allowedHosts: {
          label: this.$t('headers.allowedHosts'),
          hint: this.$t('headers.allowedHostsHint'),
          type: 'text',
          multiLine: true,
          list: false,
          fill: true
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          fill: true
        }
      };

      return fields;
    }
  },
  methods: {
    atferSave: function atferSave(result, item, fields) {
      var promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve();
      if (item.password) {
        result.password = item.password;
        promise.then(function () {
          return __WEBPACK_IMPORTED_MODULE_2__models_User__["default"].setPassword(result);
        });
      }
      if (item.sendInfo) {
        result.password = item.password;
        promise.then(function () {
          return __WEBPACK_IMPORTED_MODULE_2__models_User__["default"].sendInfo(result);
        });
      }
    }
  },
  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_1__components_ModelCrud___default.a
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PublicKeyInput__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PublicKeyInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PublicKeyInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_Company__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isBusy: false,
      publicKey: null
    };
  },
  created: function created() {
    // Only allow access when needed
    if (!this.$auth.requiresKey()) {
      this.$router.push('/');
    }
  },

  methods: {
    save: function save() {
      var _this = this;

      var company = this.$store.auth.user.company;
      var configuration = company.configuration;
      if (!configuration) {
        configuration = {
          _self: null,
          maxAge: null,
          encrypt: 'KEY',
          compression: 'PCM',
          encryptionKey: null,
          insertIdent: false,
          certificates: []
        };
      }

      configuration.encrypt = 'KEY';
      configuration.encryptionKey = this.publicKey;

      this.isBusy = true;

      __WEBPACK_IMPORTED_MODULE_2__models_Company__["a" /* default */].saveConfiguration(company, configuration).then(function (result) {
        result.encryptionKeyExists = !!result.encryptionKey;
        company.configuration = result;
        _this.$router.push('/');
      }).catch(function (err) {
        _this.isBusy = false;
        alert(_this.$t('savingFailed') + err);
      });
    }
  },
  components: {
    LoginlessLayout: __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default.a,
    PublicKeyInput: __WEBPACK_IMPORTED_MODULE_1__components_PublicKeyInput___default.a
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Records__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Records___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Records__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Reports_SystemStorageReport__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Reports_SystemStorageReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Reports_SystemStorageReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reports_LogicStorageReport__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reports_LogicStorageReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reports_LogicStorageReport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Reports_Notifications__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Reports_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Reports_Notifications__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Records: __WEBPACK_IMPORTED_MODULE_0__components_Records___default.a,
    SystemStorageReport: __WEBPACK_IMPORTED_MODULE_1__components_Reports_SystemStorageReport___default.a,
    LogicStorageReport: __WEBPACK_IMPORTED_MODULE_2__components_Reports_LogicStorageReport___default.a,
    Notifications: __WEBPACK_IMPORTED_MODULE_3__components_Reports_Notifications___default.a
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_User__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['token'],
  data: function data() {
    return {
      isBusy: false,
      sent: false,
      error: null,
      username: null
    };
  },

  methods: {
    save: function save() {
      var _this = this;

      this.isBusy = true;

      __WEBPACK_IMPORTED_MODULE_1__models_User__["default"].requestReset(this.username).then(function () {
        _this.isBusy = false;
        _this.sent = true;
      }).catch(function (err) {
        console.error(err);
        _this.error = _this.$t('forgotten.failed');
        _this.isBusy = false;
      });
    }
  },
  components: {
    LoginlessLayout: __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default.a
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_User__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_local__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginlessLayout__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_LoginlessLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_LoginlessLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_default__ = __webpack_require__(144);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// @TODO: This his too hacky
var customStyle = null;

/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    logout: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      username: null,
      password: null,
      isBusy: false,
      error: null,
      language: this.$i18n.locale,
      languages: [{
        value: 'en',
        text: 'English'
      }, {
        value: 'cs',
        text: 'Česky'
      }]
    };
  },
  created: function created() {
    var _this = this;

    // Forget pass when logged out
    var stored = __WEBPACK_IMPORTED_MODULE_1__store_local__["a" /* default */].get('private');
    if (stored && stored.pass) {
      stored.pass = null;
      this.$store.player.passSaved = false;
      __WEBPACK_IMPORTED_MODULE_1__store_local__["a" /* default */].set('private', stored);
    }

    if (this.logout && this.$auth.isLogged()) {
      // Remove custom style if needed, this can fail on some browsers
      try {
        if (customStyle) {
          customStyle.parentNode.removeChild(customStyle);
          customStyle = null;
        }
      } catch (err) {
        console.error('Failed to remove custom style', err);
      }

      // Session related stuff
      this.$auth.logout().then(function () {
        _this.$router.push('/login');
      });

      return;
    }

    if (this.$store.auth.token && this.$store.auth.username) {
      this.loadUser(this.$auth.useToken(this.$store.auth.token, this.$store.auth.username));
    }
  },

  watch: {
    language: function language() {
      this.$i18n.locale = this.language;
    }
  },
  methods: {
    login: function login() {
      this.$store.auth = {
        user: null,
        oauth: null,
        username: this.username,
        password: this.password
      };

      this.isBusy = true;

      this.loadUser(this.$auth.login(this.username, this.password));
    },
    loadUser: function loadUser(promise) {
      var _this2 = this;

      this.isBusy = true;

      promise.then(function (user) {
        // Save use data to store
        _this2.$store.auth.user = user;

        // Clear saved stuff, when logged as someone else
        var stored = __WEBPACK_IMPORTED_MODULE_1__store_local__["a" /* default */].get('private');
        if (stored) {
          if (stored.username !== _this2.$store.auth.user.username) {
            _this2.$store.player.keyStored = false;
            _this2.$store.player.passStored = false;
            __WEBPACK_IMPORTED_MODULE_1__store_local__["a" /* default */].set('private', {});
          }
        }

        // Redirect to default route or previously accessed page
        if (_this2.$store.login && _this2.$store.login.redirect) {
          _this2.$router.push(_this2.$store.login.redirect);
          _this2.$store.login.redirect = null;
        } else {
          _this2.$router.push(__WEBPACK_IMPORTED_MODULE_3__router_default__["a" /* default */][_this2.$store.auth.user.role] || '/');
        }

        // Try to add custom style, this can fail on some browsers
        try {
          var company = _this2.$store.auth.user.company;
          if (company && company.customStyle) {
            customStyle = document.createElement('link');
            customStyle.rel = 'stylesheet';
            customStyle.href = company.customStyle;
            document.head.appendChild(customStyle);
          }
        } catch (e) {
          console.error('Failed to create custom style element', e);
        }

        _this2.username = null;
        _this2.password = null;

        _this2.isBusy = false;
      }).then(function () {
        return __WEBPACK_IMPORTED_MODULE_0__models_User__["default"].getPasswordComplexity();
      }).then(function (complexity) {
        _this2.$store.auth.user.passwordComplexity = complexity.passwordComplexity;
      }).catch(function (err) {
        // Credentials were rejected
        console.error(err);
        _this2.error = _this2.$t('login.badCredentialsError');
        _this2.isBusy = false;
      });
    }
  },
  components: {
    LoginlessLayout: __WEBPACK_IMPORTED_MODULE_2__components_LoginlessLayout___default.a
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PasswordForm__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PasswordForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PasswordForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_default__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(108);
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      isBusy: false,
      error: null
    };
  },
  beforeRouteEnter: function beforeRouteEnter(from, to, next) {
    if (!__WEBPACK_IMPORTED_MODULE_4__store__["b" /* default */].auth.user) {
      return next('/');
    }
    return next();
  },

  methods: {
    save: function save(password) {
      var _this = this;

      this.isBusy = true;

      __WEBPACK_IMPORTED_MODULE_2__models_User__["default"].setPassword({
        password: password
      }).then(function () {
        _this.isBusy = false;
        _this.$store.auth.password = password;
        _this.$store.auth.user.changePasswordAfterLogin = false;
        _this.$router.push(__WEBPACK_IMPORTED_MODULE_3__router_default__["a" /* default */][_this.$store.auth.user.role] || '/');
      }).catch(function (err) {
        console.error(err);
        _this.isBusy = false;
        _this.error = _this.$t('savingFailed') + '.<br />' + err;
      });
    }
  },
  components: {
    LoginlessLayout: __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default.a,
    PasswordForm: __WEBPACK_IMPORTED_MODULE_1__components_PasswordForm___default.a
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PasswordForm__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_PasswordForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_PasswordForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['token'],
  data: function data() {
    return {
      isBusy: false,
      changed: false,
      error: null,
      invalid: null,
      passwordComplexity: null
    };
  },
  created: function created() {
    var _this = this;

    this.isBusy = true;

    __WEBPACK_IMPORTED_MODULE_2__models_User__["default"].getPasswordComplexity(this.token).then(function (data) {
      _this.passwordComplexity = data.passwordComplexity;
      _this.isBusy = false;
    }).catch(function (error) {
      console.error(error);
      _this.invalid = true;
    });
  },

  methods: {
    save: function save(password) {
      var _this2 = this;

      this.isBusy = true;

      __WEBPACK_IMPORTED_MODULE_2__models_User__["default"].resetPassword(this.token, password).then(function () {
        _this2.isBusy = false;
        _this2.changed = true;
      }).catch(function (err) {
        console.error(err);
        _this2.isBusy = false;
        _this2.error = _this2.$t('savingFailed') + '.<br />' + err;
      });
    }
  },
  components: {
    LoginlessLayout: __WEBPACK_IMPORTED_MODULE_0__components_LoginlessLayout___default.a,
    PasswordForm: __WEBPACK_IMPORTED_MODULE_1__components_PasswordForm___default.a
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_User__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Profile_Common__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Profile_Common___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Profile_Common__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Profile_Password__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Profile_Password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Profile_Password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Profile_Certificates__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Profile_Certificates___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Profile_Certificates__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile_Accesses__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Profile_Accesses___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Profile_Accesses__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      item: null
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__models_User__["default"].getSelf(this.$store.auth.user.username).then(function (item) {
      _this.item = item;
    });
  },

  components: {
    ProfileCommon: __WEBPACK_IMPORTED_MODULE_1__components_Profile_Common___default.a,
    ProfilePassword: __WEBPACK_IMPORTED_MODULE_2__components_Profile_Password___default.a,
    ProfileCertificates: __WEBPACK_IMPORTED_MODULE_3__components_Profile_Certificates___default.a,
    ProfileAccesses: __WEBPACK_IMPORTED_MODULE_4__components_Profile_Accesses___default.a
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Records__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Records___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Records__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RecordingRequests__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_RecordingRequests___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_RecordingRequests__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Records: __WEBPACK_IMPORTED_MODULE_0__components_Records___default.a,
    RecordingRequests: __WEBPACK_IMPORTED_MODULE_1__components_RecordingRequests___default.a
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_Access__ = __webpack_require__(203);
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_Access__["a" /* default */],
      fields: {
        ipAddress: {
          label: this.$t('headers.ipAddress')
        },
        username: {
          label: this.$t('headers.user')
        },
        actionDate: {
          label: this.$t('headers.date'),
          type: 'date'
        },
        actionType: {
          label: this.$t('headers.actionType')
        }
      }
    };
  },

  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_ModelCrud__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_DataChange__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_User__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      model: __WEBPACK_IMPORTED_MODULE_1__models_DataChange__["a" /* default */],
      fields: {
        created: {
          label: this.$t('headers.changeDate'),
          type: 'date'
        },
        creator: {
          label: this.$t('headers.user'),
          type: 'reference',
          model: __WEBPACK_IMPORTED_MODULE_2__models_User__["default"],
          display: 'username'
        },
        tableName: {
          label: this.$t('headers.tableName'),
          values: __WEBPACK_IMPORTED_MODULE_1__models_DataChange__["a" /* default */].enums.tableName
        },
        operation: {
          label: this.$t('headers.operation'),
          type: 'enum',
          values: __WEBPACK_IMPORTED_MODULE_1__models_DataChange__["a" /* default */].enums.operation
        },
        dataBefore: {
          label: this.$t('headers.dataBefore'),
          type: 'data'
        },
        dataAfter: {
          label: this.$t('headers.dataAfter'),
          type: 'data'
        }
      }
    };
  },

  methods: {
    formatData: function formatData(data) {
      var display = data.join(', ');
      if (display.length > 50) {
        display = display.substr(0, 47) + '...';
      }
      return display;
    },
    formatDataTooltip: function formatDataTooltip(data) {
      return data.join('<br />');
    }
  },
  components: {
    ModelCrud: __WEBPACK_IMPORTED_MODULE_0__components_ModelCrud___default.a
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reports_LogicStorageReport__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reports_LogicStorageReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reports_LogicStorageReport__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    LogicStorageReport: __WEBPACK_IMPORTED_MODULE_0__components_Reports_LogicStorageReport___default.a
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reports_Notifications__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reports_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reports_Notifications__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Notifications: __WEBPACK_IMPORTED_MODULE_0__components_Reports_Notifications___default.a
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reports_SystemStorageReport__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reports_SystemStorageReport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reports_SystemStorageReport__);
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    SystemStorageReport: __WEBPACK_IMPORTED_MODULE_0__components_Reports_SystemStorageReport___default.a
  }
});

/***/ }),
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 297,
	"./af.js": 297,
	"./ar": 304,
	"./ar-dz": 298,
	"./ar-dz.js": 298,
	"./ar-kw": 299,
	"./ar-kw.js": 299,
	"./ar-ly": 300,
	"./ar-ly.js": 300,
	"./ar-ma": 301,
	"./ar-ma.js": 301,
	"./ar-sa": 302,
	"./ar-sa.js": 302,
	"./ar-tn": 303,
	"./ar-tn.js": 303,
	"./ar.js": 304,
	"./az": 305,
	"./az.js": 305,
	"./be": 306,
	"./be.js": 306,
	"./bg": 307,
	"./bg.js": 307,
	"./bm": 308,
	"./bm.js": 308,
	"./bn": 309,
	"./bn.js": 309,
	"./bo": 310,
	"./bo.js": 310,
	"./br": 311,
	"./br.js": 311,
	"./bs": 312,
	"./bs.js": 312,
	"./ca": 313,
	"./ca.js": 313,
	"./cs": 190,
	"./cs.js": 190,
	"./cv": 314,
	"./cv.js": 314,
	"./cy": 315,
	"./cy.js": 315,
	"./da": 316,
	"./da.js": 316,
	"./de": 319,
	"./de-at": 317,
	"./de-at.js": 317,
	"./de-ch": 318,
	"./de-ch.js": 318,
	"./de.js": 319,
	"./dv": 320,
	"./dv.js": 320,
	"./el": 321,
	"./el.js": 321,
	"./en-au": 322,
	"./en-au.js": 322,
	"./en-ca": 323,
	"./en-ca.js": 323,
	"./en-gb": 324,
	"./en-gb.js": 324,
	"./en-ie": 325,
	"./en-ie.js": 325,
	"./en-il": 326,
	"./en-il.js": 326,
	"./en-nz": 327,
	"./en-nz.js": 327,
	"./eo": 328,
	"./eo.js": 328,
	"./es": 331,
	"./es-do": 329,
	"./es-do.js": 329,
	"./es-us": 330,
	"./es-us.js": 330,
	"./es.js": 331,
	"./et": 332,
	"./et.js": 332,
	"./eu": 333,
	"./eu.js": 333,
	"./fa": 334,
	"./fa.js": 334,
	"./fi": 335,
	"./fi.js": 335,
	"./fo": 336,
	"./fo.js": 336,
	"./fr": 339,
	"./fr-ca": 337,
	"./fr-ca.js": 337,
	"./fr-ch": 338,
	"./fr-ch.js": 338,
	"./fr.js": 339,
	"./fy": 340,
	"./fy.js": 340,
	"./gd": 341,
	"./gd.js": 341,
	"./gl": 342,
	"./gl.js": 342,
	"./gom-latn": 343,
	"./gom-latn.js": 343,
	"./gu": 344,
	"./gu.js": 344,
	"./he": 345,
	"./he.js": 345,
	"./hi": 346,
	"./hi.js": 346,
	"./hr": 347,
	"./hr.js": 347,
	"./hu": 348,
	"./hu.js": 348,
	"./hy-am": 349,
	"./hy-am.js": 349,
	"./id": 350,
	"./id.js": 350,
	"./is": 351,
	"./is.js": 351,
	"./it": 352,
	"./it.js": 352,
	"./ja": 353,
	"./ja.js": 353,
	"./jv": 354,
	"./jv.js": 354,
	"./ka": 355,
	"./ka.js": 355,
	"./kk": 356,
	"./kk.js": 356,
	"./km": 357,
	"./km.js": 357,
	"./kn": 358,
	"./kn.js": 358,
	"./ko": 359,
	"./ko.js": 359,
	"./ky": 360,
	"./ky.js": 360,
	"./lb": 361,
	"./lb.js": 361,
	"./lo": 362,
	"./lo.js": 362,
	"./lt": 363,
	"./lt.js": 363,
	"./lv": 364,
	"./lv.js": 364,
	"./me": 365,
	"./me.js": 365,
	"./mi": 366,
	"./mi.js": 366,
	"./mk": 367,
	"./mk.js": 367,
	"./ml": 368,
	"./ml.js": 368,
	"./mn": 369,
	"./mn.js": 369,
	"./mr": 370,
	"./mr.js": 370,
	"./ms": 372,
	"./ms-my": 371,
	"./ms-my.js": 371,
	"./ms.js": 372,
	"./mt": 373,
	"./mt.js": 373,
	"./my": 374,
	"./my.js": 374,
	"./nb": 375,
	"./nb.js": 375,
	"./ne": 376,
	"./ne.js": 376,
	"./nl": 378,
	"./nl-be": 377,
	"./nl-be.js": 377,
	"./nl.js": 378,
	"./nn": 379,
	"./nn.js": 379,
	"./pa-in": 380,
	"./pa-in.js": 380,
	"./pl": 381,
	"./pl.js": 381,
	"./pt": 383,
	"./pt-br": 382,
	"./pt-br.js": 382,
	"./pt.js": 383,
	"./ro": 384,
	"./ro.js": 384,
	"./ru": 385,
	"./ru.js": 385,
	"./sd": 386,
	"./sd.js": 386,
	"./se": 387,
	"./se.js": 387,
	"./si": 388,
	"./si.js": 388,
	"./sk": 389,
	"./sk.js": 389,
	"./sl": 390,
	"./sl.js": 390,
	"./sq": 391,
	"./sq.js": 391,
	"./sr": 393,
	"./sr-cyrl": 392,
	"./sr-cyrl.js": 392,
	"./sr.js": 393,
	"./ss": 394,
	"./ss.js": 394,
	"./sv": 395,
	"./sv.js": 395,
	"./sw": 396,
	"./sw.js": 396,
	"./ta": 397,
	"./ta.js": 397,
	"./te": 398,
	"./te.js": 398,
	"./tet": 399,
	"./tet.js": 399,
	"./tg": 400,
	"./tg.js": 400,
	"./th": 401,
	"./th.js": 401,
	"./tl-ph": 402,
	"./tl-ph.js": 402,
	"./tlh": 403,
	"./tlh.js": 403,
	"./tr": 404,
	"./tr.js": 404,
	"./tzl": 405,
	"./tzl.js": 405,
	"./tzm": 407,
	"./tzm-latn": 406,
	"./tzm-latn.js": 406,
	"./tzm.js": 407,
	"./ug-cn": 408,
	"./ug-cn.js": 408,
	"./uk": 409,
	"./uk.js": 409,
	"./ur": 410,
	"./ur.js": 410,
	"./uz": 412,
	"./uz-latn": 411,
	"./uz-latn.js": 411,
	"./uz.js": 412,
	"./vi": 413,
	"./vi.js": 413,
	"./x-pseudo": 414,
	"./x-pseudo.js": 414,
	"./yo": 415,
	"./yo.js": 415,
	"./zh-cn": 416,
	"./zh-cn.js": 416,
	"./zh-hk": 417,
	"./zh-hk.js": 417,
	"./zh-tw": 418,
	"./zh-tw.js": 418
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 956;

/***/ }),
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo2.7210c04.jpg";

/***/ }),
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */
/***/ (function(module, exports) {

module.exports = {"_args":[["vue-chartjs@2.8.7","C:\\Users\\Kamen\\dev\\prace\\siprec"]],"_from":"vue-chartjs@2.8.7","_id":"vue-chartjs@2.8.7","_inBundle":false,"_integrity":"sha512-XNNCQHwP1zUe739q0h0DdObx7qC+umJ50P8N4uab4N964rHSSq7sbRAdyoevObI3K2eYuCTLhnzjA1F90uQwtQ==","_location":"/vue-chartjs","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"vue-chartjs@2.8.7","name":"vue-chartjs","escapedName":"vue-chartjs","rawSpec":"2.8.7","saveSpec":null,"fetchSpec":"2.8.7"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/vue-chartjs/-/vue-chartjs-2.8.7.tgz","_spec":"2.8.7","_where":"C:\\Users\\Kamen\\dev\\prace\\siprec","author":{"name":"Jakub Juszczak","email":"jakub@posteo.de"},"babel":{"presets":["es2015"]},"browserify":{"transform":["babelify"]},"bugs":{"url":"https://github.com/apertureless/vue-chartjs/issues"},"contributors":[{"name":"Thorsten Lünborg","url":"https://github.com/LinusBorg"},{"name":"Juan Carlos Alonso","url":"https://github.com/jcalonso"}],"dependencies":{"lodash.merge":"^4.6.0"},"description":"Vue.js wrapper for chart.js for creating beautiful charts.","devDependencies":{"babel-cli":"^6.24.1","babel-core":"^6.25.0","babel-loader":"^7.0.0","babel-plugin-transform-object-assign":"^6.22.0","babel-plugin-transform-runtime":"^6.23.0","babel-preset-es2015":"^6.24.1","babel-preset-stage-2":"^6.24.1","babel-runtime":"^6.23.0","chai":"^3.5.0","chart.js":"^2.7.0","chromedriver":"^2.28.0","connect-history-api-fallback":"^1.1.0","cross-env":"^3.2.4","cross-spawn":"^5.1.0","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-config-standard":"^10.2.1","eslint-friendly-formatter":"^2.0.7","eslint-loader":"^1.7.1","eslint-plugin-html":"^2.0.1","eslint-plugin-import":"^2.2.0","eslint-plugin-node":"^4.2.2","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eventsource-polyfill":"^0.9.6","express":"^4.15.2","extract-text-webpack-plugin":"^1.0.1","file-loader":"^0.10.1","function-bind":"^1.0.2","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.4","inject-loader":"^3.0.0","isparta-loader":"^2.0.0","jasmine-core":"^2.5.2","json-loader":"^0.5.4","karma":"^1.5.0","karma-coverage":"^1.1.1","karma-jasmine":"^1.0.2","karma-mocha":"^1.2.0","karma-phantomjs-launcher":"^1.0.4","karma-sinon-chai":"^1.2.0","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.30","karma-webpack":"1.8.1","lolex":"^1.6.0","mocha":"^3.1.0","nightwatch":"^0.9.14","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.13","selenium-server":"^3.3.1","shelljs":"^0.7.7","sinon":"^2.1.0","sinon-chai":"^2.9.0","url-loader":"^0.5.8","vue":"^2.4.4","vue-hot-reload-api":"^2.1.0","vue-html-loader":"^1.2.4","vue-loader":"^12.2.2","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.4.2","webpack":"^1.13.2","webpack-dev-middleware":"^1.10.1","webpack-hot-middleware":"^2.17.1","webpack-merge":"1.1.1"},"engines":{"node":">=6.9.0"},"files":["src","dist","es"],"greenkeeper":{"ignore":["extract-text-webpack-plugin","karma-webpack","webpack","webpack-merge"]},"homepage":"http://vue-chartjs.org","jsnext:main":"es/index.js","keywords":["ChartJs","Vue","Visualisation","Wrapper","Charts"],"license":"MIT","main":"dist/vue-chartjs.js","maintainers":[{"name":"Jakub Juszczak","email":"jakub@posteo.de","url":"http://www.jakubjuszczak.de"}],"module":"es/index.js","name":"vue-chartjs","peerDependencies":{"chart.js":"^2.7.0","vue":"^2.4.4"},"repository":{"type":"git","url":"git+ssh://git@github.com/apertureless/vue-chartjs.git"},"scripts":{"build":"yarn run release && yarn run build:es","build:es":"cross-env BABEL_ENV=es babel src --out-dir es","dev":"node build/dev-server.js","e2e":"node test/e2e/runner.js","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","prepublish":"yarn run lint && yarn run test && yarn run build","release":"webpack --progress --hide-modules --config  ./build/webpack.release.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.min.js && webpack --progress --hide-modules --config  ./build/webpack.release.full.js && NODE_ENV=production webpack --progress --hide-modules --config  ./build/webpack.release.full.min.js","test":"npm run unit","unit":"karma start test/unit/karma.conf.js --single-run"},"unpkg":"dist/vue-chartjs.full.min.js","version":"2.8.7"}

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(894)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(1098),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(890)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(1093),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(874)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(1075),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(873)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(1074),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(880)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(1083),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(479),
  /* template */
  __webpack_require__(1058),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(480),
  /* template */
  __webpack_require__(1100),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(870)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(481),
  /* template */
  __webpack_require__(1071),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(483),
  /* template */
  __webpack_require__(1099),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(863)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(485),
  /* template */
  __webpack_require__(1064),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(486),
  /* template */
  __webpack_require__(1097),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(847)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(487),
  /* template */
  __webpack_require__(1048),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(850)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(488),
  /* template */
  __webpack_require__(1051),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(877)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(491),
  /* template */
  __webpack_require__(1080),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(889)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(492),
  /* template */
  __webpack_require__(1092),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(846)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(493),
  /* template */
  __webpack_require__(1047),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(886)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(497),
  /* template */
  __webpack_require__(1089),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(887)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(498),
  /* template */
  __webpack_require__(1090),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(868)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(499),
  /* template */
  __webpack_require__(1069),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(897)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(500),
  /* template */
  __webpack_require__(1101),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(844)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(501),
  /* template */
  __webpack_require__(1045),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(872)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(502),
  /* template */
  __webpack_require__(1073),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(876)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(503),
  /* template */
  __webpack_require__(1079),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(504),
  /* template */
  __webpack_require__(1077),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(875)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(507),
  /* template */
  __webpack_require__(1078),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(862)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(510),
  /* template */
  __webpack_require__(1063),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(882)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(511),
  /* template */
  __webpack_require__(1085),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(878)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(512),
  /* template */
  __webpack_require__(1081),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(860)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(513),
  /* template */
  __webpack_require__(1061),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(893)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(514),
  /* template */
  __webpack_require__(1096),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(515),
  /* template */
  __webpack_require__(1076),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(891)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(516),
  /* template */
  __webpack_require__(1094),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(901)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(517),
  /* template */
  __webpack_require__(1105),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(899)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(518),
  /* template */
  __webpack_require__(1103),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(879)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(519),
  /* template */
  __webpack_require__(1082),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(520),
  /* template */
  __webpack_require__(1046),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(858)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(521),
  /* template */
  __webpack_require__(1059),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(883)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(522),
  /* template */
  __webpack_require__(1086),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(865)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(523),
  /* template */
  __webpack_require__(1066),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(849)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(524),
  /* template */
  __webpack_require__(1050),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(851)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(525),
  /* template */
  __webpack_require__(1052),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(892)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1095),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(853)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(527),
  /* template */
  __webpack_require__(1054),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(855)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(528),
  /* template */
  __webpack_require__(1056),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(871)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1072),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(852)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1053),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(861)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1062),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(856)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1057),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(854)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1055),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(900)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1104),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('profile.common.title')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-alert', {
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "dismissible": "",
      "transition": "fade-transition",
      "success": "",
      "value": _vm.saved
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('profile.common.saved')) + "\n    ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.personName')
    },
    model: {
      value: (_vm.value.name),
      callback: function($$v) {
        _vm.$set(_vm.value, "name", $$v)
      },
      expression: "value.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.surname')
    },
    model: {
      value: (_vm.value.surname),
      callback: function($$v) {
        _vm.$set(_vm.value, "surname", $$v)
      },
      expression: "value.surname"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.email')
    },
    model: {
      value: (_vm.value.email),
      callback: function($$v) {
        _vm.$set(_vm.value, "email", $$v)
      },
      expression: "value.email"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    ref: "crud",
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": _vm.include,
      "extended": true,
      "atferSave": _vm.atferSave,
      "fetchFilters": _vm.fetchFilters,
      "form-order": _vm.formOrder
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    ref: "select",
    attrs: {
      "item-text": "text",
      "item-value": "index",
      "items": _vm.normalizedOptions,
      "label": _vm.label,
      "required": _vm.required,
      "autocomplete": ""
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.localIndex),
      callback: function($$v) {
        _vm.localIndex = $$v
      },
      expression: "localIndex"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasKey()),
      expression: "hasKey()"
    }],
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "deep-orange--text mr-2"
  }, [_vm._v("warning")]), _vm._v(" "), (_vm.hasPass()) ? _c('span', {
    staticClass: "deep-orange--text"
  }, [_vm._v(_vm._s(_vm.$t('keyFoot.keyAndPassWarning')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('keyFoot.keyWarning')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "my-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v(_vm._s(_vm.$t('keyFoot.forget')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-alert', {
    attrs: {
      "error": "",
      "value": !!_vm.error
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]), _vm._v(" "), _c('password-input', {
    ref: "password",
    attrs: {
      "options": {},
      "label": _vm.$t('profile.password.newPassword'),
      "model": _vm.passwords,
      "min-level": _vm.complexity
    },
    model: {
      value: (_vm.passwords.updated),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "updated", $$v)
      },
      expression: "passwords.updated"
    }
  }), _vm._v(" "), _c('password-input', {
    ref: "passwordAgain",
    attrs: {
      "options": {
        otherPassword: 'updated'
      },
      "label": _vm.$t('profile.password.newPasswordAgain'),
      "model": _vm.passwords,
      "min-level": _vm.complexity
    },
    model: {
      value: (_vm.passwords.updated2),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "updated2", $$v)
      },
      expression: "passwords.updated2"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('login.title')
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.login($event)
      }
    }
  }, [_c('v-alert', {
    staticClass: "mb-3",
    attrs: {
      "error": "",
      "value": !!_vm.error,
      "transition": "scale-transition"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.languages
    },
    model: {
      value: (_vm.language),
      callback: function($$v) {
        _vm.language = $$v
      },
      expression: "language"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$t('login.username'),
      "required": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "label": _vm.$t('login.password'),
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "type": "submit",
      "flat": "",
      "loading": _vm.isBusy
    }
  }, [_vm._v(_vm._s(_vm.$t('login.login')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center mt-2"
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/forgotten-password"
    }
  }, [_vm._v(_vm._s(_vm.$t('login.forgotten')))])], 1)], 1), _vm._v(" "), _c('template', {
    slot: "media"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(978)
    }
  })])], 2)
},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.onlyHide) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }]
  }, [_vm._t("default")], 2)] : _vm._e(), _vm._v(" "), (!_vm.onlyHide) ? [(!_vm.loading) ? _vm._t("default") : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('div', {
    class: {
      'my-5': !_vm.isSmall
    }
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    staticClass: "purple--text",
    attrs: {
      "size": _vm.isSmall ? 32 : (_vm.showProgress ? 100 : 64),
      "indeterminate": !_vm.showProgress,
      "width": _vm.showProgress ? 15 : 4,
      "value": _vm.showProgress ? _vm.progress : null,
      "rotate": _vm.showProgress ? -90 : 0
    }
  }, [(_vm.showProgress) ? _c('span', [_vm._v(_vm._s(_vm.progress) + " %")]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_vm._v(_vm._s(_vm.description))])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xs-center my-5"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('pageNotFound.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('pageNotFound.pageNotFound')))])])
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "editable": false,
      "deletable": false,
      "default-order": "actionDate",
      "default-order-asc": false
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('profile.password.title')
    }
  }, [(!_vm.changed) ? [_c('v-alert', {
    attrs: {
      "error": "",
      "value": _vm.invalid
    }
  }, [_vm._v(_vm._s(_vm.$t('reset.invalidToken')))]), _vm._v(" "), (!_vm.invalid) ? _c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "only-hide": ""
    }
  }, [_c('password-form', {
    attrs: {
      "error": _vm.error,
      "complexity": _vm.passwordComplexity
    },
    on: {
      "save": _vm.save
    }
  })], 1) : _vm._e()] : [_c('v-alert', {
    attrs: {
      "success": "",
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.$t('reset.success')))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('reset.continue')))])], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('notifications')
},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadable', {
    attrs: {
      "loading": _vm.item === null,
      "description": _vm.$t('profile.loading')
    }
  }, [(_vm.item !== null) ? _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('profile-common', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('profile-password', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('profile-certificates', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('profile-accesses', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('logic-storage-report')
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [(_vm.shown) ? _c('v-card', {
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.shown = false
      },
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('v-card-title', {
    staticClass: "headline"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('crud.filters')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-card-text', {
    staticStyle: {
      "max-height": "900px"
    }
  }, _vm._l((Object.keys(_vm.fields).filter(function (field) { return _vm.fields[field].list; })), function(field) {
    return _c('v-flex', {
      key: field
    }, [(_vm.fields[field].filterable) ? _c('crud-filter', {
      attrs: {
        "options": _vm.fields[field],
        "field": field
      },
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    }) : _vm._e()], 1)
  })), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "type": "submit",
      "success": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cancel($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('crud.filter.clear')))])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('titles.companySetup')
    }
  }, [_c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "only-hide": ""
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-alert', {
    staticClass: "mb-3",
    attrs: {
      "info": "",
      "value": true
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('companySetup.description')) + "\n      ")]), _vm._v(" "), _c('public-key-input', {
    staticClass: "mb-4",
    attrs: {
      "label": _vm.$t('companySetup.publicKey'),
      "required": ""
    },
    model: {
      value: (_vm.publicKey),
      callback: function($$v) {
        _vm.publicKey = $$v
      },
      expression: "publicKey"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('crud', {
    ref: "crud",
    attrs: {
      "items": _vm.items,
      "fields": _vm.authorizedFields,
      "editable": _vm.processRoleArg(_vm.editable),
      "deletable": _vm.processRoleArg(_vm.deletable),
      "refreshable": _vm.refreshable,
      "paginating": _vm.paginating,
      "perPage": _vm.perPage,
      "filtering": _vm.filtering,
      "bulk": _vm.bulk,
      "actions": _vm.actions,
      "exportable": _vm.exportable,
      "creatable": _vm.processRoleArg(_vm.creatable),
      "form-component": _vm.formComponent,
      "form-order": _vm.formOrder,
      "total": _vm.total,
      "loading": _vm.isBusy,
      "serverside": true,
      "requestAllItems": _vm.requestAllItems,
      "form-error": _vm.formError,
      "allItemsActions": _vm.allItemsActions
    },
    on: {
      "page-changed": _vm.changePage,
      "sort-changed": _vm.changeSort,
      "save": _vm.saveItem,
      "cancel": _vm.cancelItem,
      "remove": _vm.removeItems,
      "filters-changed": _vm.changeFilters,
      "refresh": _vm.refresh
    },
    scopedSlots: _vm._u([_vm._l((Object.keys(_vm.$scopedSlots)), function(slot, index) {
      return {
        key: slot,
        fn: function(row) {
          return [_c('td', {
            key: slot
          }, [_vm._t(slot, null, {
            item: row.item,
            field: row.field,
            value: row.value
          })], 2)]
        }
      }
    })])
  })
},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "pre-save": _vm.preSave
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": ['creator'],
      "editable": false,
      "deletable": false,
      "default-order": "created",
      "default-order-asc": false
    },
    scopedSlots: _vm._u([{
      key: "creator",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: row.item.creator ? ((row.item.creator.name) + " " + (row.item.creator.surname)) : '?'
            }),
            expression: "{ content: row.item.creator ? `${row.item.creator.name} ${row.item.creator.surname}` : '?' }"
          }]
        }, [_vm._v("\n      " + _vm._s(row.item.creator ? row.item.creator.username : '?') + "\n    ")])]
      }
    }, {
      key: "dataBefore",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.formatDataTooltip(_vm.model.getDiff(row.item, 'dataBefore'))
            }),
            expression: "{ content: formatDataTooltip(model.getDiff(row.item, 'dataBefore')) }"
          }]
        }, [_vm._v("\n      " + _vm._s(_vm.formatData(_vm.model.getDiff(row.item, 'dataBefore'))) + "\n    ")])]
      }
    }, {
      key: "dataAfter",
      fn: function(row) {
        return [_c('div', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.formatDataTooltip(_vm.model.getDiff(row.item, 'dataAfter'))
            }),
            expression: "{ content: formatDataTooltip(model.getDiff(row.item, 'dataAfter')) }"
          }]
        }, [_vm._v("\n      " + _vm._s(_vm.formatData(_vm.model.getDiff(row.item, 'dataAfter'))) + "\n    ")])]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "350px",
      "scrollable": ""
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('tagger.title')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    staticClass: "tagger",
    staticStyle: {
      "height": "400px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": _vm.$t('tagger.addTag')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "loading": _vm.isBusy
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v(_vm._s(_vm.$t('tagger.add')))], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.items), function(tag, i) {
    return _c('v-checkbox', {
      key: tag.tagName,
      staticClass: "my-0 py-0",
      attrs: {
        "label": tag.tagName,
        "value": i,
        "hide-details": ""
      },
      model: {
        value: (_vm.indexes),
        callback: function($$v) {
          _vm.indexes = $$v
        },
        expression: "indexes"
      }
    })
  })], 2), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_vm._v("Zrušit")]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v("Uložit")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadable', {
    staticClass: "delegations mt-5",
    attrs: {
      "loading": _vm.isBusy,
      "size": "small"
    }
  }, [(!_vm.delegation) ? [(_vm.delegations && _vm.delegations.length > 0) ? _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t('delegations.title')))]), _vm._v(" "), _vm._l((_vm.delegations), function(delegation) {
    return _c('v-list-tile', {
      key: delegation._self,
      on: {
        "click": function($event) {
          _vm.select(delegation)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("open_in_browser")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(delegation.company.name))])], 1)], 1)
  })], 2) : _vm._e()] : [_c('v-layout', {
    staticClass: "active-delegation",
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "px-2": ""
    }
  }, [_c('v-icon', {
    staticClass: "blue--text"
  }, [_vm._v("info")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "delegation-info"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v(_vm._s(_vm.$t('delegations.delegatedAs')))]), _vm._v(" "), _c('div', {
    staticClass: "blue--text text--lighten-1"
  }, [_vm._v(_vm._s(_vm.delegation.company.name))])]), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    attrs: {
      "flat": "",
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.select(null)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1)], 1)]], 2)
},staticRenderFns: []}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "loginless-layout",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "offset-md5": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "indigo",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))])], 1), _vm._v(" "), (!!_vm.$slots['media']) ? _c('v-card-media', [_vm._t("media")], 2) : _vm._e(), _vm._v(" "), _c('v-card-text', [_vm._t("default")], 2), _vm._v(" "), (!!_vm.$slots['actions']) ? _c('v-card-actions', [_vm._t("actions")], 2) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('titles.forgottenPassword')
    }
  }, [(!_vm.sent) ? [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-alert', {
    attrs: {
      "error": "",
      "value": !!_vm.error
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.$t('forgotten.description')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "hide-details": "",
      "label": _vm.$t('headers.username'),
      "required": true
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "loading": _vm.isBusy,
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('forgotten.send')))])], 1)], 1)] : [_c('v-alert', {
    attrs: {
      "success": "",
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.$t('forgotten.success')))])]], 2)
},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "size": "small"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isBusy),
      expression: "!isBusy"
    }]
  }, [(_vm.type === 'custom' && _vm.options.input) ? _c('div', [_c(_vm.options.input, {
    ref: "input",
    tag: "component",
    attrs: {
      "v-model": _vm.value[_vm.field],
      "required": _vm.required,
      "filter": _vm.filter,
      "options": _vm.options,
      "field": _vm.field,
      "model": _vm.value,
      "label": _vm.options.label
    },
    on: {
      "input": function($event) {
        _vm.value[_vm.field] = arguments[0]
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.type || _vm.type === 'text' || _vm.type === 'number' || _vm.type === 'password' || _vm.type === 'data') ? _c('div', [_c('v-text-field', {
    ref: "input",
    attrs: {
      "size": _vm.size,
      "type": _vm.type || 'text',
      "placeholder": _vm.small ? _vm.options.label : null,
      "label": _vm.small ? null : _vm.options.label,
      "error-messages": _vm.options.errors,
      "rules": _vm.rules,
      "required": _vm.required,
      "hide-details": _vm.filter,
      "hint": _vm.options.hint,
      "persistent-hint": !!_vm.options.hint,
      "multi-line": _vm.options.multiLine
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'bool') ? _c('div', [_c('v-checkbox', {
    ref: "input",
    attrs: {
      "label": _vm.small ? null : _vm.options.label,
      "hide-details": ""
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'enum') ? _c('div', [_c('v-select', {
    ref: "input",
    attrs: {
      "size": _vm.size,
      "items": _vm.enumValues,
      "item-text": "text",
      "item-value": "key",
      "label": _vm.small ? null : _vm.options.label,
      "error-messages": _vm.options.errors,
      "rules": _vm.rules,
      "required": _vm.required,
      "hide-details": _vm.filter,
      "autocomplete": ""
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'reference' && !_vm.isBusy) ? _c('div', [_c('object-select', {
    ref: "input",
    attrs: {
      "size": _vm.size,
      "id-field": _vm.options.id || '_self',
      "name-field": _vm.options.display || 'name',
      "options": _vm.refOptions,
      "label": _vm.small ? null : _vm.options.label,
      "required": _vm.required
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'references' && !_vm.isBusy) ? _c('div', [_c('div', {
    ref: "multiContainer",
    staticClass: "input-group input-group--dirty input-group--text-field multi-input",
    class: {
      'required-error': _vm.multiEmpty && _vm.required
    }
  }, [(!_vm.small) ? _c('label', [_vm._v(_vm._s(_vm.options.label) + _vm._s(_vm.required ? '*' : ''))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('multi-list-select', {
    ref: "input",
    attrs: {
      "selected-items": _vm.value[_vm.field],
      "option-value": _vm.options.id || '_self',
      "option-text": _vm.options.display || 'name',
      "required": _vm.required,
      "list": _vm.refOptions
    },
    on: {
      "blur": _vm.blur,
      "select": _vm.onSelect
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.type === 'weekdays' && !_vm.isBusy) ? _c('div', [_c('div', {
    staticClass: "input-group py-0"
  }, [(!_vm.small) ? _c('label', [_vm._v(_vm._s(_vm.options.label))]) : _vm._e()]), _vm._v(" "), _c('weekdays', {
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'date') ? _c('div', [(_vm.filter) ? _c('date-range', {
    attrs: {
      "label": _vm.options.label
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  }) : _c('date-time', {
    attrs: {
      "label": _vm.options.label
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'datedtime') ? _c('div', [_c('v-text-field', {
    attrs: {
      "type": _vm.$browser.isIE() ? 'text' : 'time',
      "label": !_vm.small ? _vm.options.label : '',
      "placeholder": "HH:MM",
      "error-messages": _vm.options.errors,
      "rules": _vm.rules,
      "required": _vm.required
    },
    model: {
      value: (_vm.datedtime),
      callback: function($$v) {
        _vm.datedtime = $$v
      },
      expression: "datedtime"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'color') ? _c('div', [(!_vm.small) ? _c('div', {
    staticClass: "input-group py-0"
  }, [_c('label', [_vm._v(_vm._s(_vm.options.label))])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value[_vm.field]),
      expression: "value[field]"
    }],
    attrs: {
      "type": "color"
    },
    domProps: {
      "value": (_vm.value[_vm.field])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, _vm.field, $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.small) ? _c('div', {
    staticClass: "pb-4"
  }) : _vm._e()]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    class: {
      xs6: !_vm.small
    }
  }, [_c('pie-chart', {
    attrs: {
      "chart-data": _vm.data,
      "options": _vm.options,
      "width": _vm.size,
      "height": _vm.size
    }
  })], 1), _vm._v(" "), (!_vm.small && _vm.$auth.hasRole('GROUP_ADMIN')) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('logicStorageReport.displayFilters')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('loadable', {
    attrs: {
      "loading": !_vm.groups
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('search'),
      "prepend-icon": "search",
      "hide-details": ""
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "datatable table table-crud elevation-1"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "show-check"
  }, [_vm._v(_vm._s(_vm.$t('headers.show')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.totalSpace')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.takenSpace')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.disabledSpace')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _vm._l((_vm.filtered), function(group) {
    return _c('tbody', {
      key: group.id
    }, [_c('tr', [_c('td', [_c('v-checkbox', {
      staticClass: "ma-0 pa-0",
      model: {
        value: (group.checked),
        callback: function($$v) {
          _vm.$set(group, "checked", $$v)
        },
        expression: "group.checked"
      }
    })], 1), _vm._v(" "), _c('td', {
      on: {
        "click": function($event) {
          group.showChildren = !group.showChildren
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(group.showChildren ? 'expand_less' : 'expand_more'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(group.name))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(group.total)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(group.used)) + " "), _c('div', {
      staticClass: "percentage"
    }, [_vm._v(_vm._s(_vm.$format.ratio(group.used, group.total)))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(group.inactive)) + " "), _c('div', {
      staticClass: "percentage"
    }, [_vm._v(_vm._s(_vm.$format.ratio(group.inactive, group.total)))])]), _vm._v(" "), _c('td', [_c('v-btn', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: _vm.$t('logicStorageReport.showOnly')
        }),
        expression: "{ content: $t('logicStorageReport.showOnly') }"
      }],
      staticClass: "pa-0 ma-0",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.showOnly(group, null)
        }
      }
    }, [_c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)]), _vm._v(" "), _c('tr', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (group.showChildren),
        expression: "group.showChildren"
      }]
    }, [_c('td', {
      attrs: {
        "colspan": "200"
      }
    }, [_c('table', {
      staticClass: "datatable table table-crud ma-3 subtable elevation-1"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticClass: "show-check"
    }, [_vm._v(_vm._s(_vm.$t('headers.show')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.quota')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('headers.takenSpace')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((group.filtered), function(company) {
      return _c('tr', {
        key: company.id
      }, [_c('td', [_c('v-checkbox', {
        staticClass: "ma-0 pa-0",
        model: {
          value: (company.checked),
          callback: function($$v) {
            _vm.$set(company, "checked", $$v)
          },
          expression: "company.checked"
        }
      })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(company.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(company.quota || 0)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$format.fileSize(company.recordingsSize || 0)) + " "), _c('div', {
        staticClass: "percentage"
      }, [_vm._v(_vm._s(_vm.$format.ratio(company.recordingsSize, company.quota)))])]), _vm._v(" "), _c('td', [_c('v-btn', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip",
          value: ({
            content: _vm.$t('logicStorageReport.showOnly')
          }),
          expression: "{ content: $t('logicStorageReport.showOnly') }"
        }],
        staticClass: "pa-0 ma-0",
        attrs: {
          "icon": ""
        },
        on: {
          "click": function($event) {
            _vm.showOnly(group, company)
          }
        }
      }, [_c('v-icon', [_vm._v("arrow_forward")])], 1)], 1)])
    }))])])])])
  })], 2)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('targetsReport.title')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('targets-report')], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.original ? _vm.$t('profile.certForm.titleUpdate') : _vm.$t('profile.certForm.titleAdd')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', {
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        return _vm.drop($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('headers.name')
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-switch', {
    staticClass: "ml-3",
    attrs: {
      "label": _vm.$t('headers.enabled')
    },
    model: {
      value: (_vm.enabled),
      callback: function($$v) {
        _vm.enabled = $$v
      },
      expression: "enabled"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.original === null),
      expression: "original === null"
    }]
  }, [_c('v-text-field', {
    attrs: {
      "label": "Klíč",
      "multi-line": "",
      "rules": _vm.keyRules
    },
    model: {
      value: (_vm.certificate),
      callback: function($$v) {
        _vm.certificate = $$v
      },
      expression: "certificate"
    }
  }), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "loading": _vm.isBusy
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "password-meter-group"
  }, [_c('v-text-field', {
    ref: "input",
    staticClass: "mb-0 pb-0",
    attrs: {
      "type": "password",
      "label": _vm.label,
      "error-messages": _vm.errors,
      "rules": _vm.rules,
      "required": _vm.required
    },
    on: {
      "blur": _vm.blur
    },
    model: {
      value: (_vm.input),
      callback: function($$v) {
        _vm.input = $$v
      },
      expression: "input"
    }
  }), _vm._v(" "), (!_vm.options.otherPassword) ? _c('div', {
    staticClass: "password-meter"
  }, [_c('div', {
    staticClass: "password-meter-inner",
    attrs: {
      "data-score": (_vm.info && _vm.info.score) || -1
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('crud-input', {
    ref: "input",
    attrs: {
      "field": _vm.field,
      "options": _vm.options
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.$auth.isAuditor()) ? _c('records', {
    attrs: {
      "paginating": true,
      "filtering": true,
      "exportable": true,
      "bulk": true,
      "actions": true
    }
  }) : _c('recording-requests')], 1)
},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('profile.password.title')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-alert', {
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "dismissible": "",
      "transition": "fade-transition",
      "success": "",
      "value": _vm.saved
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('profile.password.saved')) + "\n    ")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('profile.password.originalPassword'),
      "type": "password",
      "rules": [_vm.rules.original]
    },
    model: {
      value: (_vm.original),
      callback: function($$v) {
        _vm.original = $$v
      },
      expression: "original"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('password-input', {
    ref: "first",
    attrs: {
      "options": {},
      "label": _vm.$t('profile.password.newPassword'),
      "model": _vm.passwords
    },
    model: {
      value: (_vm.passwords.updated),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "updated", $$v)
      },
      expression: "passwords.updated"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('password-input', {
    ref: "second",
    attrs: {
      "options": {
        otherPassword: 'updated'
      },
      "label": _vm.$t('profile.password.newPasswordAgain'),
      "model": _vm.passwords
    },
    model: {
      value: (_vm.passwords.updated2),
      callback: function($$v) {
        _vm.$set(_vm.passwords, "updated2", $$v)
      },
      expression: "passwords.updated2"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [(!_vm.form) ? _c('div', {
    staticClass: "mb-2"
  }, [(_vm.editable && _vm.creatable) ? _c('v-btn', {
    staticClass: "pink white--text",
    on: {
      "click": _vm.add
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("add")]), _vm._v("\n      " + _vm._s(_vm.$t('crud.add')) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.serverside && _vm.refreshable) ? _c('v-btn', {
    staticClass: "blue darken-1 white--text button-refresh",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.refresh
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("refresh")])], 1) : _vm._e(), _vm._v(" "), (_vm.exportable) ? _c('v-btn', {
    staticClass: "blue darken-1 white--text",
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.exportCsv
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("save")]), _vm._v("\n      " + _vm._s(_vm.$t('crud.csv')) + "\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.filtering) ? _c('v-btn', {
    class: {
      blue: true, 'darken-1': true, 'white--text': true, 'button-active-filter': _vm.isAnyFilterActive()
    },
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showFilters($event)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("filter")]), _vm._v("\n      " + _vm._s(_vm.$t('crud.filters')) + "\n    ")], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.form) ? _c('div', {
    staticClass: "table__overflow elevation-1"
  }, [_c('table', {
    staticClass: "datatable table table-crud"
  }, [_c('thead', [_c('tr', [(_vm.isBulkEnabled) ? _c('th', {
    staticClass: "check column"
  }, [_c('input', {
    ref: "checkAll",
    attrs: {
      "type": "checkbox"
    },
    on: {
      "change": _vm.checkAll
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fieldKeys), function(field) {
    return (_vm.nFields[field].list) ? _c('th', {
      key: field,
      class: {
        sortable: _vm.nFields[field].sortable,
          column: true,
          'text-xs-center': _vm.nFields[field].type === 'bool',
          'text-xs-left': _vm.nFields[field].type !== 'bool',
      },
      on: {
        "click": function($event) {
          _vm.sort(field)
        }
      }
    }, [(_vm.isActiveFilter(field)) ? _c('v-icon', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: _vm.filterTooltip(field)
        }),
        expression: "{ content: filterTooltip(field) }"
      }],
      staticClass: "filter mr-1",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.showFilters($event)
        }
      }
    }, [_vm._v("filter_none")]) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.nFields[field].label) + "\n            "), _c('v-icon', {
      class: {
        sorted: _vm.sortBy === field
      }
    }, [_vm._v(_vm._s(_vm.sortAsc && _vm.sortBy === field ? 'arrow_downward' : 'arrow_upward'))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.itemActions.length > 0 || _vm.editable || _vm.deletable) ? _c('th', {
    staticClass: "actions"
  }) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', [_c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_c('loadable', {
    attrs: {
      "loading": true,
      "description": _vm.$t('loadingItems')
    }
  })], 1)]), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading && _vm.items && _vm.items.length == 0),
      expression: "!loading && items && items.length == 0"
    }],
    staticClass: "no-items"
  }, [_c('td', {
    attrs: {
      "colspan": "100"
    }
  }, [_vm._v(_vm._s(_vm.$t('noItems')))])]), _vm._v(" "), (!_vm.loading) ? _vm._l((_vm.paginated), function(item, index) {
    return _c('tr', {
      key: item.id,
      staticClass: "column"
    }, [(_vm.isBulkEnabled) ? _c('td', {
      staticClass: "check"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checked[item._self]),
        expression: "checked[item._self]"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(_vm.checked[item._self]) ? _vm._i(_vm.checked[item._self], null) > -1 : (_vm.checked[item._self])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.checked[item._self],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.checked, item._self, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.checked, item._self, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.checked, item._self, $$c)
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.fieldKeys), function(field) {
      return (_vm.nFields[field].list) ? [_vm._t(field, [_c('crud-field', {
        key: ((item.id) + "-" + field),
        ref: "crudField",
        refInFor: true,
        attrs: {
          "field": field,
          "options": _vm.nFields[field],
          "editable": _vm.editable
        },
        on: {
          "save": _vm.save,
          "edited": _vm.edited
        },
        model: {
          value: (_vm.paginated[index]),
          callback: function($$v) {
            _vm.$set(_vm.paginated, index, $$v)
          },
          expression: "paginated[index]"
        }
      })], {
        item: item,
        field: field,
        value: item[field]
      })] : _vm._e()
    }), _vm._v(" "), (_vm.itemActions.length > 0 || _vm.editable || _vm.deletable) ? _c('td', {
      staticClass: "text-xs-right actions"
    }, [_c('div', {
      staticClass: "actions"
    }, [_vm._l((_vm.itemActions), function(action, index) {
      return (action.visibility(item)) ? _c('v-btn', {
        key: index,
        staticClass: "ma-0",
        attrs: {
          "icon": action.icon && !action.label,
          "flat": "",
          "variant": item.variant
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            action.click(item)
          }
        }
      }, [(action.icon) ? _c('v-icon', [_vm._v(_vm._s(action.icon))]) : _vm._e(), _vm._v(" "), (action.label) ? _c('span', [_vm._v(_vm._s(action.label))]) : _vm._e()], 1) : _vm._e()
    }), _vm._v(" "), (_vm.editable) ? _c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": "",
        "title": _vm.$t('crud.edit')
      },
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.deletable) ? _c('v-btn', {
      staticClass: "ma-0",
      attrs: {
        "icon": "",
        "title": _vm.$t('crud.delete')
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()], 2)]) : _vm._e()], 2)
  }) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (!_vm.form && (_vm.bulk || _vm.paginating)) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', [_vm._l(((_vm.bulk && _vm.selectedItems.length > 0 ? _vm.bulkActions : [])), function(action, index) {
    return _c('v-btn', {
      key: index,
      attrs: {
        "error": action.color === 'error'
      },
      on: {
        "click": function($event) {
          _vm.actionOnSelected(action)
        }
      }
    }, [(action.icon) ? _c('v-icon', {
      attrs: {
        "left": "",
        "dark": action.color === 'error'
      }
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(action.multiLabel || action.label))])], 1)
  }), _vm._v(" "), (_vm.deletable && _vm.bulk && _vm.selectedItems.length > 0) ? _c('v-btn', {
    attrs: {
      "error": "",
      "size": "sm"
    },
    on: {
      "click": _vm.deleteSelected
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("delete")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('crud.deleteSelected')))])], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.allItemsActions), function(action, index) {
    return _c('v-btn', {
      key: ("allItems_" + index),
      attrs: {
        "error": action.color === 'error'
      },
      on: {
        "click": function($event) {
          _vm.allItemsActionSelected(action)
        }
      }
    }, [(action.icon) ? _c('v-icon', {
      attrs: {
        "left": "",
        "dark": action.color === 'error'
      }
    }, [_vm._v(_vm._s(action.icon))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(action.multiLabel || action.label))])], 1)
  })], 2)]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs6": ""
    }
  }, [(!_vm.serverside || _vm.total) ? _c('div', [(_vm.paginating) ? _c('v-pagination', {
    staticClass: "mt-2",
    attrs: {
      "length": Math.ceil(_vm.totalItems / _vm.perPage),
      "total-visible": "3"
    },
    model: {
      value: (_vm.page),
      callback: function($$v) {
        _vm.page = $$v
      },
      expression: "page"
    }
  }) : _vm._e()], 1) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), _c('crud-filter-dialog', {
    ref: "filterDialog",
    attrs: {
      "fields": _vm.nFields
    },
    on: {
      "saved": function($event) {
        _vm.saveFilters()
      },
      "cancel": function($event) {
        _vm.clearFilters()
      }
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  }), _vm._v(" "), (_vm.form && _vm.formComponent) ? _c(_vm.formComponent, {
    tag: "component",
    attrs: {
      "v-model": _vm.form,
      "fields": _vm.fields,
      "form-order": _vm.formOrder
    },
    on: {
      "save": _vm.formSave,
      "cancel": _vm.formCancel
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form && !_vm.formComponent) ? _c('crud-form', {
    ref: "form",
    attrs: {
      "fields": _vm.nFields,
      "form-order": _vm.formOrder,
      "error": _vm.formError
    },
    on: {
      "save": _vm.formSave,
      "cancel": _vm.formCancel
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v("Povolené klíče uživatelů")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "500px",
      "scrollable": ""
    },
    model: {
      value: (_vm.addShown),
      callback: function($$v) {
        _vm.addShown = $$v
      },
      expression: "addShown"
    }
  }, [_c('v-card', [_c('v-toolbar', [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('configuration.certs.addKey.title')))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-select', {
    attrs: {
      "items": _vm.items,
      "item-text": "name",
      "item-value": "_self",
      "label": _vm.$t('configuration.certs.addKey.certificate'),
      "autocomplete": ""
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.addShown = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat",
      "loading": _vm.isBusy
    },
    nativeOn: {
      "click": function($event) {
        return _vm.save($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])], 1)], 1)], 1), _vm._v(" "), _c('v-list', _vm._l((_vm.value.certificates), function(item) {
    return _c('v-list-tile', {
      key: item._self || item.name
    }, [_c('v-list-tile-content', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1)
  })), _vm._v(" "), (!_vm.value.certificates || _vm.value.certificates.length === 0) ? _c('div', {
    staticClass: "text-xs-center my-5"
  }, [_vm._v(_vm._s(_vm.$t('configuration.certs.noCerts')))]) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "description": "Načítání nastavení"
    }
  }, [_c('v-container', {
    attrs: {
      "fluild": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('configuration-basic', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1), _vm._v(" "), (_vm.isKey && _vm.item._self) ? _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('configuration-certificates', {
    model: {
      value: (_vm.item),
      callback: function($$v) {
        _vm.item = $$v
      },
      expression: "item"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "editable": false,
      "deletable": false,
      "include": ['recording', 'user'],
      "fetchFilters": {
        approved: 'false'
      }
    },
    scopedSlots: _vm._u([{
      key: "_src",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(row.item.recording.source) + "\n  ")]
      }
    }, {
      key: "_dst",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(row.item.recording.destination) + "\n  ")]
      }
    }, {
      key: "_actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "text-xs-right no-wrap"
        }, [_c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('audit.approve')
            }),
            expression: "{ content: $t('audit.approve') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.approve(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('audit.deny')
            }),
            expression: "{ content: $t('audit.deny') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.deny(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("clear")])], 1)], 1)]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.companies), function(record) {
    return _c('div', {
      key: record.company.id
    }, [(!_vm.$auth.hasRole('COMPANY_ADMIN')) ? _c('div', {
      staticClass: "target-report-company",
      on: {
        "click": function($event) {
          record.showChildren = !record.showChildren
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(record.showChildren ? 'expand_less' : 'expand_more'))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(record.company.name))])], 1) : _vm._e(), _vm._v(" "), _c('table', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (record.showChildren),
        expression: "record.showChildren"
      }],
      staticClass: "datatable table table-crud elevation-1"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('targetsReport.period')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('targetsReport.defined')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('targetsReport.used')))])])]), _vm._v(" "), _c('tbody', _vm._l((record.items), function(item) {
      return _c('tr', {
        key: ((item.year) + "/" + (item.month))
      }, [_c('td', [_vm._v(_vm._s(((item.year) + "/" + (item.month))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(record.company.targets.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.targetUsage.length))])])
    }))])])
  }))
},staticRenderFns: []}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        return _vm.drop($event)
      }
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "multi-line": "",
      "rules": _vm.rules,
      "required": _vm.required
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('input', {
    ref: "file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    key: _vm.updateIndex,
    staticClass: "pt-0",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.items), function(item, i) {
    return [(item.divider) ? _c('v-divider', {
      key: i,
      class: item.className
    }) : _vm._e(), _vm._v(" "), (item.items && (!item.roles || _vm.$auth.hasRole(item.roles))) ? [_c('v-subheader', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.items), function(subItem) {
      return _c('navigation-item', {
        key: subItem.title,
        attrs: {
          "item": subItem
        }
      })
    })] : _vm._e(), _vm._v(" "), (!item.divider && !item.items) ? _c('navigation-item', {
      key: i,
      attrs: {
        "item": item
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": ['companyGroup'],
      "atferSave": _vm.atferSave,
      "form-order": _vm.formOrder
    },
    scopedSlots: _vm._u([{
      key: "recordingsSize",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(_vm.$format.ratio(row.item.recordingsSize, row.item.quota * (1024 * 1024))) + "\n  ")]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": []
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    class: {
      'crud-field': true, 'saved': _vm.displaySaved
    }
  }, [(!_vm.editing) ? _c('div', {
    on: {
      "click": _vm.edit
    }
  }, [(!_vm.options.type || _vm.options.type === 'text' || _vm.options.type === 'number') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.textDisplay) + " " + _vm._s(_vm.value[_vm.field] !== undefined && _vm.value[_vm.field] !== null && _vm.value[_vm.field] !== '' ? _vm.options.unit : '') + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'bool') ? _c('span', [_c('v-checkbox', {
    staticClass: "pa-0",
    attrs: {
      "disabled": !_vm.editable || !_vm.options.editable
    },
    on: {
      "change": _vm.boolChange
    },
    model: {
      value: (_vm.value[_vm.field]),
      callback: function($$v) {
        _vm.$set(_vm.value, _vm.field, $$v)
      },
      expression: "value[field]"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.options.type === 'color') ? _c('span', [(_vm.value[_vm.field]) ? _c('div', {
    staticClass: "color-rect",
    style: (("background-color: " + (_vm.value[_vm.field])))
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'interval') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.value[_vm.field] && _vm.formatInterval(_vm.value[_vm.field])) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'date') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.value[_vm.field] && _vm.formatDate(_vm.value[_vm.field])) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'enum') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.options.values[_vm.value[_vm.field]] || _vm.value[_vm.field]) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'reference') ? _c('span', [_vm._v("\n      " + _vm._s(_vm.value[_vm.field] && _vm.value[_vm.field][_vm.options.display || 'name']) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'references') ? _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: _vm.formatReferencesTooltip(_vm.references)
      }),
      expression: "{ content: formatReferencesTooltip(references) }"
    }]
  }, [_vm._v("\n       " + _vm._s(_vm.formatReferences(_vm.references)) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.options.type === 'data') ? _c('span', _vm._l((_vm.dataChange), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(item))])
  })) : _vm._e()]) : _c('div', [_c('form', {
    staticClass: "sm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveField($event)
      }
    }
  }, [_c('crud-input', {
    ref: "field",
    attrs: {
      "field": _vm.field,
      "options": _vm.options,
      "focus": true,
      "size": "sm"
    },
    on: {
      "save": _vm.save
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "field-actions elevation-1"
  }, [_c('v-btn', {
    staticClass: "inaction ma-0 pa-0",
    attrs: {
      "icon": "",
      "flat": "",
      "size": "sm",
      "danger": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "inaction ma-0 pa-0",
    attrs: {
      "icon": "",
      "flat": "",
      "size": "sm",
      "success": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', [_vm._v("check")])], 1)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.systems), function(system, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "mb-2",
      attrs: {
        "xs3": ""
      }
    }, [_c('v-card', [_c('v-card-title', {
      attrs: {
        "primary": ""
      }
    }, [_vm._v(_vm._s(system.title))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('div', [_c('pie-chart', {
      attrs: {
        "chart-data": system,
        "options": _vm.options
      }
    })], 1)])], 1)], 1)
  }))
},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my-2",
    staticStyle: {
      "max-width": "700px"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.days), function(day, index) {
    return _c('v-flex', {
      key: index
    }, [_c('v-checkbox', {
      staticClass: "py-2",
      attrs: {
        "label": day,
        "value": index,
        "hide-details": ""
      },
      model: {
        value: (_vm.selected),
        callback: function($$v) {
          _vm.selected = $$v
        },
        expression: "selected"
      }
    })], 1)
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.$auth.hasRole(['COMPANY_ADMIN', 'COMPANY_USER'], true)) ? _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v("\n          " + _vm._s(_vm.$t('dashboard.lastRecordings')) + "\n        ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('records', {
    attrs: {
      "paginating": false,
      "filtering": false,
      "exportable": false,
      "perPage": 6
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "to": "/recordings",
      "ř": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('dashboard.moreRecordings')))])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.hasRole(['SUPER_ADMIN', 'COMPANY_ADMIN', 'GROUP_ADMIN'])) ? _c('v-flex', {
    staticClass: "my-2"
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('dashboard.notifications')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('notifications', {
    attrs: {
      "small": true
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.hasRole('SUPER_ADMIN')) ? _c('v-flex', {
    staticClass: "my-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('dashboard.systemStorageUsage')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('system-storage-report', {
    attrs: {
      "small": true
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$auth.hasRole(['GROUP_ADMIN', 'COMPANY_ADMIN'])) ? _c('v-flex', {
    class: {
      'my-2': true, xs3: _vm.$auth.hasRole('COMPANY_ADMIN'), xs4: _vm.$auth.hasRole('GROUP_ADMIN')
    }
  }, [_c('v-card', [_c('v-card-title', [_vm._v(_vm._s(_vm.$t('dashboard.logicStorageUsage')))]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('logic-storage-report', {
    attrs: {
      "small": true,
      "size": _vm.$auth.hasRole('GROUP_ADMIN') ? 300 : 250
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "editable": false,
      "deletable": false,
      "bulk": false,
      "paginating": !_vm.small,
      "exportable": !_vm.small,
      "filtering": !_vm.small,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "text",
      fn: function(row) {
        return [_vm._v("\n    " + _vm._s(_vm.$t(_vm.textValues[row.item.type], JSON.parse(row.item.text))) + "\n  ")]
      }
    }])
  })
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group py-0"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "type": _vm.$browser.isIE() ? 'text' : 'date',
      "placeholder": "YYYY-MM-DD",
      "hide-details": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "type": _vm.$browser.isIE() ? 'text' : 'time',
      "placeholder": "HH:MM",
      "hide-details": ""
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "400px"
    },
    model: {
      value: (_vm.shown),
      callback: function($$v) {
        _vm.shown = $$v
      },
      expression: "shown"
    }
  }, [_c('v-card', [(_vm.fatalError) ? _c('v-card-text', [_c('v-alert', {
    attrs: {
      "error": "",
      "icon": "warning",
      "value": "true"
    }
  }, [_vm._v(_vm._s(_vm.fatalError))])], 1) : [_c('v-card-title', {
    staticClass: "headline"
  }, [(_vm.recording) ? _c('span', [_vm._v(_vm._s(_vm.$t('player.title')))]) : _c('span', [(!_vm.privateKey) ? _c('span', [_vm._v(_vm._s(_vm.$t('player.titlePrivateKeySettings')))]) : _vm._e(), _vm._v(" "), (_vm.privateKey && !_vm.decoding) ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('player.titlePrivateKeyPass')))]) : _vm._e()])]), _vm._v(" "), (_vm.recording && _vm.shown) ? _c('v-card-text', {
    staticClass: "text-xs-center"
  }, [_c('audio', {
    ref: "player",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "timeupdate": _vm.timeUpdated,
      "canplay": function($event) {
        _vm.canPlay = true
      },
      "pause": function($event) {
        _vm.paused = true
      },
      "play": function($event) {
        _vm.paused = false
      }
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.recording,
      "type": _vm.audioType
    },
    on: {
      "error": _vm.playError
    }
  })]), _vm._v(" "), _c('loadable', {
    attrs: {
      "loading": !_vm.canPlay
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.paused),
      expression: "paused"
    }],
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.play
    }
  }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.paused),
      expression: "!paused"
    }],
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pause
    }
  }, [_c('v-icon', [_vm._v("pause")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.stop
    }
  }, [_c('v-icon', [_vm._v("stop")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pr-3",
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "xs4": ""
    }
  }, [_c('v-slider', {
    staticClass: "py-0",
    attrs: {
      "prepend-icon": "volume_up",
      "hide-details": "",
      "min": 0,
      "max": 100
    },
    model: {
      value: (_vm.volume),
      callback: function($$v) {
        _vm.volume = $$v
      },
      expression: "volume"
    }
  })], 1)], 1), _vm._v(" "), _c('v-slider', {
    staticClass: "px-3 py-2",
    attrs: {
      "hide-details": "",
      "value": _vm.currentTime,
      "min": 0,
      "max": 100
    },
    on: {
      "input": _vm.changeTime
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.recording && _vm.record && _vm.record.encrypted) ? _c('v-card-text', [_c('loadable', {
    attrs: {
      "loading": _vm.decoding,
      "description": _vm.$t('player.decryptingInProgress')
    }
  }, [(!_vm.privateKey) ? [_c('div', {
    on: {
      "drop": _vm.drop
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('player.privateKeyPrompt')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "multi-line": "",
      "label": _vm.$t('player.privateKey'),
      "error-messages": _vm.privateKeyErrors,
      "hide-details": ""
    },
    model: {
      value: (_vm.privateKeyForm),
      callback: function($$v) {
        _vm.privateKeyForm = $$v
      },
      expression: "privateKeyForm"
    }
  }), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "my-2",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.$t('player.saveLocally')
    },
    model: {
      value: (_vm.saveKey),
      callback: function($$v) {
        _vm.saveKey = $$v
      },
      expression: "saveKey"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.applyKey
    }
  }, [_vm._v(_vm._s(_vm.$t('player.continue')))])], 1)], 1)] : [_c('p', [_vm._v(_vm._s(_vm.$t('player.passPrompt')))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "type": "password",
      "label": _vm.$t('player.passphrase'),
      "hide-details": "",
      "error-messages": _vm.privateKeyPassErrors
    },
    model: {
      value: (_vm.privateKeyPass),
      callback: function($$v) {
        _vm.privateKeyPass = $$v
      },
      expression: "privateKeyPass"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": _vm.$t('player.saveTemporary')
    },
    model: {
      value: (_vm.saveKeyPass),
      callback: function($$v) {
        _vm.saveKeyPass = $$v
      },
      expression: "saveKeyPass"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearKey($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('player.forgetKey')))]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.applyPass
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("lock_open")]), _vm._v(" " + _vm._s(_vm.$t('player.decrypt')))], 1)], 1)]], 2)], 1) : _vm._e()], _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recording && _vm.record && _vm.record.encrypted),
      expression: "recording && record && record.encrypted"
    }],
    staticClass: "red--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearKey($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('player.forgetKey')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.recording && !_vm.fatalError),
      expression: "recording && !fatalError"
    }],
    staticClass: "green--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.download($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('player.download')))]), _vm._v(" "), _c('v-btn', {
    staticClass: "darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.shown = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('close')))])], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('profile.accesses.title')))])], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', [_c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fetchFilters": _vm.fetchFilters,
      "fields": _vm.fields,
      "filtering": false,
      "exportable": false,
      "editable": false,
      "deletable": false,
      "default-order": "actionDate",
      "default-order-asc": false,
      "perPage": 10
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('crud-input', {
    attrs: {
      "field": _vm.field,
      "options": _vm.options,
      "allow-empty": true,
      "override-type": _vm.options.type === 'reference' || _vm.options.type === 'enum' ? 'references' : _vm.options.type,
      "override-values": _vm.options.type === 'enum' ? _vm.convertEnum(_vm.options.values) : null,
      "filter": true,
      "no-rules": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authorized) ? _c('v-list-tile', {
    on: {
      "click": _vm.route
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(_vm.item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(_vm.item.title))])], 1), _vm._v(" "), (_vm.group) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v("keyboard_arrow_down")])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('configuration.basic.title')))])], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "position": "relative"
    },
    on: {
      "drop": function($event) {
        $event.stopPropagation();
        return _vm.drop($event)
      }
    }
  }, [_c('v-alert', {
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "0px",
      "width": "100%",
      "z-index": "1"
    },
    attrs: {
      "success": "",
      "transition": "fade-transition",
      "value": _vm.saved
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('configuration.basic.saved')) + "\n    ")]), _vm._v(" "), _c('loadable', {
    attrs: {
      "loading": _vm.value === null
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.$t('configuration.basic.insertIdent')
    },
    model: {
      value: (_vm.value.insertIdent),
      callback: function($$v) {
        _vm.$set(_vm.value, "insertIdent", $$v)
      },
      expression: "value.insertIdent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.$t('configuration.basic.maxAge'),
      "hint": _vm.$t('configuration.basic.maxAgeHint')
    },
    model: {
      value: (_vm.value.maxAge),
      callback: function($$v) {
        _vm.$set(_vm.value, "maxAge", $$v)
      },
      expression: "value.maxAge"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.compressionValues,
      "label": _vm.$t('configuration.basic.compression')
    },
    model: {
      value: (_vm.value.codecType),
      callback: function($$v) {
        _vm.$set(_vm.value, "codecType", $$v)
      },
      expression: "value.codecType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('configuration.basic.encrypt'),
      "items": _vm.encryptValues,
      "item-value": "value",
      "item-text": "text"
    },
    model: {
      value: (_vm.value.encrypt),
      callback: function($$v) {
        _vm.$set(_vm.value, "encrypt", $$v)
      },
      expression: "value.encrypt"
    }
  })], 1)], 1), _vm._v(" "), (_vm.isByPassword) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('configuration.basic.password'),
      "type": "password"
    },
    model: {
      value: (_vm.value.password),
      callback: function($$v) {
        _vm.$set(_vm.value, "password", $$v)
      },
      expression: "value.password"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isByKey) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('configuration.basic.publicKey'),
      "multi-line": "",
      "rules": _vm.keyRules
    },
    model: {
      value: (_vm.value.encryptionKey),
      callback: function($$v) {
        _vm.$set(_vm.value, "encryptionKey", $$v)
      },
      expression: "value.encryptionKey"
    }
  }), _vm._v(" "), _c('input', {
    ref: "file",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.fileChanged
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [(_vm.save) ? _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "success": "",
      "loading": _vm.isBusy
    },
    on: {
      "click": _vm.save
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('save')))])], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": ['targets', 'certificates']
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loginless-layout', {
    attrs: {
      "title": _vm.$t('profile.password.title')
    }
  }, [_c('loadable', {
    attrs: {
      "loading": _vm.isBusy,
      "only-hide": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "info": "",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.$t('changePasswordDescription')))]), _vm._v(" "), _c('password-form', {
    attrs: {
      "error": _vm.error
    },
    on: {
      "save": _vm.save
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": ['companies', 'users']
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": "",
      "sm6": ""
    }
  }, [_vm._t("default"), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.cancel) ? _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": ""
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('cancel')))])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.save) ? _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "success": ""
    },
    on: {
      "click": _vm.saveClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('save')))])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "example-2",
      "toolbar": "",
      "footer": ""
    }
  }, [(_vm.authorized()) ? _c('v-navigation-drawer', {
    staticStyle: {
      "z-index": "5"
    },
    attrs: {
      "fixed": "",
      "persistent": "",
      "light": "",
      "mini-variant": _vm.mini,
      "overflow": ""
    },
    on: {
      "update:miniVariant": function($event) {
        _vm.mini = $event
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": "",
      "tag": "div"
    }
  }, [_c('v-list-tile-avatar', {
    on: {
      "click": function($event) {
        _vm.$router.push('/profile')
      }
    }
  }, [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.$router.push('/profile')
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.auth.user.name) + " " + _vm._s(_vm.$store.auth.user.surname))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.mini = !_vm.mini
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.$store.auth.user.company && _vm.$store.auth.user.company.customLogo) ? _c('div', {
    staticClass: "company-logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.$store.auth.user.company.customLogo
    }
  })]) : _vm._e(), _vm._v(" "), _c('navigation', {
    ref: "navigation"
  }), _vm._v(" "), (_vm.$auth.hasRole('GROUP_ADMIN')) ? _c('delegations', {
    on: {
      "change": _vm.delegationChanged
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.authorized()) ? _c('v-toolbar', {
    staticClass: "indigo darken-4",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title()))]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('main', [_c('v-container', {
    staticStyle: {
      "padding-bottom": "45px"
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.authorized()) ? _c('v-footer', {
    staticClass: "footer elevation-5",
    attrs: {
      "fixed": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('key-foot'), _vm._v(" "), _c('v-flex', [_vm._v("Powered by Triinfo Solutions s.r.o.")])], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "required": _vm.required,
      "value": _vm.displayValue,
      "hide-details": ""
    },
    on: {
      "focus": _vm.openPicker
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.picker),
      expression: "picker"
    }],
    staticClass: "data-range-picker elevation-1",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePicker($event)
      }
    }
  }, [_c('div', {
    staticClass: "inner",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.closePicker($event)
      }
    }
  }, [_c('date-time', {
    attrs: {
      "label": _vm.$t('time.from')
    },
    model: {
      value: (_vm.from),
      callback: function($$v) {
        _vm.from = $$v
      },
      expression: "from"
    }
  }), _vm._v(" "), _c('date-time', {
    attrs: {
      "label": _vm.$t('time.to')
    },
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "type": "submit",
      "flat": "",
      "success": ""
    }
  }, [_vm._v("OK")])], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "width": "900px"
    }
  }, [_c('v-card-title', [_c('h4', [_vm._v(_vm._s(_vm.isNew ? _vm.$t('crud.newTitle') : _vm.$t('crud.editTitle')))])]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "error": "",
      "value": !!_vm.error
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.refresh) ? _c('v-card-text', _vm._l((_vm.rows), function(row) {
    return _c('v-layout', {
      key: JSON.stringify(row),
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [(Array.isArray(row)) ? _vm._l((row), function(field) {
      return _c('v-flex', {
        key: field,
        staticClass: "pr-5",
        attrs: {
          "xs6": ""
        }
      }, [_c('crud-form-field', {
        ref: ("input_" + field),
        refInFor: true,
        attrs: {
          "options": _vm.fields[field],
          "field": field
        },
        model: {
          value: (_vm.value),
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      })], 1)
    }) : [_c('v-flex', {
      staticClass: "pr-5"
    }, [_c('crud-form-field', {
      ref: ("input_" + row),
      refInFor: true,
      attrs: {
        "options": _vm.fields[row],
        "field": row
      },
      model: {
        value: (_vm.value),
        callback: function($$v) {
          _vm.value = $$v
        },
        expression: "value"
      }
    })], 1)]], 2)
  })) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "type": "submit",
      "success": "",
      "loading": _vm.isBusy
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("save")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.isNew ? _vm.$t('create') : _vm.$t('save')))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": "",
      "loading": _vm.isBusy
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("clear")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('cancel')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-toolbar', {
    staticClass: "teal white--text"
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.$t('profile.certs.title')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-list', _vm._l((_vm.value.userCertificates), function(item) {
    return _c('v-list-tile', {
      key: item._self
    }, [_c('v-list-tile-content', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "mr-3"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.edit(item)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          _vm.remove(item)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1)], 1)
  })), _vm._v(" "), (_vm.value.userCertificates.length === 0) ? _c('div', {
    staticClass: "text-xs-center my-5"
  }, [_vm._v(_vm._s(_vm.$t('profile.certs.noCerts')))]) : _vm._e(), _vm._v(" "), _c('certificate-form', {
    ref: "certForm",
    on: {
      "saved": _vm.saved
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('loadable', {
    attrs: {
      "loading": !!_vm.loading,
      "description": _vm.loading,
      "show-progress": _vm.isDownloading || _vm.isDeleting,
      "progress": _vm.isDownloading ? _vm.downloadProgress : _vm.deleteProgress,
      "only-hide": ""
    }
  }, [_c('model-crud', {
    ref: "crud",
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "actions": (_vm.bulk && _vm.actions) ? _vm.bulkActions : [],
      "allItemsActions": _vm.$auth.hasRole('COMPANY_ADMIN') && _vm.$store.auth.user.company && _vm.$store.auth.user.company.allowRecordingDeletion ? _vm.allItemsActions : [],
      "include": _vm.include,
      "extended": true,
      "paginating": _vm.paginating,
      "editable": false,
      "deletable": false,
      "exportable": _vm.exportable,
      "bulk": _vm.bulk && !_vm.recordingsConfirmations,
      "filtering": _vm.filtering,
      "default-order": "callDate",
      "default-order-asc": false,
      "perPage": _vm.perPage
    },
    scopedSlots: _vm._u([{
      key: "tags",
      fn: function(row) {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.tag(row.item)
            }
          }
        }, [_vm._l((row.item.tags), function(tag) {
          return _c('v-chip', {
            key: tag._self,
            staticClass: "light-blue darken-1 white--text mx-1 tag-chip",
            style: (tag.color ? ("background-color: " + (tag.color) + " !important; border: 0 !important;") : ''),
            attrs: {
              "label": ""
            }
          }, [_vm._v("\n          " + _vm._s(tag.tagName) + "\n        ")])
        }), _vm._v(" "), (row.item.tags.length === 0) ? _c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          }
        }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 2)]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.isPlayable(row.item)) ? _c('div', {
          staticClass: "text-xs-right no-wrap"
        }, [(row.item.encrypted) ? _c('v-icon', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.recordingIsEncrypted')
            }),
            expression: "{ content: $t('recordings.recordingIsEncrypted') }"
          }],
          staticClass: "recording-lock"
        }, [_vm._v("lock")]) : _vm._e(), _vm._v(" "), (!_vm.recordingsConfirmations) ? [_c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.play')
            }),
            expression: "{ content: $t('recordings.play') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.play(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.download')
            }),
            expression: "{ content: $t('recordings.download') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.download(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("get_app")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.downloadMetadata')
            }),
            expression: "{ content: $t('recordings.downloadMetadata') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.downloadMetadata(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("attachment")])], 1), _vm._v(" "), (_vm.$store.auth.user.company && _vm.$store.auth.user.company.allowRecordingDeletion) ? _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.delete')
            }),
            expression: "{ content: $t('recordings.delete') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.archive(row.item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()] : [_c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.requestPlay')
            }),
            expression: "{ content: $t('recordings.requestPlay') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.request(row.item, 'PLAY')
            }
          }
        }, [_c('v-icon', [_vm._v("play_arrow")])], 1), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.requestDownload')
            }),
            expression: "{ content: $t('recordings.requestDownload') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.request(row.item, 'DOWNLOAD')
            }
          }
        }, [_c('v-icon', [_vm._v("get_app")])], 1), _vm._v(" "), (_vm.$store.auth.user.company && _vm.$store.auth.user.company.allowRecordingDeletion) ? _c('v-btn', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.requestDelete')
            }),
            expression: "{ content: $t('recordings.requestDelete') }"
          }],
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              _vm.request(row.item, 'DELETE')
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1) : _vm._e()]], 2) : _vm._e(), _vm._v(" "), (!_vm.isPlayable(row.item) && !row.item.archived) ? _c('div', {
          staticClass: "text-xs-right pr-2"
        }, [_c('v-icon', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.formatReason(row.item)
            }),
            expression: "{ content: formatReason(row.item) }"
          }],
          staticClass: "recording-reason"
        }, [_vm._v("info")])], 1) : _vm._e(), _vm._v(" "), (row.item.archived) ? _c('div', {
          staticClass: "text-xs-right"
        }, [_c('v-icon', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: _vm.$t('recordings.archived')
            }),
            expression: "{ content: $t('recordings.archived') }"
          }],
          staticClass: "recording-lock"
        }, [_vm._v("cloud")])], 1) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('player', {
    ref: "player",
    attrs: {
      "record": _vm.playerRecord
    },
    on: {
      "closed": _vm.playerClosed
    }
  }), _vm._v(" "), _c('tagger', {
    ref: "tagger",
    attrs: {
      "record": _vm.taggerRecord
    },
    on: {
      "save": _vm.saveTags
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "width": "350px",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRequest),
      callback: function($$v) {
        _vm.showRequest = $$v
      },
      expression: "showRequest"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.$t('recordings.actionRequest')))]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        " + _vm._s(_vm.$t('recordings.requestQuestion')) + "\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "success": ""
    },
    on: {
      "click": _vm.doRequest
    }
  }, [_vm._v(_vm._s(_vm.$t('yes')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-0",
    attrs: {
      "error": ""
    },
    on: {
      "click": function($event) {
        _vm.showRequest = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('no')))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "include": ['target']
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('system-storage-report')
},staticRenderFns: []}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('model-crud', {
    attrs: {
      "model": _vm.model,
      "fields": _vm.fields,
      "creatable": ['GROUP_ADMIN'],
      "deletable": ['GROUP_ADMIN'],
      "include": ['company', 'targetGroup', 'certificates']
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(442);
module.exports = __webpack_require__(441);


/***/ })
],[1116]);


// WEBPACK FOOTER //
// static/js/app.d4521b34c7903345a6e7.js